{
    "specialties": {
        "allgemeinmedizin": "Allgemeinmedizin",
        "anaesthesiology": "Anästhesiologie",
        "occupationalMedicine": "Arbeitsmedizin",
        "ophthalmology": "Augenheilkunde",
        "surgery": "Chirurgie",
        "gynecology": "Frauenheilkunde und Geburtshilfe",
        "ent": "Hals-Nasen-Ohrenheilkunde",
        "dermatology": "Haut- und Geschlechtskrankheiten",
        "humanGenetics": "Humangenetik",
        "hygiene": "Hygiene und Umweltmedizin",
        "internalMedicine": "Innere Medizin",
        "pediatrics": "Kinder- und Jugendmedizin",
        "childPsychiatry": "Kinder- und Jugendpsychiatrie und -psychotherapie",
        "laboratoryMedicine": "Laboratoriumsmedizin",
        "microbiology": "Mikrobiologie, Virologie und Infektionsepidemiologie",
        "maxillofacialSurgery": "Mund-Kiefer-Gesichtschirurgie",
        "neurosurgery": "Neurochirurgie",
        "orthopedics": "Orthopädie und Unfallchirurgie",
        "neurology": "Neurologie",
        "nuclearMedicine": "Nuklearmedizin",
        "publicHealth": "Öffentliches Gesundheitswesen",
        "pathology": "Pathologie",
        "pharmacology": "Pharmakologie",
        "phoniatrics": "Phoniatrie und Pädaudiologie",
        "rehabilitationMedicine": "Physikalische und Rehabilitative Medizin",
        "physiology": "Physiologie",
        "plasticSurgery": "Plastische und Ästhetische Chirurgie",
        "psychiatry": "Psychiatrie und Psychotherapie",
        "psychosomatics": "Psychosomatische Medizin und Psychotherapie",
        "radiology": "Radiologie",
        "forensicMedicine": "Rechtsmedizin",
        "radiotherapy": "Strahlentherapie",
        "transfusionMedicine": "Transfusionsmedizin",
        "urology": "Urologie",
        "dentistry": "Zahnmedizin"
    },
    "language": {
        "title": "Sprache",
        "description": "Wählen Sie die Sprache der Anwendung aus"
    },
    "login": {
        "welcome": "Willkommen",
        "subtitle": "Geben Sie die Praxis-ID, die E-Mail-Adresse des Arztes und das Passwort ein",
        "praxisId": "Praxis-ID",
        "praxisIdPlaceholder": "praxisid",
        "email": "E-Mail",
        "emailPlaceholder": "username@gmail.com",
        "password": "Passwort",
        "invalidCredentials": "Ungültige Anmeldedaten",
        "tooManyAttempts": "Zu viele Anmeldeversuche. Bitte warten Sie 15 Minuten und versuchen Sie es erneut.",
        "accountLocked": "Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es erneut um {{time}} Uhr.",
        "capsLock": "Feststelltaste ist aktiv",
        "emailNotVerified": "Bitte bestätigen Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.",
        "signIn": "Anmelden",
        "questions": "Fragen? Kontaktieren Sie:",
        "or": "oder rufen Sie an",
        "noAccount": "Noch kein Konto?",
        "register": "Registrieren",
        "forgotPassword": "Passwort vergessen?",
        "forgotPasswordTitle": "Passwort zurücksetzen",
        "forgotPasswordSubtitle": "Geben Sie Ihre Praxis-ID und E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
        "forgotPasswordSent": "Falls ein Konto mit diesen Daten existiert, wurde eine E-Mail mit dem Reset-Link gesendet.",
        "forgotPasswordSend": "Link senden",
        "forgotPasswordBack": "Zurück zum Login",
        "resetPasswordTitle": "Neues Passwort",
        "resetPasswordSubtitle": "Geben Sie Ihr neues Passwort ein.",
        "resetPasswordNew": "Neues Passwort",
        "resetPasswordConfirm": "Passwort bestätigen",
        "resetPasswordMismatch": "Die Passwörter stimmen nicht überein.",
        "resetPasswordTooShort": "Das Passwort muss mindestens 8 Zeichen lang sein.",
        "resetPasswordSuccess": "Ihr Passwort wurde erfolgreich geändert.",
        "resetPasswordInvalid": "Dieser Link ist ungültig oder abgelaufen.",
        "resetPasswordSubmit": "Passwort setzen"
    },
    "register": {
        "title": "Konto erstellen",
        "alreadyHaveAccount": "Sie haben bereits ein Konto?",
        "signIn": "Anmelden",
        "step1": "Praxis",
        "step1Desc": "Praxisprofil einrichten",
        "step2": "Weitere Infos",
        "step2Desc": "Fachrichtung, Adresse & Kontakt",
        "step3": "Bankdaten",
        "step3Desc": "Bank- und Abrechnungsdaten",
        "step4": "Plan",
        "step4Desc": "Abonnement auswählen",
        "step5": "Team",
        "step5Desc": "Ärzte und Mitarbeiter hinzufügen",
        "next": "Weiter",
        "back": "Zurück",
        "backToLogin": "Zurück zur Anmeldung",
        "submit": "Registrierung abschließen",
        "submitting": "Wird registriert...",
        "praxisName": "Praxisname",
        "praxisEmail": "E-Mail",
        "password": "Passwort",
        "confirmPassword": "Passwort bestätigen",
        "suggestedId": "Login-ID",
        "suggestedIdHint": "Beim Login verwenden",
        "regenerate": "Neu generieren",
        "padPraxisId": "PAD-Abrechnungs-ID (optional)",
        "specialization": "Fachrichtung(en)",
        "logo": "Logo (optional)",
        "logoUpload": "Zum Hochladen klicken",
        "phones": "Telefonnummer(n)",
        "addPhone": "+ Telefon hinzufügen",
        "street": "Straße",
        "streetNumber": "Nr.",
        "plz": "PLZ",
        "city": "Stadt",
        "country": "Land",
        "iban": "IBAN",
        "bic": "BIC / SWIFT",
        "taxNumber": "Steuernummer",
        "selectPlan": "Plan wählen",
        "perMonth": "/ Monat",
        "trialNotice": "Alle Pläne beinhalten eine 14-tägige kostenlose Testphase.",
        "sepaNotice": "Ihre IBAN wird für das SEPA-Lastschriftmandat verwendet. Die erste Abbuchung erfolgt nach Ablauf der Testphase.",
        "smsPostNotice": "Bei Basic- und Plus-Tarifen wird der SMS-Versand separat pro Nutzung berechnet.",
        "manageSubscriptionNotice": "Sie können Ihr Abonnement jederzeit unter Einstellungen → Abonnement ändern oder kündigen.",
        "priceExclVat": "Alle Preise zzgl. gesetzlicher MwSt.",
        "selected": "Ausgewählt",
        "planFeatureSms": "SMS",
        "planFeatureSmsIncluded": "SMS inklusive",
        "planFeatureCardPayment": "Kartenzahlung im Patientenportal (SumUp) – demnächst",
        "planFeatureCustomTeam": "Individuelle Teamgröße",
        "planFeatureUnlimitedInvoices": "Unbegrenzte Rechnungen",
        "planBasic": "Basic",
        "planPlus": "Plus",
        "planPro": "Pro",
        "planEnterprise": "Enterprise",
        "teamTitle": "Teammitglieder",
        "adminBadge": "Admin",
        "member": "Mitglied",
        "addMember": "Mitglied hinzufügen",
        "planLimitReached": "Ihr aktueller Plan erlaubt keine weiteren Mitglieder. Bitte upgraden Sie Ihren Plan.",
        "editMember": "Mitglied bearbeiten",
        "unnamedMember": "Unbenanntes Mitglied",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "remove": "Entfernen",
        "salutation": "Anrede",
        "memberTitle": "Titel",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "specialty": "Fachrichtung",
        "memberEmail": "E-Mail",
        "memberPassword": "Passwort",
        "confirmMemberPassword": "Passwort bestätigen",
        "userRights": "Rolle",
        "avatar": "Profilfoto",
        "uploadPhoto": "Zum Hochladen klicken",
        "memberIban": "IBAN (optional)",
        "memberBic": "BIC (optional)",
        "memberTaxNumber": "Steuernummer (optional)",
        "basicOneMember": "Der Basic-Plan enthält ein Arzt-Konto.",
        "planMembersInfo": "Ihr {{plan}}-Plan beinhaltet bis zu {{max}} Teammitglied(er).",
        "planDoctorInfo": "{{plan}}: {{doctorCount}}/{{maxDoctors}} Arzt/Ärzte belegt",
        "planStaffInfo": "{{staffCount}}/{{maxStaff}} Personal belegt",
        "errorTooManyDoctors": "Ihr Plan erlaubt {{max}} Arzt/Ärzte, Sie haben jedoch {{count}}. Bitte entfernen Sie einen Arzt oder upgraden Sie Ihren Plan.",
        "errorTooManyStaff": "Ihr Plan erlaubt {{max}} Mitarbeiter, Sie haben jedoch {{count}}. Bitte entfernen Sie einen Mitarbeiter oder upgraden Sie Ihren Plan.",
        "extraDoctorInfo": "Jeder weitere Arzt über das Planlimit hinaus kostet €39/Monat.",
        "memberOverageInfo": "Sie haben das Maximum an Mitglieder erreicht. Jeder weitere Arzt über das Planlimit hinaus kostet €39/Monat. Jeder weitere Mitarbeiter (MFA / Buchhaltung) über das Planlimit hinaus kostet €9,90/Monat. Falls Sie weitere Mitglieder dazubuchen wollen, nehmen Sie bitte mit uns Kontakt auf.",
        "ibanFallbackInfo": "Wenn ein Admin oder Arzt keine eigene IBAN hat, wird die Praxis-IBAN den Patienten für eingehende Zahlungen angezeigt.",
        "ibanFallbackNotice": "Keine IBAN eingetragen – die Praxis-IBAN wird für Zahlungen dieses Mitglieds verwendet.",
        "roleAdmin": "Admin",
        "roleDoctor": "Arzt",
        "roleMedicalAssistant": "Medizinische Fachangestellte",
        "roleAccounting": "Buchhaltung",
        "successTitle": "Alles bereit!",
        "successMsg": "Ihre Praxis wurde registriert. Bitte notieren Sie Ihre Login-ID — Sie benötigen diese bei jeder Anmeldung.",
        "yourPraxisId": "Ihre Login-ID:",
        "verifyEmailNotice": "Wir haben eine Bestätigungs-E-Mail an {{email}} gesendet. Bitte bestätigen Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.",
        "goToLogin": "Jetzt anmelden",
        "errorPraxisName": "Praxisname ist erforderlich.",
        "errorEmail": "Eine gültige E-Mail-Adresse ist erforderlich.",
        "errorPasswordLength": "Das Passwort muss mindestens 8 Zeichen lang sein.",
        "errorPasswordMatch": "Die Passwörter stimmen nicht überein.",
        "errorPraxisId": "Login-ID ist erforderlich.",
        "errorIdTaken": "Diese Login-ID ist bereits vergeben. Bitte wählen Sie eine andere.",
        "errorIban": "IBAN ist erforderlich.",
        "errorIbanFormat": "Ungültiges IBAN-Format.",
        "errorSpecialization": "Bitte wählen Sie mindestens eine Fachrichtung aus.",
        "errorStreet": "Straße ist erforderlich.",
        "errorStreetNumber": "Hausnummer ist erforderlich.",
        "errorPlz": "Postleitzahl ist erforderlich.",
        "errorCity": "Stadt ist erforderlich.",
        "errorPhone": "Mindestens eine Telefonnummer ist erforderlich.",
        "errorNoAdmin": "Bitte fügen Sie mindestens einen Admin hinzu.",
        "errorPlan": "Bitte wählen Sie einen Plan aus.",
        "errorFirstName": "Vorname ist erforderlich.",
        "errorLastName": "Nachname ist erforderlich.",
        "errorGeneral": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "suggestedIds": "Vorschläge",
        "idChecking": "Wird geprüft…",
        "idAvailable": "Verfügbar",
        "idTaken": "Bereits vergeben",
        "praxisIdNotice": "Ihre Login-ID wird zusammen mit Ihrer E-Mail und Ihrem Passwort bei jeder Anmeldung benötigt.",
        "adminNotice": "Vorname, Nachname, E-Mail und Passwort gelten für den obligatorischen Administrator-Zugang dieser Praxis.",
        "otpTitle": "E-Mail bestätigen",
        "otpHint": "Wir haben einen 6-stelligen Code an {{email}} gesendet.",
        "otpConfirm": "Bestätigen & registrieren",
        "otpResend": "Code erneut senden",
        "otpInvalid": "Ungültiger oder abgelaufener Code. Bitte versuchen Sie es erneut.",
        "otpTooMany": "Zu viele Versuche. Bitte warten Sie 10 Minuten und versuchen Sie es erneut.",
        "otpSendError": "Code konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
        "staffOverageInfo": "Jeder weitere Mitarbeiter (MFA / Buchhaltung) über das Planlimit hinaus kostet €9,90/Monat.",
        "streetAndNumber": "Straße & Hausnummer",
        "sepaConsentText": "Ich erteile der Exipnon GmbH ein SEPA-Lastschriftmandat für wiederkehrende Zahlungen zur Nutzung von Medinvoice®. Ich kann dieses Mandat jederzeit direkt bei der Exipnon GmbH widerrufen.",
        "errorIbanConsent": "Bitte stimmen Sie dem SEPA-Lastschriftmandat zu.",
        "passwordHint": "Min. 8 Zeichen · 1 Großbuchstabe · 1 Sonderzeichen",
        "errorPasswordStrength": "Das Passwort muss mindestens einen Großbuchstaben und ein Sonderzeichen enthalten.",
        "addLaterNote": "Sie können weitere Team-Mitglieder jederzeit später unter Einstellungen hinzufügen.",
        "adminNameMissing": "Bitte geben Sie Ihren Vor- und Nachnamen ein, um fortzufahren.",
        "errorIbanRegistered": "Diese IBAN ist bereits mit einem Medinvoice-Konto verknüpft. Bitte melden Sie sich an oder kontaktieren Sie den Support.",
        "emailInfoTitle": "Zwei E-Mails werden versendet",
        "emailInfoPraxisLabel": "Praxis-E-Mail",
        "emailInfoPraxisDesc": "Erhält einen 6-stelligen Bestätigungscode zur Verifizierung der Registrierung.",
        "emailInfoAdminLabel": "Administrator-E-Mail",
        "emailInfoAdminDesc": "Erhält nach erfolgreicher Bestätigung einen Verifizierungslink. Dieser muss geklickt werden, bevor die erste Anmeldung möglich ist.",
        "emailInfoConfirm": "Verstanden, Code senden",
        "errorPraxisExists": "Diese E-Mail-Adresse ist bereits mit einer Praxis verknüpft. Bitte melden Sie sich an."
    },
    "nav": {
        "home": "Startseite",
        "recipients": "Empfänger",
        "patients": "Patienten",
        "invoices": "Rechnungen",
        "bank": "Bank",
        "praxisSoftwareSync": "Synchronisation",
        "uploads": "hochgeladene Dateien",
        "settings": "Einstellungen",
        "docs": "Dokumentation",
        "logout": "abmelden",
        "myProfile": "Mein Profil",
        "assistant": "Assistent",
        "charges": "monatliche Kosten",
        "menuToggle": "Menü öffnen",
        "menuClose": "Menü schließen",
        "mainNavigation": "Hauptnavigation"
    },
    "bank": {
        "title": "Bankabgleich",
        "leadConnected": "<strong>{{total}} Transaktionen synchronisiert.</strong> <em>{{unmatched}} nicht zugeordnet, {{auto}} automatisch zugeordnet, {{reviewed}} geprüft.</em>"
    },
    "roles": {
        "doctor": "Ärztin/Arzt",
        "admin": "Administrator",
        "medicalAssistant": "Medizinische Fachangestellte",
        "accounting": "Buchhaltung",
        "user": "Benutzer",
        "firstLogin": "Erstanmeldung"
    },
    "dashboard": {
        "title": "Tägliches Briefing",
        "welcomeBack": "Willkommen zurück,",
        "staffSubtitle": "Patientenrechnungen verwalten, Zahlungsstatus verfolgen und Daten aktuell halten.",
        "invoicesThisMonth": "Rechnungen diesen Monat",
        "quotaTip": "{{count}} von {{allowance}} Rechnungen verwendet. Jede weitere Rechnung wird mit €{{rate}} berechnet.",
        "pvsSavingsPositive": "Sie sparen diesen Monat {{amount}} gegenüber einer PVS-Abrechnungsstelle",
        "pvsSavingsNegative": "Diesen Monat {{amount}} teurer als eine PVS-Abrechnungsstelle",
        "pvsHistoryTitle": "Ersparnis gegenüber einer PVS-Abrechnungsstelle",
        "pvsHistoryCurrent": "Aktuell",
        "pvsHistoryPositive": "{{amount}} gespart",
        "pvsHistoryNegative": "{{amount}} teurer",
        "pvsHistoryNotConfigured": "Nicht konfiguriert",
        "pvsHistoryEmpty": "Noch keine Abrechnungshistorie.",
        "pvsHistoryOpenCharges": "In Gebühren öffnen →",
        "totalOutstanding": "Offene Posten",
        "openPosten": "Offene Posten",
        "openPostenCount_one": "{{count}} Rechnung",
        "openPostenCount_other": "{{count}} Rechnungen",
        "openPostenTotal": "Gesamt offen",
        "openPostenEmpty": "Keine offenen Posten.",
        "openPostenNoReminder": "Noch keine Mahnung",
        "openPostenReminded": "Gemahnt",
        "openPostenCritical": "Letzte Mahnung",
        "pendingToSend": "in Bearbeitung",
        "pendingToSendCount_one": "{{count}} Rechnung",
        "pendingToSendCount_other": "{{count}} Rechnungen",
        "billed": "abgerechnet",
        "collected": "bezahlt",
        "uploaded": "hochgeladen",
        "sent": "Jahresumsatz",
        "paid": "bezahlt",
        "recipients": "Empfänger",
        "patients": "Patienten",
        "pendingInvoices": "offene Rechnungen",
        "overdue": "überfällig",
        "invoices": "Rechnungen",
        "openInvoices": "Offen",
        "dunningStatus": "Mahnstatus",
        "overview": "Übersicht",
        "toggleActivity": "Aktivität & Aufgaben ein-/ausblenden",
        "toggleOverview": "Übersicht & Mahnung ein-/ausblenden",
        "toggleBank": "Bankdetails ein-/ausblenden",
        "toggleSectionsHint": "Mit diesen Symbolen blenden Sie Bereiche des Dashboards ein oder aus. Ihre Auswahl wird gespeichert.",
        "toggleSectionsHintDismiss": "Verstanden",
        "boot": {
            "loading": "Ihre Daten werden geladen…",
            "invoices": "Rechnungen werden abgerufen…",
            "patients": "Patientenliste wird vorbereitet…",
            "recipients": "Empfängerliste wird vorbereitet…",
            "calculating": "Beträge werden berechnet…",
            "sub": "Bei langsamen Netzwerken kann das einen Moment dauern."
        },
        "kpiHelp": {
            "moreAbout": "Mehr Informationen: {{topic}}",
            "outstanding": "Offener Betrag: versendete, noch nicht vollständig bezahlte Rechnungen (ohne storniert/abgeschrieben).",
            "sent": "Bruttosumme aller im laufenden Kalenderjahr ausgestellten Rechnungen (bezahlt oder offen).",
            "paid": "Gesamtbetrag der eingegangenen Zahlungen (inkl. Teilzahlungen).",
            "overdue": "Restbetrag versendeter Rechnungen in Mahnstufen (M1/M2/M3/Inkasso), noch nicht bezahlt."
        },
        "overdueBreakdown": "Überfällig – Aufschlüsselung",
        "overdueTotalFines": "Mahngebühren gesamt",
        "overdueBaseAmounts": "Rechnungsbeträge",
        "overdueNoData": "Keine überfälligen Rechnungen",
        "toggleTimeline": "Status offene Posten ein-/ausblenden",
        "noDunning": "keine Mahnung",
        "friendly": "freundlich",
        "demanding": "fordernd",
        "final": "Letzte",
        "legal": "Inkasso",
        "open": "offen",
        "invoicesIssued": "Rechnungen in",
        "statsButton": "Statistiken",
        "help": "Hilfe",
        "stats": {
            "title": "Praxis-Statistiken",
            "monthOverMonth": "Monatsvergleich",
            "newPatients": "Neue Patienten",
            "invoicesCreated": "Erstellte Rechnungen",
            "patientsAndInvoices": "Patienten & Rechnungen",
            "sentAndPaid": "Versendet & Bezahlt",
            "popularServices": "Beliebteste Leistungen",
            "mostUsed": "Am häufigsten abgerechnet",
            "topEarning": "Höchster Umsatz",
            "noServices": "Noch keine Leistungen erfasst.",
            "serviceCount": "{{count}}×"
        },
        "timeline": {
            "title": "Rechnungsverlauf",
            "sent": "Jahresumsatz",
            "m1": "M1",
            "m2": "M2",
            "m3": "M3",
            "legal": "Inkasso",
            "thisMonth": "diesen Monat",
            "thisYear": "dieses Jahr",
            "last3m": "letzten 3M",
            "last6m": "letzten 6M",
            "last12m": "letzten 12M",
            "allTime": "gesamter Zeitraum"
        },
        "summaryPie": {
            "title": "Status offene Posten",
            "total": "gesamt",
            "yearTotal": "Jahresumsatz",
            "active": "aktiv",
            "outstanding": "ausstehend",
            "overdue": "überfällig",
            "paid": "bezahlt",
            "sent": "Versandt",
            "m1": "M1 – 1. Erinnerung",
            "m2": "M2 – 2. Erinnerung",
            "m3": "M3 – letzte Mahnung",
            "legal": "Inkasso"
        },
        "unsentInvoices": "{{count}} Rechnung nicht versandt",
        "unsentInvoices_other": "{{count}} Rechnungen nicht versandt",
        "noEmail": "{{count}} Empfänger ohne E-Mail",
        "noEmail_other": "{{count}} Empfänger ohne E-Mail",
        "noPhone": "{{count}} Empfänger ohne Telefonnummer",
        "noPhone_other": "{{count}} Empfänger ohne Telefonnummer",
        "unansweredQuestions": "{{count}} unbeantwortete Frage",
        "unansweredQuestions_other": "{{count}} unbeantwortete Fragen",
        "questionnaireNoInvoice": "{{count}} Rechnung nicht versandt (Einwilligung unterschrieben)",
        "questionnaireNoInvoice_other": "{{count}} Rechnungen nicht versandt (Einwilligung unterschrieben)"
    },
    "activity": {
        "title": "Aktivitäten",
        "empty": "keine Aktivitäten in den letzten {{n}} Tagen.",
        "emptyHint": "Das ist normal, wenn in diesem Zeitraum nichts zu Ihrem Filter passt. Probieren Sie einen anderen Filter oder schauen Sie später wieder vorbei.",
        "invoicePaid": "Rechnung {{readableId}} bezahlt",
        "invoiceViewed": "Rechnung {{readableId}} vom Empfänger geöffnet",
        "dunningAdvanced": "Mahnstufe {{dunningLevel}} — Rechnung {{readableId}}",
        "portalRegistered": "Empfänger hat sich im Portal registriert",
        "smsOtpUsed": "Empfänger per SMS verifiziert",
        "unsentReminder": "Rechnung {{readableId}} nicht versendet ({{daysSinceCreation}}d)",
        "questionSubmitted": "Empfänger hat eine Frage gestellt ({{questionCategory}})",
        "questionnaireFilled": "Empfänger hat die Einwilligung unterschrieben",
        "bankTransactionMatched": "Banküberweisung zu Rechnung {{readableId}} zugeordnet",
        "billingCharged": "Monatliche Abrechnung eingezogen — €{{amount}} ({{transactionRef}})",
        "overpaymentDetected": "Überzahlung bei Rechnung {{readableId}} erkannt (+€{{amount}})",
        "found": "{{count}} gefunden · letzte {{n}} Tage",
        "filter": {
            "all": "alle",
            "paid": "bezahlt",
            "bank": "Bank",
            "unsent": "nicht versendet",
            "dunning": "Mahnung",
            "portal": "Portal"
        }
    },
    "todos": {
        "title": "Aufgaben",
        "allDone": "Alles erledigt!",
        "allDoneHint": "Derzeit sind keine Rechnungen offen, die Ihre Aufmerksamkeit brauchen.",
        "unsentInvoices": "{{count}} Rechnung nicht versandt",
        "unsentInvoices_other": "{{count}} Rechnungen nicht versandt",
        "consentMissing": "{{count}} Rechnung kann nicht versendet werden – Einwilligung fehlt",
        "consentMissing_other": "{{count}} Rechnungen können nicht versendet werden – Einwilligung fehlt",
        "noEmail": "{{count}} Empfänger ohne E-Mail",
        "noEmail_other": "{{count}} Empfänger ohne E-Mail",
        "noPhone": "{{count}} Empfänger ohne Telefonnummer",
        "noPhone_other": "{{count}} Empfänger ohne Telefonnummer",
        "unansweredQuestions": "{{count}} unbeantwortete Frage",
        "unansweredQuestions_other": "{{count}} unbeantwortete Fragen",
        "questionnaireNoInvoice": "{{count}} Rechnung nicht versandt (Einwilligung unterschrieben)",
        "questionnaireNoInvoice_other": "{{count}} Rechnungen nicht versandt (Einwilligung unterschrieben)",
        "overdueUnmatched": "{{count}} überfällige Rechnung prüfen",
        "overdueUnmatched_other": "{{count}} überfällige Rechnungen prüfen",
        "overpaidInvoices": "{{count}} Rechnung überzahlt",
        "overpaidInvoices_other": "{{count}} Rechnungen überzahlt",
        "unmatchedBankTx": "{{count}} Banktransaktion keiner Rechnung zugeordnet",
        "unmatchedBankTx_other": "{{count}} Banktransaktionen keiner Rechnung zugeordnet",
        "doublePayments": "{{count}} Rechnung doppelt bezahlt",
        "doublePayments_other": "{{count}} Rechnungen doppelt bezahlt"
    },
    "patients": {
        "title": "Patienten",
        "fetching": "Laden...",
        "search": "Name oder E-Mail…",
        "add": "Patient hinzufügen",
        "selected": "ausgewählt",
        "noFound": "keine Patienten gefunden",
        "createdSuccess": "Patient erfolgreich erstellt",
        "deleteTitle": "Patient löschen",
        "editPatient": "Patient bearbeiten",
        "deletePatient": "Patient löschen",
        "failedDelete": "Patient konnte nicht gelöscht werden. Bitte erneut versuchen.",
        "otherDoctorHint": "Gehört zu {{name}}",
        "otherDoctorHintUnknown": "Gehört zu einem anderen Arzt",
        "deleteNTitle": "{{count}} Patient(en) löschen",
        "count_one": "{{count}} Patient",
        "count_other": "{{count}} Patienten",
        "recipientsCount": "{{count}} Rechnungsempfänger",
        "lead": "<strong>{{total}} Patienten · {{recipients}} Rechnungsempfänger</strong> in der Kartei. <em>{{withOpen}} haben offene Rechnungen.</em>",
        "viewAll": "Alle",
        "viewWithOpen": "Offene Rechnungen",
        "viewAllPaid": "Bezahlt",
        "viewMissingEmail": "Ohne E-Mail",
        "viewMinors": "Minderjährige",
        "advancedFilters": "Erweiterte Filter",
        "exportCsv": "CSV exportieren",
        "selfPayer": "Selbst",
        "noEmail": "— keine E-Mail —",
        "noInvoicesYet": "noch keine Rechnungen",
        "open": "Patient öffnen",
        "noTel": "Kein Tel.",
        "sortLabel": "Sortierung: {{label}}",
        "bulkQuestionnaireBtn": "Einwilligung senden",
        "bulkQuestionnaireTitle": "Fragebogen an {{count}} Patient(en) senden",
        "bulkQuestionnaireCanSend": "{{count}} sendbar",
        "bulkQuestionnaireNoEmail": "{{count}} ohne E-Mail",
        "bulkQuestionnairePostOnly": "{{count}} nur Brief",
        "bulkQuestionnaireSend": "Senden",
        "bulkQuestionnaireSending": "Sende…",
        "bulkQuestionnaireSelectAll": "Alle auswählen",
        "bulkQuestionnaireDone_one": "{{count}} Fragebogen gesendet",
        "bulkQuestionnaireDone_other": "{{count}} Fragebögen gesendet",
        "bulkQuestionnaireDonePartial": "{{sent}} von {{total}} Fragebögen gesendet — {{failed}} fehlgeschlagen",
        "bulkQuestionnaireDonePartialReason": "{{sent}} von {{total}} Fragebögen gesendet — {{failed}} fehlgeschlagen ({{reason}})",
        "bulkQuestionnaireAlreadySent": "Bereits gesendet",
        "bulkQuestionnaireOpened": "Geöffnet",
        "bulkQuestionnaireSubmitted": "Eingereicht",
        "bulkQuestionnaireNoRecipient": "Kein Empfänger",
        "bulkQuestionnaireNoEmailReason": "Keine E-Mail",
        "bulkQuestionnairePostOnlyReason": "Nur Brief — Einwilligung nur auf Papier",
        "bulkQuestionnaireReason": "Grund"
    },
    "recipients": {
        "title": "Empfänger",
        "search": "Patienten oder Empfänger suchen",
        "add": "+ Patient hinzufügen",
        "noFound": "keine(n) Empfänger gefunden",
        "createdSuccess": "Empfänger erfolgreich erstellt",
        "noRecipient": {
            "title_one": "1 Patient ohne Rechnungsempfänger",
            "title_other": "{{count}} Patienten ohne Rechnungsempfänger",
            "lead": "Für diese Patienten ist noch nichts möglich – keine Rechnung, keine Einwilligung, kein Versand. Ordnen Sie zuerst einen Rechnungsempfänger zu, bei Minderjährigen einen Elternteil oder Erziehungsberechtigten.",
            "born": "geb. {{date}}",
            "minor": "Minderjährig",
            "fromSync": "Aus der Praxissoftware",
            "assign": "Empfänger zuordnen",
            "assigned": "Rechnungsempfänger zugeordnet",
            "delete": "Löschen",
            "deleteSyncNote": "Das Löschen ist endgültig. Wird der Patient erneut aus der Praxissoftware übertragen, erscheint er wieder hier.",
            "deleteBlocked_one": "Dieser Patient hat 1 Rechnung und kann hier nicht gelöscht werden. Ordnen Sie zuerst einen Rechnungsempfänger zu – dann sehen Sie die Rechnung in der Patientenakte und können dort entscheiden.",
            "deleteBlocked_other": "Dieser Patient hat {{count}} Rechnungen und kann hier nicht gelöscht werden. Ordnen Sie zuerst einen Rechnungsempfänger zu – dann sehen Sie die Rechnungen in der Patientenakte und können dort entscheiden.",
            "deleteFailed": "Der Patient konnte nicht gelöscht werden. Bitte versuchen Sie es erneut."
        },
        "deleteTitle": "Patient löschen",
        "deleteRecipient": "Empfänger löschen",
        "sendQuestionnaire": "Einwilligung senden",
        "sending": "senden…",
        "send": "senden",
        "noEmail": "(keine E-Mail-Adresse hinterlegt)",
        "noEmailShort": "keine E-Mail",
        "noPhone": "(keine Telefonnummer hinterlegt)",
        "noAddressShort": "keine Adresse",
        "portalRegistered": "im Portal registriert",
        "questionnaireSent": "Einwilligung gesendet",
        "questionnaireOpened": "Einwilligung geöffnet",
        "questionnaireSubmitted": "Einwilligung unterschrieben",
        "questionnaireReceived": "Fragebogen eingegangen — Patientendaten wurden aktualisiert.",
        "viewQuestionnaire": "Fragebogen anzeigen",
        "viewConsent": "Einwilligung anzeigen",
        "consentManualDigital": "Einwilligung dig. Versand (manuell gesetzt)",
        "consentManualPost": "Einwilligung Briefversand (manuell gesetzt)",
        "consentMissingFor": "Einwilligung fehlt für: {{names}}",
        "consentMissingForHint": "Jeder Patient braucht eine eigene Einwilligung. Diese Patienten kamen nach der Unterschrift dazu – lassen Sie die Einwilligung neu unterschreiben, sie nennt dann alle Patienten. Bis dahin können ihre Rechnungen nicht versendet werden.",
        "questionnaireResend": "Fragebogen erneut senden",
        "editRecipient": "Patient bearbeiten",
        "failedDelete": "Patient konnte nicht gelöscht werden. Bitte erneut versuchen.",
        "deleteNTitle": "{{count}} Patienten löschen",
        "sendQuestionnaireTo": "Fragebogen-Link senden an",
        "willAlsoDelete": "Folgendes wird ebenfalls gelöscht:",
        "deleteConfirm": "Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.",
        "deleteCascadeIntro": "Dabei werden ebenfalls gelöscht:",
        "deleteAlsoLinked_one": "{{count}} verknüpfter Patienteneintrag",
        "deleteAlsoLinked_other": "{{count}} verknüpfte Patienteneinträge",
        "deleteAlsoInvoices_one_open": "1 offene Rechnung",
        "deleteAlsoInvoices_one_paid": "1 bezahlte Rechnung",
        "deleteAlsoInvoices_allPaid": "{{count}} Rechnungen (alle bezahlt)",
        "deleteAlsoInvoices_withOpen": "{{count}} Rechnungen, davon {{open}} offen",
        "deleteAlsoInvoices_sent": "{{sent}} gesendet, {{notSent}} nicht gesendet",
        "deleteAlsoInvoices_dunning": "M1: {{m1}}, M2: {{m2}}, M3: {{m3}}, Legal: {{legal}}",
        "samePersonBadge": "Patient ist dieselbe Person",
        "samePersonPatientsCol": "Wie oben (gleiche Person)",
        "showQuestionnaireNotSubmitted": "Einwilligung offen",
        "questionnaireNotSubmitted": "Fragebogen nicht eingereicht",
        "showInvoiceNotSent": "Nicht versendet",
        "invoiceNotSent": "Rechnung nicht versendet",
        "count_one": "{{count}} Patient",
        "count_other": "{{count}} Patienten",
        "lead": "<strong>{{total}} Patienten · {{recipientCount}} Rechnungsempfänger</strong> in der Kartei. {{withOpen}} haben offene Rechnungen, {{noEmail}} haben keine E-Mail.",
        "viewAll": "Alle",
        "viewWithOpen": "Offene Rechnungen",
        "viewNotSent": "Rechnung nicht versendet",
        "viewNoEmail": "Keine E-Mail",
        "sortNameAsc": "Name A→Z",
        "sortNameDesc": "Name Z→A",
        "sortOpenDesc": "Meiste offene Rechnungen",
        "sortNotSentDesc": "Nicht versendet zuerst",
        "exportCsv": "CSV exportieren",
        "importCsv": "CSV importieren"
    },
    "invoiceTemplates": {
        "settingsTitle": "Rechnungsvorlagen",
        "settingsDescription": "Leistungen, die Sie oft zusammen abrechnen – z. B. „Check-up“ oder „Impfung“. Einfügen in Schritt 3 von „Rechnung erstellen“.",
        "new": "Neue Vorlage",
        "newTitle": "Neue Vorlage",
        "editTitle": "Vorlage bearbeiten",
        "insert": "Vorlage einfügen",
        "insertTitle": "Vorlage einfügen",
        "saveAs": "Als Vorlage speichern",
        "saveNeedsLines": "Erst Leistungen mit GOÄ-Ziffer eintragen",
        "saveTitle": "Als Vorlage speichern",
        "name": "Name",
        "namePlaceholder": "z. B. Check-up",
        "shareWithPractice": "Für die ganze Praxis freigeben",
        "linesToSave_one": "{{count}} Leistung wird gespeichert: {{codes}}",
        "linesToSave_other": "{{count}} Leistungen werden gespeichert: {{codes}}",
        "save": "Vorlage speichern",
        "saving": "Wird gespeichert …",
        "saved": "Vorlage „{{name}}“ gespeichert.",
        "inserted_one": "Vorlage „{{name}}“ eingefügt ({{count}} Leistung).",
        "inserted_other": "Vorlage „{{name}}“ eingefügt ({{count}} Leistungen).",
        "shared": "Praxis",
        "personal": "Persönlich",
        "searchPlaceholder": "Vorlage oder GOÄ-Ziffer suchen",
        "loading": "Vorlagen werden geladen …",
        "emptyWizard": "Noch keine Vorlagen. Speichern Sie die Leistungen eines Tages mit „Als Vorlage speichern“ – oder legen Sie Vorlagen in den Einstellungen an.",
        "emptySettings": "Noch keine Vorlagen. Legen Sie hier eine an – oder speichern Sie beim Erstellen einer Rechnung die Leistungen eines Tages als Vorlage.",
        "manage": "Vorlagen verwalten",
        "noMatch": "Keine Vorlage passt zu „{{query}}“.",
        "lineCount_one": "{{count}} Leistung",
        "lineCount_other": "{{count}} Leistungen",
        "usedCount_zero": "noch nicht verwendet",
        "usedCount_one": "1-mal verwendet",
        "usedCount_other": "{{count}}-mal verwendet",
        "byColleague": "von einer Kollegin / einem Kollegen",
        "editNamed": "Vorlage „{{name}}“ bearbeiten",
        "deleteNamed": "Vorlage „{{name}}“ löschen",
        "deleteTitle": "Vorlage löschen?",
        "deleteMessage": "Die Vorlage „{{name}}“ wird gelöscht. Bereits erstellte Rechnungen ändern sich nicht.",
        "deleteSharedMessage": "Die Vorlage „{{name}}“ wird für die ganze Praxis gelöscht. Bereits erstellte Rechnungen ändern sich nicht.",
        "delete": "Löschen",
        "total": "Summe",
        "fixLines": "Bitte korrigieren Sie die markierten Leistungen.",
        "dayN": "Tag {{n}}",
        "dayCount_one": "{{count}} Tag",
        "dayCount_other": "{{count}} Tage",
        "insertedDays_one": "Vorlage „{{name}}“ eingefügt.",
        "insertedDays_other": "Vorlage „{{name}}“ auf {{count}} Behandlungstage ab hier verteilt.",
        "skippedDays_one": "{{count}} Tag der Vorlage wurde nicht eingefügt – dafür fehlt ein weiterer Behandlungstag (Schritt 2).",
        "skippedDays_other": "{{count}} Tage der Vorlage wurden nicht eingefügt – dafür fehlen weitere Behandlungstage (Schritt 2).",
        "saveScope": "Was speichern?",
        "scopeDay": "Nur dieser Tag",
        "scopeAll_one": "Alle {{count}} Behandlungstage",
        "scopeAll_other": "Alle {{count}} Behandlungstage",
        "linesToSaveDays_one": "{{count}} Leistung an {{days}} Tagen wird gespeichert: {{codes}}",
        "linesToSaveDays_other": "{{count}} Leistungen an {{days}} Tagen werden gespeichert: {{codes}}",
        "fromInvoiceSkipped_one": "{{count}} Auslage aus der Praxissoftware (z. B. Material) wird nicht übernommen – bei manuell erstellten Rechnungen tragen Sie Auslagen an der Leistung ein.",
        "fromInvoiceSkipped_other": "{{count}} Auslagen aus der Praxissoftware (z. B. Material) werden nicht übernommen – bei manuell erstellten Rechnungen tragen Sie Auslagen an der Leistung ein.",
        "addDay": "Behandlungstag hinzufügen",
        "removeDay": "Tag {{n}} entfernen",
        "removeDayShort": "Tag entfernen",
        "emptyDay": "Dieser Tag hat noch keine Leistung – ergänzen oder den Tag entfernen.",
        "errors": {
            "NAME_TAKEN": "Es gibt schon eine Vorlage mit diesem Namen.",
            "TOO_MANY_TEMPLATES": "Ihre Praxis hat die Höchstzahl von {{limit}} Vorlagen erreicht. Löschen Sie nicht mehr benötigte Vorlagen.",
            "INVALID_NAME": "Bitte geben Sie einen Namen ein.",
            "INVALID_LINES": "Die Vorlage braucht mindestens eine vollständige Leistung.",
            "NOT_YOURS": "Diese Vorlage können nur die Person, die sie angelegt hat, oder ein Administrator ändern.",
            "load": "Die Vorlagen konnten nicht geladen werden.",
            "generic": "Das hat nicht geklappt. Bitte versuchen Sie es erneut."
        }
    },
    "invoiceDrafts": {
        "button": "Entwürfe",
        "title": "Rechnungsentwürfe",
        "empty": "Keine offenen Entwürfe.",
        "noPatient": "Noch kein Patient gewählt",
        "atStep": "bei {{step}}",
        "updated": "zuletzt {{when}}",
        "delete": "Entwurf „{{name}}“ löschen",
        "continue": "Fortsetzen"
    },
    "goaLineEditor": {
        "confirmRow": "Übernehmen",
        "rowAdded": "Übernommen",
        "rowUpdated": "Aktualisiert",
        "price": "Einfachsatz (€)",
        "justificationRequired": "Pflicht – Faktor über {{threshold}}",
        "move": "Ziehen zum Verschieben",
        "moveRow": "Zeile {{position}} von {{count}} verschieben – Pfeiltasten hoch/runter",
        "justificationList": "Gespeicherte Begründungen",
        "justificationNumberTip": "Tipp: Nummer eingeben + Enter",
        "manageJustifications": "Begründungen verwalten",
        "saveJustification": "Als Begründung speichern",
        "justificationSaved": "In den Begründungen gespeichert",
        "justificationSaveFailed": "Konnte nicht gespeichert werden – bitte erneut versuchen."
    },
    "justifications": {
        "settingsTitle": "Begründungen",
        "settingsDescription": "Gespeicherte Begründungen für Leistungen über dem Schwellenwert. Sie stehen im Feld „Begründung“ jeder Leistung zur Auswahl – die Nummer + Enter fügt sie direkt ein. Gilt für die ganze Praxis.",
        "loading": "Begründungen werden geladen …",
        "empty": "Noch keine Begründungen. Legen Sie unten eine an – oder speichern Sie eine beim Eintragen einer Leistung mit „Als Begründung speichern“.",
        "textN": "Begründung {{n}}",
        "moveUp": "Begründung {{n}} nach oben",
        "moveDown": "Begründung {{n}} nach unten",
        "deleteN": "Begründung {{n}} löschen",
        "addLabel": "Neue Begründung",
        "addPlaceholder": "z. B. Kind sehr unruhig, Untersuchung erschwert",
        "add": "Hinzufügen",
        "save": "Änderungen speichern",
        "saving": "Wird gespeichert …",
        "discard": "Verwerfen",
        "saved": "Gespeichert.",
        "errors": {
            "load": "Die Begründungen konnten nicht geladen werden.",
            "save": "Speichern fehlgeschlagen – bitte erneut versuchen.",
            "duplicate": "Eine Begründung steht doppelt in der Liste.",
            "duplicateRow": "Diese Begründung steht doppelt in der Liste.",
            "invalid": "Jede Begründung braucht einen Text (höchstens 300 Zeichen).",
            "tooMany": "Höchstens {{max}} Begründungen."
        }
    },
    "invoiceCreate": {
        "title": "Neue Rechnung",
        "stepsLabel": "Schritte zur neuen Rechnung",
        "stepOf": "Schritt {{current}} von {{total}}",
        "steps": {
            "patient": "Patient",
            "treatment": "Behandlung",
            "services": "Leistungen",
            "check": "Prüfung",
            "preview": "Vorschau"
        },
        "stepHeadings": {
            "patient": "Für wen ist die Rechnung?",
            "treatment": "Behandlung",
            "services": "Leistungen",
            "check": "Prüfung",
            "preview": "Vorschau"
        },
        "stepLeads": {
            "patient": "Wählen Sie einen Patienten aus oder legen Sie einen neuen an – zusammen mit der Person, die die Rechnung bezahlt.",
            "treatment": "Behandelnde Ärztin oder behandelnder Arzt, Behandlungstage und Diagnosen. Als Rechnungsdatum gilt – wie bei allen Rechnungen – der Versandtag.",
            "services": "GOÄ-Ziffern mit Anzahl, Faktor und Begründung, dazu Auslagen und Materialkosten.",
            "check": "Alle Hinweise zur Abrechnung auf einen Blick, bevor die Rechnung erstellt wird.",
            "preview": "Die Rechnung im Überblick, das PDF und was nach dem Versand passiert."
        },
        "entry": "Rechnung erstellen",
        "creating": "Wird erstellt …",
        "createAndSend": "Erstellen & senden",
        "createSendAfterConsent": "Erstellen, Versand nach Einwilligung",
        "creatingAndSending": "Wird erstellt und gesendet …",
        "created": {
            "created": "Rechnung {{number}} wurde erstellt.",
            "sent": "Rechnung {{number}} wurde erstellt und per E-Mail gesendet.",
            "waitsForConsent": "Rechnung {{number}} wurde erstellt. Sie geht per E-Mail raus, sobald die Einwilligung unterschrieben ist.",
            "notSent": "Rechnung {{number}} wurde erstellt, aber nicht gesendet:",
            "reasons": {
                "LEGAL_NOT_ACCEPTED": "Die Einwilligung fehlt.",
                "NO_RECIPIENT_EMAIL": "Es ist keine E-Mail-Adresse hinterlegt.",
                "POST_ONLY": "Der Patient erhält nur Post.",
                "EMAIL_FAILED": "Die E-Mail konnte nicht zugestellt werden. Prüfen Sie die E-Mail-Einstellungen und senden Sie erneut.",
                "other": "Bitte senden Sie sie hier erneut."
            }
        },
        "draft": {
            "idle": "Wird als Entwurf gespeichert, sobald Sie etwas eingeben",
            "saving": "Entwurf wird gespeichert …",
            "saved": "Entwurf gespeichert",
            "savedAt": "Entwurf gespeichert · {{time}}",
            "error": "Entwurf nicht gespeichert.",
            "retry": "Erneut versuchen",
            "discard": "Entwurf verwerfen",
            "discardTitle": "Entwurf verwerfen?",
            "discardMessage": "Alle Eingaben dieser Rechnung werden gelöscht. Der Patient und seine Daten bleiben erhalten.",
            "missing": "Dieser Entwurf existiert nicht mehr – vielleicht wurde daraus schon eine Rechnung erstellt. Sie starten mit einer neuen Rechnung.",
            "loading": "Entwurf wird geladen …",
            "info": "Alle Eingaben werden automatisch als Entwurf gespeichert. Sie können jederzeit beenden und später unter Rechnungen → Entwürfe weitermachen."
        },
        "exit": {
            "button": "Beenden",
            "unsavedTitle": "Ohne Speichern beenden?",
            "unsavedMessage": "Die letzten Änderungen konnten nicht als Entwurf gespeichert werden und gehen verloren."
        },
        "check": {
            "ready": "Alles bereit – die Rechnung kann erstellt werden.",
            "blocked": "Bitte beheben Sie die rot markierten Punkte, bevor Sie die Rechnung erstellen.",
            "patient": "Patient und Rechnungsempfänger",
            "patientMissing": "Noch kein Patient gewählt",
            "paidBy": "zahlt: {{name}}",
            "treatment": "Behandlung",
            "services": "Leistungen",
            "delivery": "Versand",
            "deliveryLoading": "Kontaktdaten werden geladen …",
            "deliveryBoth": "Per E-Mail und per Post möglich",
            "deliveryPostOnly": "Nur per Post möglich – keine E-Mail-Adresse hinterlegt",
            "deliveryEmailOnly": "Nur digital möglich – keine vollständige Postanschrift",
            "deliveryNone": "Weder E-Mail noch Postanschrift – bitte in der Patientenakte ergänzen",
            "consent": "Einwilligung",
            "consentMissing": "Noch nicht unterschrieben – Erstellen geht, der Versand erst nach der Einwilligung.",
            "goa": "GOÄ-Prüfung",
            "goaOk": "Keine Ausschlüsse, Höchstzahlen eingehalten.",
            "goaLoading": "Wird geprüft …",
            "goaFailed": "Die GOÄ-Prüfung war gerade nicht möglich. Erstellen geht trotzdem.",
            "goaFindings_one": "{{count}} Hinweis – bitte unten prüfen und bestätigen.",
            "goaFindings_other": "{{count}} Hinweise – bitte unten prüfen und bestätigen.",
            "goaAllAcked_one": "{{count}} Hinweis bestätigt.",
            "goaAllAcked_other": "{{count}} Hinweise bestätigt.",
            "goaPending": "Fast fertig – bitte bestätigen Sie die GOÄ-Hinweise unten.",
            "goaFindingsTitle": "GOÄ-Hinweise",
            "goaFindingsLead": "Bitte prüfen Sie diese Leistungen nach den Abrechnungsregeln der GOÄ. Korrigieren Sie sie in Schritt 3 – oder bestätigen Sie, dass Sie bewusst so abrechnen (z. B. mit Begründung).",
            "goaDuplicate": "Nr. {{nr}} am {{date}} {{count}}-mal erfasst – Uhrzeit oder Organ in der Begründung angeben",
            "goaConflict": "Nr. {{a}} und Nr. {{b}} am {{date}} – nicht nebeneinander berechnungsfähig",
            "goaOverLimit": "Nr. {{nr}} am {{date}} {{billed}}-mal – erlaubt sind {{max}}-mal je Sitzung",
            "goaMissingCode": "Nr. {{nr}} am {{date}} ohne Nr. {{requires}}",
            "goaNoDate": "ohne Datum",
            "goaAck": "Bewusst so abrechnen",
            "goaFix": "Leistungen ändern",
            "legal": {
                "title": "Hinweis zur GOÄ-Abrechnung",
                "intro": "Medinvoice® unterstützt bei der Erstellung von Privatabrechnungen nach der Gebührenordnung für Ärzte (GOÄ).",
                "introChecker": "Medinvoice® unterstützt bei der Erstellung und Prüfung von Privatabrechnungen nach der Gebührenordnung für Ärzte (GOÄ). Die bereitgestellten Hinweise und Prüffunktionen dienen ausschließlich der Unterstützung und ersetzen keine eigenverantwortliche Prüfung.",
                "responsibility": "Die Verantwortung für die Richtigkeit, Vollständigkeit und Rechtmäßigkeit der Abrechnung liegt bei den abrechnenden Ärztinnen/Ärzten bzw. der abrechnenden Praxis.",
                "liability": "Medinvoice® übernimmt, soweit gesetzlich zulässig, keine Haftung für fehlerhafte GOÄ-Ziffern, unzulässige Leistungskombinationen, fehlerhafte Steigerungsfaktoren oder sonstige Abrechnungsfehler."
            },
            "rules": {"onlyWith":"Nr. {{nr}} am {{date}} neben Nr. {{others}} – so nicht berechnungsfähig","limit":"Nr. {{nr}}: {{count}}-mal {{window}} – erlaubt sind {{max}}","limitPerUnit":"Nr. {{nr}} am {{date}} {{count}}-mal – erlaubt sind {{max}} {{per}}, bitte prüfen","limitNeedsReason":"Nr. {{nr}}: {{count}}-mal {{window}} – über {{max}} nur mit Begründung","tierOver":"Nr. {{nr}}: {{count}} Tests – diese Stufe umfasst {{max}}","tierOrder":"Nr. {{nr}} erst, wenn Nr. {{previous}} voll ist ({{count}} von {{size}})","tierTotal":"Nr. {{nr}}: zusammen {{count}} Tests – erlaubt sind {{max}} je Behandlungsfall","repeatTime":"Nr. {{nr}} am {{date}} {{count}}-mal – Uhrzeit auf jeder Zeile nötig","repeatReason":"Nr. {{nr}} am {{date}} {{count}}-mal – Begründung zusätzlich zur Uhrzeit nötig","onceBeside":"Nr. {{nr}}: {{count}}-mal im Behandlungsfall neben Nr. {{beside}} – nur einmal berechnungsfähig","detail":"Nr. {{nr}} am {{date}} – Rechnung muss {{detail}} nennen","comboReason":"Nr. {{nr}} am {{date}} nebeneinander – Begründung nötig"},
            "ruleWindow": {"treatmentCase":"im Behandlungsfall","calendarYear":"im Kalenderjahr","sixMonths":"in sechs Monaten","year":"in zwölf Monaten","invoice":"auf dieser Rechnung","session":"je Sitzung","day":"am Tag"},
            "ruleDetail": {"time":"die Uhrzeit","organ":"das Organ","medication":"das Medikament","examinationType":"die Art der Untersuchung","parameters":"die untersuchten Parameter","viruses":"die untersuchten Viren","germs":"die untersuchten Keime","fungi":"die untersuchten Pilze","parasites":"die untersuchten Parasiten","markers":"die untersuchten Merkmale","material":"Material und Mikroorganismus","skeletalPart":"das Skeletteil","tissue":"das Gewebe","services":"die einzelnen Leistungen","indication":"die Indikation"},
            "rulePer": {"material":"je Material","fungus":"je Pilz","joint":"je Gelenk","skeletalPart":"je Skeletteil","side":"je Seite","visit":"je Inanspruchnahme","identification":"je Identifizierung"},
            "goaSingleRate": "Nr. {{nr}} am {{date}} mit Faktor {{factor}} – nur mit dem einfachen Gebührensatz (Faktor 1) berechnungsfähig",
            "billingNotes": "Abrechnungshinweise",
            "billingNotesPending": "Fast fertig – bitte bestätigen Sie die Abrechnungshinweise unten.",
            "billingNotesLead": "Bitte prüfen Sie diese Leistungen. Korrigieren Sie sie in Schritt 3 – oder bestätigen Sie, dass Sie bewusst so abrechnen.",
            "billingNotesConfirmFirst_one": "Bitte bestätigen Sie zuerst {{count}} Abrechnungshinweis in Schritt 4.",
            "billingNotesConfirmFirst_other": "Bitte bestätigen Sie zuerst {{count}} Abrechnungshinweise in Schritt 4.",
            "goaUpgrade": "Mit Pro prüft Medinvoice hier auch, welche GOÄ-Ziffern nicht nebeneinander abgerechnet werden dürfen und wie oft eine Ziffer je Sitzung erlaubt ist.",
            "goaConfirmFirst_one": "Bitte bestätigen Sie zuerst {{count}} GOÄ-Hinweis in Schritt 4.",
            "goaConfirmFirst_other": "Bitte bestätigen Sie zuerst {{count}} GOÄ-Hinweise in Schritt 4.",
            "goaToCheck": "Zu Schritt 4"
        },
        "suggestions": {
            "title": "Vorschläge",
            "diagnosisTitle": "Passend zu den Diagnosen",
            "upgrade": "Mit Plus schlägt Medinvoice hier Leistungen und Faktoren vor – aus Ihren eigenen Rechnungen.",
            "basis": {
                "doctor": "Aus Ihren {{count}} Rechnungen – jede Nacht aktualisiert.",
                "praxis": "Aus den {{count}} Rechnungen Ihrer Praxis – Ihre eigenen sind dafür noch zu wenige.",
                "templates": "Für Vorschläge aus Ihrer Abrechnung gibt es noch zu wenige Rechnungen – vorerst aus Ihren Vorlagen.",
                "none": "Noch keine Grundlage für Vorschläge."
            },
            "kind": {
                "add": "Nr. {{code}} ergänzen ({{date}})",
                "remove": "Nr. {{code}} prüfen ({{date}})",
                "factor": "Nr. {{code}}: Faktor {{factor}} statt {{current}} ({{date}})"
            },
            "reasons": {
                "pair": {
                    "doctor": "Bei {{share}} % Ihrer Behandlungen mit Nr. {{base}} rechnen Sie auch Nr. {{code}} ab ({{together}} von {{visits}}).",
                    "praxis": "Bei {{share}} % der Behandlungen Ihrer Praxis mit Nr. {{base}} wird auch Nr. {{code}} abgerechnet ({{together}} von {{visits}})."
                },
                "diagnosis": {
                    "doctor": "Bei „{{diagnosis}}“ rechnen Sie in {{share}} % der Fälle Nr. {{code}} ab ({{together}} von {{invoices}} Rechnungen).",
                    "praxis": "Bei „{{diagnosis}}“ wird in Ihrer Praxis in {{share}} % der Fälle Nr. {{code}} abgerechnet ({{together}} von {{invoices}} Rechnungen)."
                },
                "factor": {
                    "doctor": "Ihr üblicher Faktor für Nr. {{code}} ist {{factor}} ({{lines}} von {{total}} Abrechnungen).",
                    "praxis": "Der übliche Faktor Ihrer Praxis für Nr. {{code}} ist {{factor}} ({{lines}} von {{total}} Abrechnungen)."
                },
                "neverTogether": {
                    "doctor": "Nr. {{code}} und Nr. {{other}} haben Sie noch nie am selben Tag abgerechnet, obwohl Sie beide oft verwenden ({{codeVisits}}- und {{otherVisits}}-mal). Ein Versehen? Übernehmen entfernt Nr. {{code}}.",
                    "praxis": "Nr. {{code}} und Nr. {{other}} wurden in Ihrer Praxis noch nie am selben Tag abgerechnet, obwohl beide oft vorkommen ({{codeVisits}}- und {{otherVisits}}-mal). Ein Versehen? Übernehmen entfernt Nr. {{code}}."
                },
                "template": "Ihre Vorlage „{{template}}“ enthält zu diesen Leistungen auch Nr. {{code}}."
            },
            "apply": "Übernehmen",
            "dismiss": "Ausblenden",
            "showAll": "Alle {{count}} anzeigen",
            "showFewer": "Weniger anzeigen"
        },
        "preview": {
            "to": "Rechnung an",
            "patient": "Patient",
            "doctor": "Behandelnde Ärztin / behandelnder Arzt",
            "colCode": "GOÄ",
            "colDescription": "Leistung",
            "colQty": "Anz.",
            "colFactor": "Faktor",
            "colAmount": "Betrag",
            "justification": "Begründung: {{text}}",
            "fees": "Leistungen",
            "material": "Auslagen",
            "total": "Gesamtbetrag",
            "afterCreate": "Rechnungsnummer und Rechnungsdatum (= Versandtag) vergibt Medinvoice. Nach dem Erstellen öffnet sich die Rechnung – dort können Sie sie versenden.",
            "viewPdf": "PDF ansehen",
            "pdfLoading": "PDF wird erstellt …",
            "pdfFailed": "Die Vorschau konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
            "pdfCardTitle": "Rechnung als PDF prüfen",
            "pdfCardLead": "Genau so erhält der Empfänger die Rechnung – noch mit der Nummer „VORSCHAU“. Erstellt wird dabei nichts.",
            "pdfIncomplete":"Verfügbar, sobald Patient, Behandlung und Leistungen vollständig sind.",
            "sendNow": "Mit „Erstellen & senden“ geht die Rechnung sofort per E-Mail an {{email}}.",
            "sendAfterConsent": "Die Einwilligung fehlt noch. Mit „Erstellen, Versand nach Einwilligung“ geht die Rechnung per E-Mail an {{email}}, sobald sie unterschrieben ist.",
            "sendNone": "Senden geht hier nicht:",
            "sendNoneReasons": {
                "emailOff": "Der E-Mail-Versand ist in den Einstellungen aus. Senden Sie die Rechnung nach dem Erstellen auf der Rechnungsseite.",
                "postOnly": "Der Patient erhält nur Post. Senden Sie die Rechnung nach dem Erstellen auf der Rechnungsseite per Post.",
                "noEmail": "Es ist keine E-Mail-Adresse hinterlegt. Senden Sie die Rechnung nach dem Erstellen per Post oder ergänzen Sie die E-Mail-Adresse.",
                "consent": "Die Einwilligung fehlt. Holen Sie sie in Schritt 1 ein – oder erstellen Sie jetzt und senden Sie später."
            },
            "pdfTitle": "Rechnungsvorschau (noch nicht erstellt)"
        },
        "schedule": {
            "title": "Wenn Sie die Rechnung heute versenden",
            "loading": "Fristen werden berechnet …",
            "unavailable": "Die Fristen konnten nicht geladen werden.",
            "sent": "Versand – das ist das Rechnungsdatum",
            "due": "Fällig – ab dem Folgetag gilt die Rechnung als überfällig",
            "level1": "Zahlungserinnerung (M1)",
            "level2": "Mahnung (M2)",
            "level3": "Letzte Mahnung (M3)",
            "level4": "Inkasso-Übergabe möglich",
            "sendMode": {
                "email": "per E-Mail",
                "letter": "per Post",
                "both": "per E-Mail und Post"
            },
            "fee": "Mahngebühr {{fee}}",
            "legalSelf": "Sie entscheiden und übergeben selbst",
            "legalPaywise": "Übergabe an Paywise – Sie lösen sie selbst aus",
            "hint": "Die Mahnstufen laufen automatisch nach Ihren Einstellungen unter Einstellungen → Mahnwesen, solange die Rechnung nicht bezahlt und das Mahnwesen nicht pausiert ist. Wird später versendet, verschieben sich alle Daten entsprechend."
        },
        "createErrors": {
            "TRIAL_INVOICE_LIMIT": "In der Testphase sind höchstens {{limit}} Rechnungen möglich. Bitte aktivieren Sie Ihr Abonnement, um weitere Rechnungen zu erstellen.",
            "OWNER_REQUIRED": "Bitte wählen Sie im Schritt Behandlung die Ärztin oder den Arzt, zu dem die Rechnung gehört.",
            "PATIENT_NOT_FOUND": "Der Patient wurde nicht gefunden – bitte wählen Sie ihn im ersten Schritt erneut.",
            "NO_RECIPIENT": "Für den Patienten ist kein Rechnungsempfänger hinterlegt.",
            "INVALID_SERVICES": "Einige Leistungen sind unvollständig – bitte prüfen Sie den Schritt Leistungen.",
            "NO_SERVICES": "Die Rechnung enthält keine Leistungen.",
            "NO_DIAGNOSIS": "Die Rechnung braucht mindestens eine Diagnose (Schritt 2).",
            "generic": "Die Rechnung konnte nicht erstellt werden. Bitte versuchen Sie es erneut."
        },
        "patient": {
            "searchPlaceholder": "Name oder Geburtsdatum suchen …",
            "searchHint": "Tippen Sie den Namen oder das Geburtsdatum, z. B. „Schmidt 1980“.",
            "loading": "Patienten werden geladen",
            "results": "Gefundene Patienten",
            "paidBy": "zahlt: {{name}}",
            "noResults": "Kein Patient zu „{{query}}“ gefunden.",
            "createNew": "Neuen Patienten anlegen",
            "createNewHint": "Zusammen mit der Person, die die Rechnung bezahlt – der Patient selbst oder z. B. ein Elternteil.",
            "born": "geb. {{date}}",
            "changePatient": "Anderen Patienten wählen",
            "noRecipient": "Für diesen Patienten ist kein Rechnungsempfänger hinterlegt. Legen Sie in der Patientenakte fest, wer die Rechnung bezahlt.",
            "loadingRecipient": "Rechnungsempfänger wird geladen …",
            "recipient": "Rechnungsempfänger",
            "self": "selbst",
            "noAddress": "Keine vollständige Postanschrift",
            "noEmail": "Keine E-Mail-Adresse",
            "consent": "Einwilligung",
            "consentDigital": {
                "signed": "unterschrieben",
                "requested": "angefragt",
                "missing": "fehlt",
                "postOnly": "nur Briefversand"
            },
            "consentPost": {
                "signed": "unterschrieben",
                "covered": "durch digitale Einwilligung erlaubt",
                "missing": "fehlt"
            },
            "consentNotRequired": "In Ihrer Praxis ist für den Versand keine Einwilligung erforderlich.",
            "noDeliveryWay": "Weder E-Mail noch Postanschrift hinterlegt – so kann die Rechnung später nicht versendet werden. Ergänzen Sie die Kontaktdaten in der Patientenakte.",
            "openRecord": "Patientenakte öffnen"
        },
        "consent": {
            "leadMissing": "Für den Versand fehlt noch die Einwilligung. Holen Sie sie jetzt ein – erstellen können Sie die Rechnung auch ohne.",
            "leadRequested": "Der Einwilligungslink ist verschickt und wartet auf die Unterschrift. Sie können ihn erneut senden oder die Einwilligung vor Ort einholen.",
            "leadPost": "Dieser Patient erhält Rechnungen nur per Post. Die Einwilligung dafür gibt er auf Papier oder per QR-Code.",
            "leadNotNamed": "Die vorhandene Einwilligung gilt nicht für {{patient}} – jeder Patient braucht eine eigene. Lassen Sie sie neu unterschreiben; das Formular nennt alle Patienten des Empfängers. Erstellen können Sie die Rechnung auch ohne.",
            "postAlreadySigned": "Für den Postversand liegt sie bereits vor.",
            "present": "Patient ist in der Praxis",
            "absent": "Patient ist nicht da",
            "qr": "QR-Code zeigen",
            "qrHint": "Scannt mit dem Handy und unterschreibt dort",
            "qrTitle": "Einwilligung per QR-Code",
            "qrDialogHint": "Der Patient scannt den Code mit dem Handy, ergänzt seine Daten und unterschreibt. Das Fenster schließt sich, sobald die Einwilligung da ist.",
            "qrPostTitle": "Einwilligung zum Postversand",
            "qrPostHint": "Scannt mit dem Handy und unterschreibt die Einwilligung zum Postversand",
            "qrAlt": "QR-Code zur Einwilligung für {{name}}",
            "qrLoading": "QR-Code wird erstellt…",
            "waiting": "Wartet auf die Unterschrift…",
            "paper": "Auf Papier unterschreiben",
            "paperHint": "Formular drucken, Unterschrift bestätigen",
            "email": "Link per E-Mail senden",
            "emailAgain": "Link erneut per E-Mail senden",
            "emailConfirm": "Einwilligungslink für {{name}} senden an",
            "noEmail": "Keine E-Mail-Adresse hinterlegt",
            "sms": "Link per SMS senden",
            "smsAgain": "Link erneut per SMS senden",
            "smsCost": "0,09 €",
            "smsCostNote": "Diese SMS kostet 0,09 €. Der Link ist 30 Tage gültig.",
            "smsTo": "An",
            "smsLanguage": "Sprache",
            "noPhone": "Keine Telefonnummer hinterlegt",
            "send": "Senden",
            "sending": "Wird gesendet…",
            "emailSent": "Einwilligungslink an {{email}} gesendet.",
            "smsSent": "Einwilligungslink per SMS an {{phone}} gesendet.",
            "signed": "Einwilligung unterschrieben – die Rechnung kann versendet werden.",
            "paperSaved": "Einwilligung auf Papier gespeichert.",
            "errors": {
                "qr": "Der QR-Code konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
                "email": "Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
                "sms": "Die SMS konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
                "postOnly": "Dieser Patient erhält nur Post – die Einwilligung geht nur auf Papier oder per QR-Code."
            }
        },
        "treatment": {
            "doctor": "Behandelnde Ärztin / behandelnder Arzt",
            "doctorPlaceholder": "Bitte auswählen",
            "doctorStaffHint": "Rechnungen gehören immer einer Ärztin oder einem Arzt der Praxis.",
            "doctorOthersHint": "Sie dürfen Rechnungen auch für Kolleginnen und Kollegen erstellen – ohne Auswahl ist es Ihre eigene.",
            "doctorLoading": "Wird geladen …",
            "days": "Behandlungstage",
            "daysHint": "Für jeden Tag erfassen Sie im nächsten Schritt die Leistungen.",
            "removeDay": "{{date}} entfernen",
            "newDay": "Weiterer Behandlungstag",
            "addDay": "Tag hinzufügen",
            "noTreatmentDay": "Mindestens ein Behandlungstag ist nötig.",
            "treatmentInFuture": "Ein Behandlungstag liegt in der Zukunft.",
            "diagnoses": "Diagnosen",
            "diagnosisPlaceholder": "z. B. I10.90 Essentielle Hypertonie",
            "addDiagnosis": "Hinzufügen",
            "diagnosisHint": "Mit Enter übernehmen. Die Diagnosen stehen in dieser Reihenfolge auf der Rechnung.",
            "diagnosisSuggestions": "Vorschläge",
            "frequentDiagnoses": "Häufig verwendet",
            "icdCaption": "ICD-10-GM",
            "icdTerm": "auch: {{term}}",
            "icdSource": "Quelle: ICD-10-GM {{version}}, BfArM. Die Erstellung erfolgt unter Verwendung der maschinenlesbaren Fassung des BfArM.",
            "icdSourceLink": "Quellenangaben",
            "certainty": "Diagnosesicherheit",
            "certaintyNames": {
                "G": "gesichert",
                "V": "Verdacht auf",
                "A": "ausgeschlossen",
                "Z": "Zustand nach"
            },
            "side": "Seite",
            "addSide": "Seite angeben",
            "sideNames": {
                "R": "rechts",
                "L": "links",
                "B": "beidseitig"
            },
            "relatedTitle": "Oft zusammen eingetragen",
            "relatedAdd": "„{{text}}“ hinzufügen",
            "relatedReason": {
                "doctor": "Bei {{share}} % Ihrer Rechnungen mit „{{diagnosis}}“ ({{together}} von {{invoices}}).",
                "praxis": "Bei {{share}} % der Rechnungen Ihrer Praxis mit „{{diagnosis}}“ ({{together}} von {{invoices}})."
            },
            "removeDiagnosis": "„{{text}}“ entfernen",
            "noDiagnosis": "Bitte mindestens eine Diagnose eintragen – ohne Diagnose erstatten private Krankenversicherungen eine Rechnung meist nicht.",
            "summaryOneDay": "Behandlung am {{date}}",
            "summaryDays_one": "{{count}} Behandlungstag",
            "summaryDays_other": "{{count}} Behandlungstage",
            "summaryDiagnoses_zero": "Keine Diagnose",
            "summaryDiagnoses_one": "{{count}} Diagnose",
            "summaryDiagnoses_other": "{{count}} Diagnosen"
        },
        "services": {
            "dayTitle": "Behandlung am {{date}}",
            "emptyDay": "Für diesen Tag ist noch keine Leistung erfasst. Fügen Sie eine hinzu oder entfernen Sie den Tag im Schritt Behandlung.",
            "fixToContinue": "Bitte vervollständigen Sie die rot markierten Leistungen, um fortzufahren.",
            "problems": {
                "codeMissing": "GOÄ-Ziffer fehlt",
                "descriptionMissing": "Bezeichnung fehlt",
                "priceMissing": "Einfachsatz fehlt",
                "factorOutOfRange": "Faktor außerhalb des erlaubten Bereichs",
                "justificationMissing": "Über dem Schwellenwert ist eine Begründung nötig",
                "materialIncomplete": "Auslage ohne Bezeichnung oder Betrag"
            },
            "summaryLines_one": "{{count}} Leistung",
            "summaryLines_other": "{{count}} Leistungen",
            "summaryMaterial": "davon Auslagen {{amount}}"
        },
        "overview": "Übersicht",
        "overviewCollapse": "Übersicht einklappen",
        "overviewExpand": "Übersicht ausklappen",
        "summaryDone": "Erledigt",
        "summaryCurrent": "In Bearbeitung",
        "change": "Ändern",
        "back": "Zurück",
        "next": "Weiter",
        "footerWarnings_one": "{{count}} Hinweis zu den Leistungen – anzeigen",
        "footerWarnings_other": "{{count}} Hinweise zu den Leistungen – anzeigen",
        "total": "Summe",
        "create": "Erstellen",
        "noPermission": "Sie haben keine Berechtigung, Rechnungen zu erstellen. Bitte wenden Sie sich an die Praxis-Administration."
    },
    "invoices": {
        "title": "Rechnungen",
        "search": "Rechnung, Patient oder Betrag suchen",
        "upload": "Rechnung hochladen",
        "uploadHistory": "Upload-Verlauf",
        "uploadHistoryTitle": "Upload-Verlauf",
        "uploadHistoryEmpty": "Noch keine Uploads.",
        "uploadHistoryId": "Rechnungs-Nr.",
        "uploadHistoryPatient": "Patient",
        "uploadHistoryFile": "Datei",
        "uploadHistoryDate": "Datum",
        "uploadHistoryInvoices": "Rechnungen",
        "uploadHistoryAmount": "Betrag",
        "uploadHistoryStatus": "Status",
        "noFound": "keine Rechnung(en) gefunden",
        "overdueAt": "Überfällig seit {{date}}",
        "overdue": "Überfällig",
        "showPaid": "Bezahlte anzeigen",
        "showWrittenOff": "Abgeschriebene anzeigen",
        "lead": "<strong>{{total}} Rechnungen</strong> im Bestand. <em>{{open}} offen, {{overdue}} überfällig, {{unsent}} noch nicht versendet.</em>",
        "viewAll": "Alle",
        "viewOpen": "Offen",
        "viewOverdue": "Überfällig",
        "viewUnsent": "Nicht versendet",
        "viewPaid": "Bezahlt",
        "viewWrittenOff": "Abgeschrieben",
        "exportCsv": "CSV/DATEV exportieren",
        "sortLabel": "Sortierung: {{label}}",
        "daysOverdue": "{{days}} T überfällig",
        "daysOverdueWithFine": "{{days}} T überfällig · inkl. €{{fine}} Gebühr",
        "dueInDays": "fällig in {{days}} T",
        "createdAgo": "vor {{days}} T erstellt",
        "askedAgo": "vor {{days}} T gefragt",
        "paidAfterSent": "bezahlt {{date}} · {{days}} T nach Versand",
        "selectedCount": "{{count}} ausgewählt",
        "showingRange": "Zeige {{from}}–{{to}} von {{total}}",
        "send": "senden",
        "sendPortalLink": "Portallink senden",
        "sendViaPost": "per Post senden",
        "delete": "löschen",
        "view": "anzeigen",
        "selected": "ausgewählt",
        "addTags": "Tags hinzufügen",
        "bulkTagsApplied_one": "Tag zu {{count}} Rechnung hinzugefügt",
        "bulkTagsApplied_other": "Tag zu {{count}} Rechnungen hinzugefügt",
        "count_one": "{{count}} Rechnung",
        "count_other": "{{count}} Rechnungen",
        "perPage": "pro Seite:",
        "total": "gesamt",
        "selectAll": "alle auswählen",
        "filterPatients": "Nach Patientenname filtern",
        "patientAccountHint": "Rechnungsempfänger: {{account}}",
        "linkedAccountHolder": "Rechnungsempfänger für diesen Patienten",
        "ownerSystem": "Kein Arzt zugeordnet",
        "ownerUnknown": "Unbekannter Arzt",
        "ownerTitle": "Rechnung von {{name}}",
        "bulkSend": {
            "title": "{{count}} Portallink(s) senden",
            "willSend": "{{count}} werden erstmalig versendet",
            "willResend": "{{count}} bereits versendet — erhalten einen neuen Link",
            "noEmail": "{{count}} ohne E-Mail-Adresse",
            "postOnly": "{{count}} nur Brief (digitaler Versand deaktiviert)",
            "legalNotAccepted": "{{count}} warten auf unterzeichnete Einwilligung",
            "cannotSend": "{{count}} übersprungen (bezahlt oder abgeschrieben)",
            "done_one": "{{count}} Portallink gesendet",
            "done_other": "{{count}} Portallinks gesendet",
            "donePartial": "{{sent}} von {{total}} Portallinks gesendet — {{failed}} fehlgeschlagen",
            "donePartialReason": "{{sent}} von {{total}} Portallinks gesendet — {{failed}} fehlgeschlagen ({{reason}})"
        },
        "bulkLetter": {
            "title": "{{count}} Rechnung(en) per Post senden",
            "canSend": "{{count}} sendbar",
            "noAddress": "{{count}} ohne Adresse",
            "noConsent": "{{count}} ohne Einwilligung",
            "letterSent": "{{count}} bereits per Post versendet",
            "cannotSend": "{{count}} übersprungen (bezahlt oder abgeschrieben)",
            "pages": "Seiten",
            "cost": "Kosten",
            "total": "Gesamtkosten",
            "totalPartial": "Gesamtkosten (teilweise)",
            "done_one": "{{count}} Brief gesendet",
            "done_other": "{{count}} Briefe gesendet",
            "donePartial": "{{sent}} von {{total}} Briefen gesendet — {{failed}} fehlgeschlagen",
            "donePartialReason": "{{sent}} von {{total}} Briefen gesendet — {{failed}} fehlgeschlagen ({{reason}})"
        },
        "bulkDelete": {
            "title": "{{count}} Rechnung(en) löschen",
            "willDelete": "{{count}} werden gelöscht",
            "cannotDelete": "{{count}} können nicht gelöscht werden (versendet, bezahlt, abgeschrieben oder im Mahnverfahren)"
        },
        "csvExport": {
            "title": "CSV/DATEV exportieren",
            "step1": "Rechnungen filtern",
            "step2": "Spalten wählen",
            "fromDate": "Zeitraum von",
            "toDate": "Zeitraum bis",
            "status": "Status",
            "statusAll": "Alle Status",
            "statusOpen": "Offen",
            "statusPaid": "Bezahlt",
            "statusOverdue": "Überfällig",
            "statusWrittenOff": "Abgeschrieben",
            "amountMin": "Betrag ab (€)",
            "cancel": "Abbrechen",
            "next": "Weiter",
            "back": "Zurück",
            "export": "Exportieren",
            "invoiceCount": "{{count}} Rechnungen entsprechen den Kriterien",
            "formatCsv": "CSV",
            "formatCsvDesc": "Frei wählbare Spalten, öffnet in Excel",
            "formatExtf": "DATEV / EXTF",
            "formatExtfDesc": "Buchungsstapel-Datei für Ihren Steuerberater",
            "checkingReadiness": "DATEV-Einstellungen werden geprüft…",
            "datevReady": "DATEV-Einstellungen sind konfiguriert — bereit zum Export.",
            "datevNotReady": "DATEV-Einstellungen sind unvollständig.",
            "datevGoToSettings": "Zu Einstellungen → DATEV",
            "columnsHint": "Wählen Sie, welche Spalten im Export enthalten sein sollen.",
            "selectAll": "Alle auswählen",
            "selectNone": "Alle abwählen",
            "columnsSelected": "{{count}} Spalten ausgewählt",
            "colInvoiceNr": "Rechnungsnr.",
            "colDate": "Datum",
            "colDueDate": "Fälligkeitsdatum",
            "colPatient": "Patient",
            "colRecipient": "Empfänger",
            "colAmount": "Betrag (€)",
            "colPaid": "Bezahlt (€)",
            "colStatus": "Status",
            "colDunning": "Mahnstufe",
            "colTag": "Tag"
        }
    },
    "praxisSoftwareSync": {
        "title": "Praxissoftware-Synchronisation",
        "openSettings": "Einstellungen öffnen",
        "description": "Patientendaten (GDT) und Rechnungsdateien (.dat / PADneXt .xml) automatisch aus den lokalen Exportordnern Ihrer Praxissoftware synchronisieren — ohne manuellen Upload. Nur Chrome/Edge.",
        "unsupportedBrowser": "Diese Funktion erfordert Chrome oder Edge. Bitte weiterhin den manuellen Upload auf der Rechnungen-Seite in diesem Browser nutzen.",
        "gdtFolder": "Patientendaten-Ordner (GDT)",
        "datFolder": "Rechnungsdaten-Ordner (.dat, PADneXt .xml)",
        "connected": "Verbunden",
        "notConnected": "Nicht verbunden",
        "needsReconnect": "Berechtigung erforderlich",
        "folderNotFound": "{{folder}} wurde nicht gefunden — er wurde möglicherweise umbenannt, verschoben oder gelöscht. Bitte erneut verbinden.",
        "checkingConnection": "Wird geprüft…",
        "connectBtn": "Ordner verbinden",
        "reconnectBtn": "Erneut verbinden",
        "disconnectBtn": "Ordner trennen",
        "syncNow": "Jetzt synchronisieren",
        "syncing": "Synchronisiere…",
        "uploading": "Lade hoch",
        "processing": "Verarbeite",
        "lastSync": "Letzte Synchronisation",
        "logUploaded": "Hochgeladen",
        "logInvoicesUploaded_one": "{{count}} Rechnung hochgeladen",
        "logInvoicesUploaded_other": "{{count}} Rechnungen hochgeladen",
        "logPatientCreated": "Patient angelegt",
        "logPatientCreatedNeedsRecipient": "Patient angelegt — Rechnungsempfänger muss zugewiesen werden (minderjährig, keine erziehungsberechtigte Person in den Quelldaten)",
        "logPatientUpdated": "Patient aktualisiert",
        "logSkipped": "Übersprungen — nächstes Mal erneut zur Bestätigung vorgelegt",
        "unknownError": "Unbekannter Fehler",
        "nothingToSync": "Keine neuen oder geänderten Dateien gefunden.",
        "syncAlreadyRunning": "Eine Synchronisation läuft bereits — bitte einen Moment warten.",
        "blockingTitle": "Synchronisation mit der Praxissoftware läuft…",
        "blockingStep": "Datei {{index}} von {{total}}",
        "blockingWarning": "Bitte diese Seite nicht verlassen oder den Tab schließen, bis die Synchronisation abgeschlossen ist.",
        "badgeSyncing": "Synchronisation mit der Praxissoftware läuft…",
        "badgeDone": "Fertig — Daten sind aktuell",
        "reviewTitleNew": "Neuer Patient aus der Praxissoftware",
        "reviewTitleUpdate": "Aktualisierter Patient aus der Praxissoftware",
        "reviewAlreadyImportedBadge": "Bereits importiert",
        "reviewPatientSummaryHeading": "Aus der Praxissoftware",
        "reviewRecipientHeading": "Rechnungsempfänger",
        "reviewSelfDisabledMinor": "Dieser Patient ist minderjährig — bitte einen Rechnungsempfänger auswählen oder anlegen.",
        "reviewRecipientRequired": "Bitte einen Rechnungsempfänger auswählen oder anlegen.",
        "reviewContinue": "Weiter",
        "reviewRecipientLater": "Später zuweisen",
        "reviewCancel": "Import abbrechen",
        "reviewAdd": "Hinzufügen",
        "reviewSave": "Speichern",
        "reviewAddConsentBtn": "Hinzufügen und Einwilligung senden",
        "reviewSaveConsentBtn": "Speichern und Einwilligung senden",
        "reviewAgentProcessed": "Dieser Patient wurde bereits um {{time}} Uhr von der Desktop-App verarbeitet.",
        "reviewQrTitle": "Zum Abschluss der Einwilligung scannen",
        "reviewQrLead": "Lassen Sie den Patienten diesen Code mit dem Handy scannen, um die Einwilligung direkt vor Ort zu unterschreiben.",
        "reviewQrFailed": "QR-Code konnte nicht erzeugt werden. Der Patient wurde trotzdem gespeichert — die Einwilligung kann von der Patienten-Seite aus gesendet werden.",
        "logConsentSent": "Einwilligungs-Link gesendet",
        "logConsentFailed": "Einwilligungs-Link fehlgeschlagen ({{reason}})",
        "logImportCancelled": "Import abgebrochen — Patient rückgängig gemacht",
        "logCancelFailed": "Abbrechen fehlgeschlagen ({{reason}})",
        "logRecipientAssigned": "Rechnungsempfänger zugewiesen",
        "autoParseLabel": "Automatisches Verarbeiten der verbundenen Ordnerdaten erlauben",
        "autoParseOnNote": "Automatische Verarbeitung ist an (Einstellungen → Praxissoftware-Synchronisation).",
        "autoParseOffNote": "Automatische Verarbeitung ist aus — neue Dateien warten auf Bestätigung (Einstellungen → Praxissoftware-Synchronisation).",
        "autoParseDesc": "Wenn aktiviert, werden neue oder geänderte Dateien automatisch verarbeitet. Wenn deaktiviert (Standard), wird vor jeder neuen oder geänderten Datei um Bestätigung gebeten.",
        "confirmTitle": "Neue Dateien gefunden",
        "confirmIntro_one": "{{count}} neue oder geänderte Datei wurde gefunden. Mit der Verarbeitung beginnen?",
        "confirmIntro_other": "{{count}} neue oder geänderte Dateien wurden gefunden. Mit der Verarbeitung beginnen?",
        "confirmTitleRecheck": "Erneute Prüfung bereits verarbeiteter Dateien",
        "confirmIntroRecheck_one": "{{count}} Datei wurde erneut geprüft — sie wurde bereits zuvor verarbeitet und hat sich nicht geändert. Trotzdem mit der Verarbeitung beginnen?",
        "confirmIntroRecheck_other": "{{count}} Dateien wurden erneut geprüft — sie wurden bereits zuvor verarbeitet und haben sich nicht geändert. Trotzdem mit der Verarbeitung beginnen?",
        "confirmAlreadyProcessed": "Bereits verarbeitet",
        "confirmAlreadyProcessedHint": "Diese Datei wurde bereits zuvor verarbeitet und hat sich seitdem nicht geändert.",
        "confirmDecline": "Nicht jetzt",
        "confirmStart": "Verarbeitung starten",
        "resultsTitle": "Ergebnisse der Synchronisation",
        "summaryInvoices": "Rechnungen",
        "summaryAccountPatients": "Empfänger",
        "summaryLinkedPatients": "Verknüpfte Patienten",
        "summaryTotal": "Gesamtbetrag",
        "summarySamePerson": "{{count}} Rechnung: behandelter Patient ist Rechnungsempfänger",
        "summarySamePerson_other": "{{count}} Rechnungen: behandelter Patient ist Rechnungsempfänger",
        "duplicateUploadSame": "Diese Datei haben Sie bereits am {{date}} hochgeladen.",
        "duplicateUploadOther": "Diese Datei wurde bereits von {{name}} am {{date}} hochgeladen.",
        "duplicateUploadUnknownDoctor": "einem anderen Mitglied der Praxis",
        "emailsSent": "{{count}} E-Mail versendet",
        "emailsSent_other": "{{count}} E-Mails versendet",
        "emailsFailed": "{{count}} Versand fehlgeschlagen – bitte manuell senden",
        "emailsFailed_other": "{{count}} Versände fehlgeschlagen – bitte manuell senden",
        "sendFailuresTitle": "Diese Rechnungen wurden nicht versendet",
        "sendFailureReasonNO_RECIPIENT_EMAIL": "Keine E-Mail-Adresse hinterlegt",
        "sendFailureReasonLEGAL_NOT_ACCEPTED": "Einwilligung noch nicht unterschrieben — zuerst versenden",
        "sendFailureReasonPOST_ONLY": "Patient ist als \"Nur Post\" markiert",
        "sendFailureReasonEMAIL_FAILED": "E-Mail-Zustellung fehlgeschlagen",
        "sendFailureReasonUnknown": "Konnte nicht versendet werden",
        "whatsNextMissingEmailBody": "Ergänzen Sie die Patienten — mindestens ein aus diesem Import angelegtes Konto hat noch keine E-Mail-Adresse. Ohne E-Mail können keine Rechnungen, Portal-Links oder Fragebögen versendet werden.",
        "whatsNextNeedsRecipientBody_one": "1 Patient wurde ohne Rechnungsempfänger synchronisiert — er/sie ist minderjährig und der Datensatz der Praxissoftware enthielt keine erziehungsberechtigte Person. Weisen Sie vor der Abrechnung einen Empfänger zu.",
        "whatsNextNeedsRecipientBody_other": "{{count}} Patienten wurden ohne Rechnungsempfänger synchronisiert — sie sind minderjährig und der Datensatz der Praxissoftware enthielt keine erziehungsberechtigte Person. Weisen Sie vor der Abrechnung einen Empfänger zu.",
        "whatsNextPatientsCta": "Zu den Patienten",
        "patientsSyncedTitle": "{{count}} Patient synchronisiert",
        "patientsSyncedTitle_other": "{{count}} Patienten synchronisiert",
        "badgeCreated": "Neu",
        "badgeUpdated": "Aktualisiert",
        "badgeNeedsRecipient": "Empfänger fehlt",
        "filesFailedTitle": "Diese Dateien sind fehlgeschlagen",
        "confirmDisconnect": "{{folder}} trennen? Medinvoice liest diesen Ordner erst nach erneutem Verbinden wieder.",
        "confirmBreakdownPatients": "{{count}} Patientendatei (GDT)",
        "confirmBreakdownPatients_other": "{{count}} Patientendateien (GDT)",
        "confirmBreakdownInvoices": "{{count}} Rechnungsdatei (.dat)",
        "confirmBreakdownInvoices_other": "{{count}} Rechnungsdateien (.dat)",
        "gdtFolderShort": "Patientendaten",
        "datFolderShort": "Rechnungsdaten",
        "panelTitle": "Praxissoftware-Synchronisation",
        "dashboardNudge": "Verbinde die Exportordner deiner Praxissoftware, um Patienten- und Rechnungsdaten automatisch zu synchronisieren — ohne manuellen Upload.",
        "pendingBadge": "{{count}} Datei wartet auf Bestätigung",
        "pendingBadge_other": "{{count}} Dateien warten auf Bestätigung",
        "panelNoActivity": "Noch keine Aktivität",
        "goToPage": "Synchronisation öffnen",
        "pageLeadConnected": "Zuletzt synchronisiert: {{datetime}}.",
        "activityTitle": "Aktivität",
        "logColTime": "Zeit",
        "logColType": "Typ",
        "logColFile": "Datei",
        "logColResult": "Ergebnis",
        "clearLog": "Leeren",
        "confirmClearLog": "Aktivitätsprotokoll leeren? Dies entfernt nur den hier angezeigten Verlauf — synchronisierte Patienten oder Rechnungen sind nicht betroffen."
    },
    "devices": {
        "title": "Geräteverwaltung",
        "description": "Mit dieser Praxis verbundene Desktop-Apps. Die Desktop-App überwacht den Exportordner Ihrer Praxissoftware und übernimmt Patienten automatisch, ohne dass ein Browser-Tab geöffnet sein muss.",
        "rowTitle": "Registrierte Geräte",
        "rowDesc": "Erzeugen Sie einen einmaligen Code, um ein neues Gerät zu registrieren, oder verwalten Sie bestehende unten.",
        "generateBtn": "Registrierungscode erzeugen",
        "generating": "Wird erzeugt…",
        "refreshBtn": "Aktualisieren",
        "enrollmentCodeLabel": "Registrierungscode",
        "renewalCodeLabel": "Erneuerungscode",
        "codeExpires": "Läuft ab: {{time}}",
        "copyBtn": "Kopieren",
        "copied": "Kopiert",
        "copyError": "Konnte nicht in die Zwischenablage kopiert werden.",
        "loadError": "Geräte konnten nicht geladen werden.",
        "generateError": "Registrierungscode konnte nicht erzeugt werden.",
        "renewError": "Erneuerungscode konnte nicht erzeugt werden.",
        "revokeError": "Gerät konnte nicht widerrufen werden.",
        "deleteError": "Gerät konnte nicht gelöscht werden.",
        "emptyState": "Noch keine Geräte registriert.",
        "neverSeen": "Nie",
        "detailsApp": "Desktop-App {{version}}",
        "detailsGdt": "GDT {{version}}",
        "colLabel": "Gerät",
        "colLastSeen": "Zuletzt gesehen",
        "colStatus": "Status",
        "colExpires": "Läuft ab",
        "colShared": "Gemeinsamer PC",
        "colActions": "Aktionen",
        "sharedLabel": "Gemeinsamer PC",
        "sharedHint": "Mehrere Ärzt/innen nutzen diesen PC — die Desktop-App fragt bei jedem Import, für welchen Arzt/welche Ärztin er ist, statt automatisch die Person anzunehmen, die das Gerät registriert hat.",
        "sharedToggleError": "Konnte nicht aktualisiert werden — bitte erneut versuchen.",
        "status": {
            "active": "Aktiv",
            "expiring_soon": "Bald erneuern",
            "expired": "Abgelaufen",
            "revoked": "Widerrufen"
        },
        "connection": {
            "connected": "Verbunden",
            "notConnected": "Nicht verbunden"
        },
        "renewBtn": "Erneuern",
        "renewing": "Wird erneuert…",
        "revokeBtn": "Widerrufen",
        "revokeConfirm": "\"{{label}}\" widerrufen? Der Zugriff wird sofort entzogen und kann nicht rückgängig gemacht werden.",
        "deleteBtn": "Löschen",
        "deleteConfirm": "\"{{label}}\" löschen? Dies entfernt es vollständig, einschließlich seines Verbindungsverlaufs, und kann nicht rückgängig gemacht werden. Nur möglich, solange es nicht aktuell verbunden ist."
    },
    "syncMethod": {
        "prompt": "Wie sollen Patientendateien zu Medinvoice gelangen? Wählen Sie eine Methode.",
        "status": {
            "folderConnected": "Ordner verbunden",
            "notSetUp": "Nicht eingerichtet",
            "unsupported": "In diesem Browser nicht unterstützt",
            "devicesConnected_one": "{{count}} Gerät verbunden",
            "devicesConnected_other": "{{count}} Geräte verbunden",
            "notConnected": "Nicht verbunden",
            "paused": "Pausiert"
        },
        "pausedBanner": "Die Synchronisation über die Desktop-App ist pausiert — es wird nichts importiert, bis dies unter Einstellungen → Praxissoftware-Synchronisation wieder ausgeschaltet wird.",
        "label": "Synchronisationsmethode",
        "browser": {
            "title": "Im Browser",
            "caption": "Liest die Exportordner, solange Medinvoice in einem Tab geöffnet ist. Verarbeitet Patienten- und Rechnungsdateien."
        },
        "agent": {
            "title": "Desktop-App (Windows)",
            "caption": "Läuft im Hintergrund auf dem Praxis-PC — kein Tab nötig. Patientendateien, auf Wunsch auch Rechnungsdateien."
        },
        "leadAgent": "Installieren Sie die Desktop-App auf dem Praxis-PC, dann übernimmt sie Patientendateien selbstständig.",
        "unsupportedBrowser": "Dieser Browser kann keine Ordner lesen, daher brauchen Patientendateien einen anderen Weg — siehe unten.",
        "unsupported": {
            "title": "Dieser Browser kann keine Ordner lesen",
            "titleNamed": "{{browser}} kann keine Ordner lesen",
            "text": "Die Synchronisation aus dem Exportordner Ihrer Praxissoftware im Browser erfordert Chrome, Edge oder einen anderen Chromium-Browser. Firefox und Safari bieten keinen Ordnerzugriff.",
            "optionBrowser": "Öffnen Sie Medinvoice in Chrome, Edge, Opera oder Vivaldi auf diesem Computer und verbinden Sie dort den Ordner.",
            "optionApp": "Oder installieren Sie die Desktop-App auf dem Praxis-PC (Windows). Sie übernimmt Patientendateien im Hintergrund und funktioniert mit jedem Browser.",
            "cta": "Desktop-App verwenden",
            "hint": "Rechnungsdateien (.dat / PADneXt .xml) können weiterhin manuell auf der Rechnungen-Seite hochgeladen werden, in jedem Browser."
        },
        "agentNeedsAdmin": "Nur Ärzte, Administratoren oder Personen mit Einstellungsrecht können die Desktop-App einrichten. Bitten Sie sie, diesen PC zu registrieren.",
        "invoiceNote": "Die Desktop-App kann auch Rechnungsdateien (.dat / PADneXt .xml) überwachen, wenn Sie beim Verbinden einen Rechnungsordner angegeben haben. Rechnungen lieber im Browser synchronisieren?",
        "invoiceNoteAction": "Zum Browser wechseln"
    },
    "praxisSoftwareSyncSettings": {
        "description": "Gemeinsame Richtlinie für die Synchronisation im Browser und die Desktop-App. Live-Verbindungsstatus, Ordner und Geräte finden Sie auf der Seite Praxissoftware-Synchronisation — siehe Navigation.",
        "loadError": "Diese Einstellungen konnten nicht geladen werden.",
        "saveError": "Diese Einstellungen konnten nicht gespeichert werden.",
        "autoParseTitle": "Neue Dateien automatisch verarbeiten",
        "autoParseDesc": "Neue oder geänderte Rechnungsdateien (PAD/PADneXt) werden automatisch übernommen. Der gewohnte Upload-Dialog erscheint.",
        "autoSendConsentTitle": "Einwilligung automatisch versenden",
        "autoSendConsentDesc": "Benötigt ein synchronisierter Patient eine Einwilligung und eine E-Mail-Adresse ist vorhanden, kann der Link sofort aus dem Dialog heraus versendet werden. Gilt aktuell nur für die Desktop-App.",
        "syncPausedTitle": "Synchronisation der Desktop-App pausieren",
        "syncPausedDesc": "Verhindert, dass die Desktop-App etwas importiert, ohne ein Gerät zu widerrufen. Zum Fortsetzen einfach wieder ausschalten — nichts muss neu registriert werden.",
        "importTitle": "Rechnungsdatei übernehmen",
        "matrixTitle": "Was passiert, wenn …",
        "matrixDesc": "Legen Sie für jedes Ereignis fest, ob es in der Patientenakte Ihrer Praxissoftware abgelegt wird und ob dazu ein Pop-up auf diesem PC erscheint.",
        "colEvent": "Ereignis",
        "colPractice": "Praxissoftware",
        "colPopup": "Pop-up auf diesem PC",
        "consentTitle": "Unterschriebene Einwilligung",
        "consentHint": "Der Patient unterschreibt die Einwilligung",
        "invoiceSentTitle": "Rechnung versendet",
        "invoiceSentHint": "Die Rechnungs-E-Mail geht an den Patienten",
        "paidTitle": "Rechnung bezahlt",
        "paidHint": "Die Rechnung ist vollständig bezahlt"
    },
    "syncHowItWorks": {
        "button": "So funktioniert's",
        "title": "So funktioniert die Synchronisation",
        "aboutTitle": "Was bedeutet das?",
        "about": "Die Praxissoftware-Synchronisation überträgt die Patienten- und Rechnungsdaten, die Ihre Praxissoftware bereits exportiert hat, automatisch in Medinvoice. Es gibt zwei Wege: mittels Browser oder mit der Desktop-App für Windows.",
        "done": "Verstanden",
        "tabsLabel": "Methode wählen",
        "factsCovers": "Liest",
        "factsNeeds": "Voraussetzung",
        "factsRuns": "Läuft",
        "browser": {
            "tab": "Im Browser",
            "facts": {
                "covers": "Patienten- und Rechnungsdateien",
                "needs": "Chrome, Edge oder ein anderer Chromium-Browser (Opera, Vivaldi …) — nicht Firefox oder Safari",
                "runs": "Nur, solange Medinvoice in einem Tab geöffnet ist"
            },
            "note": "Bei geschlossenem Tab wird nichts importiert."
        },
        "agent": {
            "tab": "Desktop-App (Windows)",
            "facts": {
                "covers": "Patientendateien (GDT), auf Wunsch auch Rechnungsdateien",
                "needs": "Windows 10 oder 11, beliebiger Browser",
                "runs": "Im Hintergrund, kein Tab nötig"
            },
            "note": "Der automatische Import wird für Ihre Umgebung separat freigeschaltet. Meldet die App, dass er deaktiviert ist, wenden Sie sich an den Support."
        }
    },
    "syncGuide": {
        "analogy": "Medinvoice wird an Ihre Praxissoftware angebunden wie ein EKG- oder Spirometrie-Gerät: Die Praxissoftware legt die Patientendaten als GDT-Datei in einen Ordner, Medinvoice holt sie dort ab. Das Übermitteln der Rechnungsdatei funktioniert genauso, über den Privatabrechnungs-Export (PAD / PADneXt).",
        "clipLabel": "Kurzvideo: {{title}}",
        "gdtHelp": {
            "question": "Sie wissen nicht, wie Sie das GDT-Gerät und den Ordner in Ihrer Praxissoftware einrichten?",
            "contact": "Schreiben Sie uns an",
            "subject": "mit dem Betreff „{{subject}}“ – wir helfen Ihnen weiter."
        },
        "jump": {
            "devices": "Zum Download und Registrierungscode",
            "folders": "Zu den Ordnern"
        },
        "phases": {
            "prepare": {
                "title": "Praxissoftware vorbereiten",
                "lead": "Einmalig richten Sie oder Ihr Praxissoftware-Betreuer ein GDT-Gerät „Medinvoice“ ein, das Patientendaten in einen Ordner schreibt.",
                "items": {
                    "invoices": "Rechnungen (optional): den Privatabrechnungs-Export (PAD / PADneXt) in einen eigenen Ordner schreiben lassen."
                }
            },
            "install": {
                "title": "Desktop-App installieren",
                "lead": "Empfehlung: Die Desktop-App sollte für den Rückschrieb auf dem Synchronisations-PC installiert werden. Auf weiteren Clients, die für das Onboarding der Patienten verwendet werden, ebenfalls installieren.",
                "items": {
                    "download": "Auf der Synchronisationsseite unter „Geräteverwaltung“ auf „Für Windows herunterladen“ klicken und die heruntergeladene Datei öffnen.",
                    "smartscreen": "Erscheint „Der Computer wurde durch Windows geschützt“ → auf „Weitere Informationen“ → „Trotzdem ausführen“ klicken. Als Herausgeber muss „exipnon GmbH“ stehen.",
                    "autostart": "Den Haken bei „Start Medinvoice Desktop-App automatically when Windows starts“ gesetzt lassen. Die Desktop-App läuft dann nach jedem Neustart im Hintergrund mit."
                }
            },
            "connect": {
                "title": "Mit Medinvoice verbinden",
                "lead": "Am Ende der Installation startet die App und öffnet in Ihrem Browser einen neuen Tab „Medinvoice mit Ihrer Praxissoftware verbinden“.",
                "items": {
                    "code": "Auf der Synchronisationsseite auf „Registrierungscode erzeugen“ klicken und den Code kopieren. Er gilt einmalig und 30 Minuten lang.",
                    "setupTab": "Im neuen Tab den Code einfügen. Ist der Tab geschlossen: Rechtsklick auf das Medinvoice-Symbol in der Taskleiste → „Einstellungen / Verbindung…“.",
                    "folders": "Den GDT-Exportordner aus Schritt 1 wählen, optional den Rechnungsordner und einen PDF-Ordner für den Import der Dokumente (unterschriebene Einwilligung etc.). Dann auf „Verbinden“ klicken.",
                    "sharedPc": "Teilen sich mehrere Ärztinnen und Ärzte diesen PC? Dann zu „Registrierte Geräte“ gehen → „Gemeinsamer PC“ aktivieren — die Desktop-App fragt dann bei jedem Upload der Rechnungsdatei, welcher Ärztin oder welchem Arzt sie zugeordnet werden soll.",
                    "test": "Testen: einen Patienten an das Gerät „Medinvoice“ senden — innerhalb weniger Sekunden öffnet sich ein Tab. Kommt nichts: Rechtsklick auf das Symbol → „Jetzt synchronisieren“."
                }
            },
            "daily": {
                "title": "Ablauf im Praxisalltag",
                "lead": "Klick auf den Button der Schnittstelle „Medinvoice“ → Ihre Praxissoftware legt eine Patientendatei (GDT) in den zuvor definierten Ordner ab → die Desktop-App übernimmt die Daten automatisch. Medinvoice muss dafür nicht geöffnet sein. Es öffnet sich ein Dialog in einem separaten Fenster.",
                "items": {
                    "extras": "Unterschriebene Einwilligungen kann die App als PDF an Ihre Praxissoftware zurückgeben — dafür muss der GDT-Import eingerichtet sein. Einzustellen unter Einstellungen → Praxissoftware-Synchronisation."
                }
            },
            "connectBrowser": {
                "title": "Ordner verbinden",
                "lead": "Direkt hier auf dieser Seite, auf dem PC, der den Exportordner sieht.",
                "items": {
                    "browser": "Nutzen Sie Chrome, Edge, Opera oder Vivaldi. Firefox und Safari können keine Ordner lesen.",
                    "connect": "Beim „Patientendaten-Ordner“ auf „Ordner verbinden“ klicken und den GDT-Exportordner aus Schritt 1 wählen. Für Rechnungen dasselbe beim „Rechnungsdaten-Ordner“.",
                    "allow": "Fragt der Browser, ob Medinvoice den Ordner ansehen darf, auf „Dateien ansehen“ bzw. „Zulassen“ klicken. Medinvoice liest nur die gewählten Ordner.",
                    "test": "Testen: einen Patienten an das Gerät „Medinvoice“ senden — innerhalb einer Minute meldet sich Medinvoice in diesem Tab."
                }
            },
            "dailyBrowser": {
                "title": "Im Praxisalltag",
                "lead": "Neue Dateien werden erkannt, solange Medinvoice auf diesem PC in einem Tab geöffnet ist. Bei geschlossenem Tab wird nichts übernommen.",
                "items": {
                    "keepOpen": "Medinvoice morgens öffnen und den Tab offen lassen. Fragt der Browser nach einem Neustart erneut, auf „Erneut verbinden“ klicken.",
                    "export": "Senden Sie den Patienten in Ihrer Praxissoftware an das Gerät „Medinvoice“ — die Datei landet im Ordner und Medinvoice meldet sich.",
                    "confirm": "Ohne automatisches Verarbeiten fragt Medinvoice kurz nach, bevor neue Dateien gelesen werden.",
                    "review": "Für jeden Patienten öffnet sich in diesem Tab ein Fenster: Angaben prüfen, Rechnungsempfänger wählen, fertig. „Import abbrechen“ macht alles rückgängig."
                }
            }
        },
        "pvs": {
            "tested": "Bereits getestet mit MEDICAL OFFICE (T2med, tomedo und medatixx folgen in Kürze).",
            "specTitle": "Benötigte Werte",
            "spec": {
                "name": {
                    "label": "Gerätename",
                    "value": "z. B. Medinvoice",
                    "hint": "Frei wählbar, damit Sie es später wiederfinden."
                },
                "satzart": {
                    "label": "Satzart",
                    "value": "6301 – Stammdaten übermitteln",
                    "hint": "Manchmal auch „Patientendaten senden“. 6302 funktioniert ebenfalls."
                },
                "folder": {
                    "label": "Exportordner",
                    "value": "z. B. C:\\Medinvoice\\GDT",
                    "hint": "Genau diesen Ordner wählen Sie danach in Medinvoice."
                },
                "fileName": {
                    "label": "Dateiname",
                    "value": "z. B. für MEDICAL OFFICE: MO2MEDI.GDT\nz. B. für T2med: T2med2MEDI.*",
                    "hint": "Fragt Ihre Software danach: Die Datei muss auf .gdt enden oder auf eine Nummer wie .001 — andere Dateien liest Medinvoice nicht."
                },
                "returnFolder": {
                    "label": "Rückschrieb (Import ins PVS)",
                    "value": "Bsp. für einen Import-Ordner in MEDICAL OFFICE: C:\\GDT",
                    "hint": "Optional, nur Desktop-App: ein eigener Ordner für Dokumente, die in die Praxissoftware zurück übermittelt werden, z. B. C:\\GDT\\Medinvoice-PDF."
                }
            }
        },
        "tray": {
            "title": "Das Symbol in der Taskleiste",
            "caption": "Rechts unten neben der Uhr, oft versteckt hinter dem Pfeil ^. Tipp: Symbol aus dem Pfeil-Menü auf die Taskleiste ziehen, dann ist es immer sichtbar.",
            "legendLabel": "Status des Symbols",
            "menu": "Rechtsklick auf das Symbol öffnet das Menü: „Jetzt synchronisieren“ prüft den Ordner sofort, „Einstellungen / Verbindung…“ öffnet die Einrichtung (Ordner ändern ohne neuen Code, oder mit Code erneuern), „Beenden“ beendet die App.",
            "states": {
                "running": {
                    "label": "Läuft",
                    "meaning": "Grün — läuft",
                    "todo": "Alles in Ordnung, nichts zu tun."
                },
                "enrolling": {
                    "label": "Noch nicht verbunden",
                    "meaning": "Grau — noch nicht verbunden",
                    "todo": "Einrichtung abschließen (Schritt 3)."
                },
                "renewSoon": {
                    "label": "Verbindung bald erneuern",
                    "meaning": "Orange — Zugang läuft bald ab",
                    "todo": "In der Geräteliste „Erneuern“ klicken und den Code über „Einstellungen / Verbindung…“ einfügen."
                },
                "revoked": {
                    "label": "Neu verbinden nötig",
                    "meaning": "Rot — Zugang abgelaufen oder widerrufen",
                    "todo": "Mit einem neuen Registrierungscode erneut verbinden."
                },
                "attention": {
                    "label": "Ein Patient muss geprüft werden",
                    "meaning": "Blau — ein Patient braucht Ihre Entscheidung",
                    "todo": "Auf dieser Seite unter „Braucht Ihre Aufmerksamkeit“ ansehen."
                }
            }
        },
        "reviewTab": {
            "title": "Ein neuer Tab für jeden Patienten",
            "otherTab": "Medinvoice – Rechnungen",
            "newBadge": "Neu",
            "caption": "Für jede neue Patientendatei öffnet die App einen Tab in Ihrem Standardbrowser: Angaben prüfen, dann „Hinzufügen“ — oder „Hinzufügen und Einwilligung senden“, falls noch keine Einwilligung vorliegt. Der Patient ist da schon gespeichert; „Import abbrechen“ macht ihn rückgängig. Der Tab schließt sich danach von selbst. Bei Rechnungsdateien öffnet sich genauso ein Tab „Datei hochladen“ für den Rechnungs-Upload."
        },
        "glossary": {
            "title": "Begriffe kurz erklärt",
            "gdt": {
                "term": "GDT",
                "text": "Gerätedatentransfer — der Standard, über den Praxissoftware Patientendaten an Geräte wie EKG oder Spirometer übergibt. Medinvoice nutzt denselben Weg."
            },
            "pad": {
                "term": "PAD / PADneXt",
                "text": "Exportformate für die Privatabrechnung, wie sie auch Abrechnungsstellen bekommen. PAD ist das ältere Format (.dat), PADneXt das neuere (.xml)."
            },
            "exportFolder": {
                "term": "Exportordner",
                "text": "Der Ordner, in den Ihre Praxissoftware diese Dateien schreibt. Medinvoice liest nur diesen Ordner — sonst nichts auf dem PC."
            },
            "tray": {
                "term": "Taskleiste / Infobereich",
                "text": "Die Leiste am unteren Bildschirmrand. Rechts neben der Uhr sitzen kleine Symbole laufender Programme — dort auch das der Medinvoice-App."
            },
            "code": {
                "term": "Registrierungscode",
                "text": "Ein Einmal-Code, mit dem sich die Desktop-App bei Ihrer Praxis anmeldet. Gilt 30 Minuten; danach einfach einen neuen erzeugen."
            }
        }
    },
    "agentDownload": {
        "rowTitle": "Desktop-App für Windows",
        "rowDesc": "Installieren Sie ihn auf dem Rechner, auf dem Ihre Praxissoftware läuft, und registrieren Sie ihn dann mit einem Code von unten. Er übernimmt Dateien, sendet unterschriebene Einwilligungen zurück an die Praxissoftware und kann kurze Pop-ups anzeigen.",
        "btn": "Für Windows herunterladen",
        "version": "Version {{version}}",
        "unavailable": "Das Installationsprogramm steht noch nicht zum Download bereit.",
        "privacy": "Datenschutzhinweise zur Desktop-App"
    },
    "paperConsentRequests": {
        "title": "Einwilligung auf Papier angefragt",
        "description": "Patienten, die den QR-Code gescannt und statt der digitalen Unterschrift lieber Papier gewählt haben.",
        "born": "Geboren {{date}}",
        "handledBtn": "Erledigt",
        "handledError": "Konnte nicht als erledigt markiert werden."
    },
    "identityReviews": {
        "title": "Abweichende Angaben — Prüfung erforderlich",
        "description": "Patienten, die beim Ausfüllen des Fragebogens einen anderen Namen oder eine andere Adresse angegeben haben als im System hinterlegt."
    },
    "agentAttention": {
        "title": "Braucht Ihre Aufmerksamkeit",
        "description": "Patienten, die die Desktop-App selbstständig übernommen hat, und Importe, die sie zurückgehalten hat.",
        "ambiguousTitle": "Zurückgehalten — zwei Patienten passen",
        "ambiguousHint": "Die Desktop-App hat diese nicht importiert, weil mehr als ein vorhandener Patient denselben Namen und dasselbe Geburtsdatum hat. Öffnen Sie die Patienten und entfernen oder führen Sie das Duplikat zusammen; der nächste Export Ihrer Software wird dann normal importiert.",
        "unknownPatient": "Unbekannter Patient",
        "born": "Geboren {{date}}",
        "externalId": "Software-ID {{id}}",
        "candidates": "Vorhandene Patienten:",
        "candidateLink": "Patient {{n}}",
        "dismissBtn": "Ausblenden",
        "dismissError": "Eintrag konnte nicht ausgeblendet werden.",
        "undoTitle": "Kürzlich importiert — kann rückgängig gemacht werden",
        "created": "Neuer Patient angelegt",
        "updated": "Bestehender Patient aktualisiert",
        "minutesLeft_one": "noch {{count}} Min. zum Rückgängigmachen",
        "minutesLeft_other": "noch {{count}} Min. zum Rückgängigmachen",
        "undoBtn": "Rückgängig",
        "undoConfirm": "Import von {{name}} rückgängig machen? Ein neu angelegter Patient wird wieder entfernt, ein aktualisierter Patient erhält die vorherigen Werte zurück.",
        "undoAlreadyDone": "Dieser Import wurde bereits rückgängig gemacht.",
        "undoExpired": "Das Zeitfenster zum Rückgängigmachen ist abgelaufen.",
        "undoNotFound": "Dieser Import wurde nicht gefunden.",
        "undoError": "Import konnte nicht rückgängig gemacht werden."
    },
    "cardQr": {
        "button": "Kartenzahlung per QR",
        "title": "Kartenzahlung – Rechnung {{id}}",
        "imageAlt": "QR-Code für die Kartenzahlung bei SumUp",
        "amount": "€ {{amount}}",
        "hint": "Der Patient scannt den Code mit dem Handy und zahlt bei SumUp per Karte, Apple Pay oder Google Pay.",
        "waiting": "Warte auf Zahlung …",
        "paid": "€ {{amount}} bezahlt. Die Rechnung ist als bezahlt markiert.",
        "expired": "Der QR-Code ist abgelaufen.",
        "failed": "Die Kartenzahlung konnte nicht gestartet werden.",
        "newCode": "Neuen QR-Code erzeugen"
    },
    "cardPay": {
        "button": "Kartenzahlung",
        "qr": "QR-Code",
        "qrHint": "Patient zahlt mit dem eigenen Handy",
        "terminal": "Kartenterminal",
        "terminalHint": "Betrag ans SumUp-Terminal senden"
    },
    "cardReader": {
        "button": "An Kartenterminal senden",
        "title": "Kartenterminal – Rechnung {{id}}",
        "loading": "Kartenterminal wird gesucht …",
        "choose": "An welches Kartenterminal senden?",
        "sending": "Betrag wird an das Terminal gesendet …",
        "hint": "Der Betrag ist auf „{{name}}“. Der Patient hält seine Karte oder sein Handy ans Terminal.",
        "declined": "Die Zahlung ist nicht erfolgt (abgelehnt oder am Terminal abgebrochen).",
        "timeout": "Keine Rückmeldung vom Terminal. Falls der Patient bezahlt hat, wird die Zahlung automatisch verbucht.",
        "offline": "Das Kartenterminal ist nicht online. Bitte prüfen Sie, ob es eingeschaltet und mit dem WLAN verbunden ist.",
        "busy": "Am Terminal wartet bereits eine Zahlung. Bitte kurz warten oder dort abbrechen.",
        "nothingDue": "Für diese Rechnung ist nichts mehr offen.",
        "failed": "Die Zahlung konnte nicht an das Terminal gesendet werden.",
        "cancel": "Am Terminal abbrechen",
        "sendAgain": "Erneut senden"
    },
    "sumup": {
        "title": "Kartenzahlung (SumUp)",
        "description": "Patienten bezahlen im Patientenportal per Karte, Apple Pay oder Google Pay. Das Geld geht direkt auf Ihr SumUp-Konto.",
        "ownAccount": "Mein SumUp-Konto",
        "praxisAccount": "Praxis-Konto",
        "ownAccountHint": "Kartenzahlungen für Ihre eigenen Rechnungen gehen auf dieses Konto.",
        "praxisAccountHint": "Gemeinsames SumUp-Konto der Praxis. Kartenzahlungen für Ihre Rechnungen gehen hierhin. Verbinden kann es nur ein Admin.",
        "praxisAccountAskAdmin": "Noch nicht verbunden – bitten Sie einen Admin, das Praxis-Konto zu verbinden.",
        "usePraxis": "Stattdessen Praxis-SumUp nutzen",
        "usePraxisSaveFailed": "Die Auswahl konnte nicht gespeichert werden.",
        "notUsed": "verbunden, wird nicht verwendet",
        "ownDisabledHint": "Sie nutzen das Praxis-Konto. Schließen Sie „Stattdessen Praxis-SumUp nutzen“, um ein eigenes Konto zu verbinden.",
        "summary": "Patienten zahlen per Karte im Portal oder per QR-Code am Empfang.",
        "notConnected": "nicht verbunden",
        "connectedAs": "verbunden mit {{name}}",
        "needsReconnect": "Verbindung abgelaufen, bitte neu verbinden",
        "connect": "Mit SumUp verbinden",
        "reconnect": "Neu verbinden",
        "connecting": "Wird geöffnet…",
        "disconnect": "trennen",
        "confirmDisconnect": "SumUp-Verbindung trennen? Patienten können dann nicht mehr per Karte bezahlen.",
        "connectSuccess": "SumUp ist verbunden. Patienten sehen die Kartenzahlung jetzt im Portal.",
        "connectFailed": "Die Verbindung mit SumUp ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "connectCancelled": "Die Verbindung mit SumUp wurde abgebrochen.",
        "scopeMissing": "SumUp hat die Zahlungsberechtigung nicht erteilt. Bitte wenden Sie sich an den Medinvoice-Support.",
        "comingSoon": "Demnächst verfügbar.",
        "notAvailableYet": "Sie können Ihr SumUp-Konto hier verbinden, sobald die Kartenzahlung freigeschaltet ist.",
        "howItWorks": "Sie brauchen ein eigenes SumUp-Geschäftskonto. Im Portal erscheint dann „Mit Karte bezahlen“; bezahlte Rechnungen werden automatisch als bezahlt markiert. Kartendaten sieht Medinvoice nie. Automatisch verbucht werden nur Kartenzahlungen, die in Medinvoice gestartet werden (Portal, QR-Code am Empfang, an das Kartenterminal gesendet). Beträge, die Sie selbst am SumUp-Terminal oder in der SumUp-App eingeben, und eigene SumUp-Links erkennt Medinvoice nicht – bitte diese Rechnungen manuell als bezahlt markieren.",
        "feesNotice": "SumUp berechnet Ihnen pro Zahlung eine Gebühr. Ein Aufschlag für Patienten ist gesetzlich nicht erlaubt.",
        "switchesTitle": "Wo Kartenzahlung angeboten wird",
        "switchesDesc": "Gilt für die ganze Praxis. Bezahlte Rechnungen werden in allen drei Fällen automatisch als bezahlt markiert.",
        "switchesAdminOnly": "Gilt für die ganze Praxis. Nur Admins können das ändern.",
        "portalTitle": "Im Patientenportal",
        "portalDesc": "Patienten sehen „Mit Karte bezahlen“ neben der Überweisung und zahlen auf der Zahlungsseite von SumUp.",
        "deskQrTitle": "Per QR-Code am Empfang",
        "deskQrDesc": "Schaltfläche „Kartenzahlung per QR“ bei offenen Rechnungen. Der Patient scannt den Code und zahlt mit dem eigenen Handy.",
        "terminalTitle": "Am Kartenterminal",
        "terminalDesc": "Schaltfläche „An Kartenterminal senden“ bei offenen Rechnungen, sobald ein SumUp Solo gekoppelt ist.",
        "saveFailed": "Die Änderungen konnten nicht gespeichert werden.",
        "terminalNoReader": "Noch kein Terminal gekoppelt – oben unter „Kartenterminals“ koppeln.",
        "deskQrSaveFailed": "Die Einstellung konnte nicht gespeichert werden.",
        "terminalsTitle": "Kartenterminals (SumUp Solo)",
        "terminalsEmpty": "Koppeln Sie ein SumUp Solo, um den Rechnungsbetrag per Klick ans Terminal zu senden.",
        "terminalsReconnect": "Für Kartenterminals bitte SumUp einmal neu verbinden.",
        "pairReader": "Terminal koppeln",
        "pairSteps": "Am Solo: abmelden (Einstellungen → Geräteeinstellungen → Info → Abmelden), dann Verbindungen → API → Verbinden. Den angezeigten Code hier eingeben (5 Minuten gültig).",
        "pairCode": "Kopplungscode",
        "pairName": "Name",
        "pairNamePlaceholder": "z. B. Empfang",
        "pairNameDefault": "Empfang",
        "pairSubmit": "Koppeln",
        "pairing": "Wird gekoppelt …",
        "pairCancel": "Abbrechen",
        "pairInvalidCode": "Der Code hat 8 oder 9 Zeichen.",
        "pairRejected": "SumUp hat den Code nicht akzeptiert. Er ist 5 Minuten gültig – bitte am Terminal einen neuen erzeugen.",
        "pairFailed": "Das Terminal konnte nicht gekoppelt werden. Bitte versuchen Sie es erneut.",
        "unpairReader": "Terminal entfernen",
        "confirmUnpair": "Kartenterminal „{{name}}“ entfernen? Trennen Sie es danach auch am Gerät (Verbindungen → API → Trennen).",
        "unpairFailed": "Das Terminal konnte nicht entfernt werden.",
        "tabCardPayments": "Kartenzahlungen",
        "paymentsHint": "Kartenzahlungen aus dem Patientenportal. Jede Zahlung ist bereits auf ihrer Rechnung verbucht. SumUp zahlt sie gesammelt auf Ihr Bankkonto aus.",
        "noPayments": "Noch keine Kartenzahlungen",
        "colAccount": "SumUp-Konto",
        "colInvoice": "Rechnung",
        "colPayer": "Zahler",
        "colTransaction": "SumUp-Transaktion",
        "praxisAccountShort": "Praxis-Konto",
        "payoutChip": "SumUp-Auszahlung",
        "payoutTooltip": "Sammelauszahlung Ihrer Kartenzahlungen. Die einzelnen Zahlungen sind bereits auf den Rechnungen verbucht. Bitte nicht zuordnen, sondern als geprüft markieren."
    },
    "finapi": {
        "panelTitle": "Kontoübersicht",
        "panelTitleBank": "Kontoübersicht von {{bank}}",
        "unknownCounterpart": "unbekannt",
        "autoMatched": "automatisch einer Rechnung zugeordnet",
        "autoMatchedCount": "{{count}} Rechnungen zugeordnet",
        "manuallyMatched": "manuell einer Rechnung zugeordnet",
        "manuallyMatchedCount": "{{count}} Rechnungen manuell zugeordnet",
        "possibleDuplicate": "Rechnung {{readableId}} bereits bezahlt — mögliche Doppelzahlung",
        "notifyPatientDuplicate": "Patient informieren",
        "notifyingPatient": "Wird gesendet…",
        "patientNotified": "Patient informiert",
        "bankConnection": "Bankverbindung",
        "notConnected": "nicht verbunden",
        "connected": "verbunden",
        "connectDesc": "Bankkonto verbinden, um Zahlungen automatisch Rechnungen zuzuordnen.",
        "settingsDesc": "Bankkonto über BANKSapi verbinden, um eingehende Zahlungen automatisch zu erkennen und Rechnungen zuzuordnen. Ihre Bankzugangsdaten werden ausschließlich von BANKSapi verarbeitet.",
        "tanNotice": "Ihre Bank bittet beim Verbinden um eine TAN-Freigabe. Dort steht meist ein allgemeiner Text wie „Datenabruf“ oder „Kontoinformationsdienst“, oft ohne den Namen Medinvoice: Unser Partner BANKSapi ruft Ihre Kontoumsätze nur lesend ab. Das ist richtig so.",
        "dashboardNudge": "Bankkonto unter Einstellungen → Bankdaten verbinden, um Kontostände zu sehen.",
        "dashboardNudgeStaff": "Es ist noch kein Bankkonto verbunden. Ärztinnen und Ärzte verbinden ihr Konto unter Einstellungen → Bankdaten.",
        "connectBtn": "Bank verbinden",
        "goToSettings": "in Einstellungen konfigurieren",
        "confirmDisconnect": "Bankverbindung trennen? Alle Verbindungsdaten werden entfernt.",
        "duplicateAccountWarning": "Dieses Bankkonto ist bereits unter {{names}} verbunden. Bitte eine der beiden Verbindungen trennen (unter Einstellungen → Bankdaten, im jeweiligen Konto angemeldet).",
        "totalBalance": "Gesamtsaldo",
        "lastSync": "letzte Synchronisation",
        "syncFailedTitle": "Synchronisierung konnte gerade nicht durchgeführt werden",
        "syncFailedHint": "Das kann gelegentlich vorkommen. Ihre Daten bleiben davon unberührt — bitte versuchen Sie es in ein paar Minuten erneut.",
        "syncFailedLastSync": "Letzte erfolgreiche Synchronisation: {{datetime}}",
        "sync": "jetzt synchronisieren",
        "disconnect": "trennen",
        "syncing": "Transaktionen werden synchronisiert…",
        "manualMatch": "Rechnung zuordnen",
        "unmatch": "Zuordnung entfernen",
        "unmatching": "Zuordnung wird entfernt…",
        "manualMatchTitle": "Transaktion einer Rechnung zuordnen",
        "searchPlaceholder": "Transaktionen suchen…",
        "manualMatchSearch": "Rechnungs-ID, Betrag, Patient suchen…",
        "manualMatchPersonSearch": "nach Patient oder Empfänger suchen…",
        "manualMatchNone": "keine offenen Rechnungen gefunden",
        "manualMatchSelected_one": "{{count}} ausgewählt",
        "manualMatchSelected_other": "{{count}} ausgewählt",
        "manualMatchConfirm": "Zuordnung bestätigen",
        "matching": "Wird zugeordnet…",
        "accountHolder": "Rechnungsempfänger",
        "billedPatient": "Behandelter Patient",
        "recipient": "Empfänger",
        "patient": "Patient",
        "loading": "laden…",
        "fetching": "Bankdaten werden abgerufen…",
        "pendingLabel": "vorgemerkte Transaktionen",
        "ignore": "als irrelevant markieren",
        "unignore": "wiederherstellen",
        "connecting": "verbinden…",
        "retry": "erneut versuchen",
        "connectFailed": "Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "lockedNotice": "BANKSapi hat die Verbindung temporär gesperrt (423). Bitte warten Sie ein paar Minuten und versuchen Sie es erneut. Tipp: Vermeiden Sie mehrfaches Klicken hintereinander — das kann die Sperre auslösen.",
        "tabIncoming": "Eingänge",
        "tabOutgoing": "Auszahlungen",
        "noOutgoingTransactions": "Keine Auszahlungen.",
        "refundMatchTitle": "Rückzahlung einer Rechnung zuordnen",
        "refundMatchNone": "Keine bezahlten Rechnungen gefunden",
        "refundAmountLabel": "Rückzahlungsbetrag",
        "remainingLabel": "Offen",
        "paidLabel": "Bezahlt",
        "amountToAddLabel": "Hinzuzufügender Betrag",
        "amountToRemoveLabel": "Abzuziehender Betrag",
        "effectAdd": "Fügt {{amount}} zum bezahlten Betrag der Rechnung hinzu",
        "effectRemove": "Zieht {{amount}} vom bezahlten Betrag der Rechnung ab",
        "statAutoMatched": "Automatisch gematcht",
        "statUnmatched": "Nicht gematcht",
        "statReviewed": "Manuell geprüft",
        "tabAll": "Alle",
        "colDate": "Datum",
        "colAccount": "Konto",
        "colAmount": "Betrag",
        "filterAmountMax": "Max. Betrag",
        "colCounterpart": "Zahlungspflichtige:r / Absender",
        "colPurpose": "Verwendungszweck",
        "colStatus": "Status",
        "colAction": "Aktion",
        "multiAccountSummary": "{{count}} verbundene Konten",
        "statusOpen": "Offen",
        "statusMatched": "Gematcht",
        "statusReviewed": "Geprüft",
        "suggestionsTitle": "Vorschläge",
        "matchPopupTitle": "Transaktion zuordnen",
        "viewAll": "Alle anzeigen",
        "selectedTransaction": "Ausgewählte Transaktion",
        "possibleInvoices": "Mögliche Rechnungen",
        "showMoreInvoices": "Weitere Rechnungen anzeigen",
        "showLessInvoices": "Weniger anzeigen",
        "noInvoiceSelected": "Transaktion auswählen, um Vorschläge zu sehen.",
        "noMatchHint": "Keine passende Rechnung? Als geprüft markieren und manuell bearbeiten.",
        "matchOwnerHint": "Eingang auf dem Konto von {{name}} — angezeigt werden nur versendete offene Rechnungen von {{name}} und Rechnungen aus der Desktop-App.",
        "markReviewed": "Als geprüft markieren",
        "dueOn": "Fällig am {{date}}",
        "noTransactions": "Keine Transaktionen.",
        "bestMatch": "Beste Übereinstimmung",
        "transactionLimitLabel": "Anzahl angezeigter Transaktionen",
        "transactionLimitDesc": "Wie viele der letzten Transaktionen (je Richtung) abgerufen und angezeigt werden ({{min}}–{{max}})."
    },
    "invoicePage": {
        "generating": "wird erstellt…",
        "sendLink": "Rechnung per Link senden",
        "resendLink": "Rechnung per Link erneut senden",
        "sendViaPost": "per Post senden",
        "viewPdf": "PDF ansehen",
        "pdfNotSent": "PDF nicht verfügbar — der Link wurde noch nicht an den Empfänger gesendet",
        "emailFailed": "E-Mail-Zustellung fehlgeschlagen — die E-Mail-Adresse des Empfängers ist möglicherweise ungültig",
        "noEmail": "Empfänger hat keine E-Mail-Adresse",
        "legalNotAccepted": "Diese Rechnung kann nicht digital versendet werden — der Empfänger hat die Einwilligung noch nicht unterzeichnet. Der Versand per Post ist weiterhin möglich.",
        "postConsentRequired": "Diese Rechnung kann nicht per Post versendet werden — der Empfänger hat die Einwilligung zur Datenweitergabe noch nicht unterzeichnet.",
        "postOnlyBlocked": "Dieser Patient ist als „Nur Brief“ markiert — Rechnungen können nur per Post versendet werden, der digitale Versand ist deaktiviert.",
        "amountMismatch": "Gespeicherter Betrag (€ {{stored}}) stimmt nicht mit der Summe der Leistungen (€ {{calculated}}) überein.",
        "amountMismatchShort": "Betrag stimmt nicht mit den Leistungen überein",
        "amountMismatchFlagged": "Betragsabweichung markiert.",
        "amountMismatchDetail": "Der ursprüngliche PAD-Upload betrug {{stored}}, die Leistungssumme ist {{calculated}}.",
        "amountMismatchReview": "Prüfen im Tab Leistungen.",
        "markAsPaid": "als bezahlt markieren",
        "writeOff": "abschreiben",
        "saving": "Speichern…",
        "savingChangesMessage": "Änderungen werden gespeichert…",
        "saveChanges": "Änderungen speichern",
        "notFound": "Rechnung nicht gefunden",
        "tab_details": "Details",
        "tab_exams": "Leistungen",
        "tab_log": "Protokoll",
        "tab_portal": "Portal",
        "tab_questions": "Fragen",
        "tab_notes": "Notizen",
        "portalTitle": "Portal",
        "portalNoActivity": "Noch keine Portalaktivität",
        "portalLoading": "Laden…",
        "portalColDate": "Datum",
        "portalColEvent": "Ereignis",
        "portalColDetails": "Details",
        "portalEventRegister": "Registriert",
        "portalEventLogin": "Angemeldet",
        "portalEventSmsOtp": "SMS OTP gesendet",
        "portalEventPdfDownloaded": "PDF heruntergeladen",
        "portalEventInvoiceViewed": "Rechnung angesehen",
        "notesOnlyVisibleToYou": "Diese Notizen sind privat – nur für Sie hier sichtbar. Sie werden niemals an den Patienten weitergegeben.",
        "notesSave": "Notiz speichern",
        "notesClear": "Löschen",
        "notesPlaceholder": "Private Notiz zu dieser Rechnung hinzufügen…",
        "notesSaved": "Notiz gespeichert",
        "noQuestions": "Keine Fragen vorhanden.",
        "hasQuestion": "Empfänger hat eine Frage gestellt",
        "exams": "Leistungen",
        "noExams": "Keine Leistungen vorhanden.",
        "goaCatalogButton": "GOÄ-Ziffern",
        "goaCatalogTitle": "GOÄ-Ziffern",
        "goaRulesButton": "GOÄ-Regeln",
        "goaRulesTitle": "GOÄ-Ausschlussregeln",
        "goaRulesIntro": "Diese GOÄ-Ziffern dürfen laut Gebührenordnung nicht zusammen am selben Behandlungstag abgerechnet werden. Aktuell abgedeckt: Abschnitte B, C, E–O.",
        "goaRulesEmpty": "Keine Regeln gefunden.",
        "goaRulesSearchPlaceholder": "Nach GOÄ-Ziffer suchen…",
        "goaRulesCount": "{{count}} Regel",
        "goaRulesCount_other": "{{count}} Regeln",
        "goaCatalogSearchPlaceholder": "Nr. oder Bezeichnung suchen…",
        "goaCatalogEmpty": "Keine Ziffern gefunden.",
        "goaScopeSpecialty": "Meine Fachrichtung",
        "goaScopeAll": "Alle Fachgebiete",
        "goaSearchHint": "Die Suche durchsucht nur Ihre Fachrichtung. Für alle Fachgebiete oben umschalten.",
        "goaCatalogCount": "{{count}} Ziffer",
        "goaCatalogCount_other": "{{count}} Ziffern",
        "goaConflictBadge": "{{count}} möglicher Abrechnungsfehler",
        "goaConflictBadge_other": "{{count}} mögliche Abrechnungsfehler",
        "goaBaseCodeBadge": "{{count}} Grundleistung fehlt",
        "goaBaseCodeBadge_other": "{{count}} Grundleistungen fehlen",
        "goaBaseCodeLine": "Nr. {{nr}} setzt am selben Tag eine dieser Leistungen voraus: Nr. {{requires}}.",
        "goaMaxCountBadge": "{{count}} mögliches Häufigkeitsproblem",
        "goaMaxCountBadge_other": "{{count}} mögliche Häufigkeitsprobleme",
        "duplicateCodeError": "Diese Ziffer ist bereits erfasst",
        "duplicateCodeBanner": "Diese GOÄ-Ziffer(n) sind mehrfach erfasst: {{codes}}",
        "duplicateCodeHint": "Das ist möglich, wenn es medizinisch begründet ist. Geben Sie dann in der Begründung die Uhrzeit oder das untersuchte Organ an.",
        "goaConflictRowTooltip": "Mögliche GOÄ-Abrechnungsfehler in diesem Beleg",
        "goaConflictTabTooltip": "Mögliche GOÄ-Abrechnungsfehler in den Leistungen",
        "goaConflictTitle": "Mögliche Abrechnungsfehler",
        "goaConflictIntro": "Diese GOÄ-Ziffern werden laut Gebührenordnung normalerweise nicht zusammen abgerechnet. Bitte prüfen Sie die Positionen und passen Sie sie bei Bedarf an.",
        "goaConflictDateLabel": "Behandlungstag",
        "goaConflictNoDate": "Kein Leistungsdatum erfasst — bitte manuell prüfen.",
        "logEmpty": "Noch keine Protokolleinträge.",
        "logDate": "Datum",
        "logAction": "Aktion",
        "logPerformedBy": "durchgeführt von",
        "logFrom": "Von",
        "logTo": "Zu",
        "logAction_statusChanged": "Status geändert",
        "logAction_dunningAdvanced": "Mahnstufe geändert",
        "logAction_dunningResent": "Mahnung erneut versendet",
        "logResendChannel_email": "E-Mail",
        "logResendChannel_post": "Brief",
        "logResendChannel_both": "E-Mail + Brief",
        "resendDunning": "Mahnung erneut senden",
        "resendDunningBtn": "Erneut senden",
        "dunningDowngradeWarning": "Wenn Sie die Mahnstufe herabsetzen, läuft das automatische Mahnwesen ab dem Speichern neu: Die nächste Stufe folgt nach dem in den Mahnwesen-Einstellungen festgelegten Abstand. Um es anzuhalten, pausieren Sie das Mahnwesen für diese Rechnung.",
        "resendDunningPausedHint":"Mahnwesen ist pausiert",
        "resendDunningUnsavedHint": "Bitte zuerst die Änderungen speichern",
        "resendDunningTitle": "Mahnung erneut senden",
        "resendDunningMsg": "Die {{level}} zu Rechnung {{id}} wird erneut {{channel}} an {{name}} gesendet. Mahnstufe und Mahngebühr bleiben unverändert.",
        "resendDunningConfirm": "Senden",
        "dunningNotice_1": "Zahlungserinnerung (M1)",
        "dunningNotice_2": "Mahnung (M2)",
        "dunningNotice_3": "Letzte Mahnung (M3)",
        "resendDunningChannel_email": "per E-Mail",
        "resendDunningChannel_letter": "per Brief",
        "resendDunningChannel_both": "per E-Mail und Brief",
        "saveDunningSendTitle": "Mahnung jetzt versenden?",
        "saveDunningSendMsg": "Die Mahnstufe wird auf {{level}} geändert. Soll die {{level}} jetzt {{channel}} an {{name}} gesendet werden?",
        "saveDunningSendConfirm": "Speichern & senden",
        "saveDunningSaveOnly": "Nur speichern",
        "toastDunningResentEmail": "Mahnung per E-Mail versendet",
        "toastDunningResentLetter": "Mahnung per Brief versendet",
        "toastDunningResentBoth": "Mahnung per E-Mail und Brief versendet",
        "toastDunningResentPartial": "Mahnung nur teilweise versendet – ein Versandweg ist fehlgeschlagen",
        "toastDunningResendNoChannel": "Empfänger ist für diese Mahnstufe nicht erreichbar (keine E-Mail-Adresse bzw. nur Brief, kein Brief-Fallback)",
        "toastDunningResendFailed": "Mahnung konnte nicht versendet werden",
        "paymentReceiptSend": "Zahlungsbestätigung senden",
        "paymentReceiptResend": "Zahlungsbestätigung erneut senden",
        "paymentReceiptMsg": "Die Zahlungsbestätigung für Rechnung {{id}} an {{email}} senden?",
        "paymentReceiptFailed": "Zahlungsbestätigung konnte nicht zugestellt werden",
        "toastPaymentReceiptSent": "Zahlungsbestätigung versendet",
        "toastPaymentReceiptFailed": "Zahlungsbestätigung konnte nicht versendet werden",
        "logAction_bankTransactionMatched": "Bankabgleich",
        "logAction_sumupPayment": "Kartenzahlung (SumUp)",
        "logAction_paidAmountChanged": "Zahlbetrag aktualisiert",
        "logAction_paywiseSubmitted": "An Paywise übergeben",
        "logAction_dunningFeeChanged": "Mahngebühr geändert",
        "logAction_sent": "Portal-Link gesendet",
        "logAction_reSent": "Portal-Link erneut gesendet",
        "logAction_sentPost": "Per Post versendet",
        "logAction_reSentPost": "Erneut per Post versendet",
        "letterStatus": "Brief-Status",
        "resendViaPost": "Erneut per Post senden",
        "resendViaPostNotice": "Diese Rechnung wurde bereits per Post versendet. Der erneute Versand ist ein neuer Brief und kostet erneut Porto.",
        "resendViaPostConfirm": "Erneut senden",
        "toastLxResent": "Rechnung erneut per Post versandt.",
        "sendLinkTitle": "Rechnungs-Link senden",
        "sendLinkDesc": "Der Rechnungs-Link wird gesendet an:",
        "invoiceTitle": "Rechnung {{id}}",
        "nextInvoice": "Nächste Rechnung",
        "nextInvoiceTitle": "Nächste Rechnung {{number}} – {{name}}",
        "lxJobTitle": "Brief Auftrag #{{id}}",
        "lxStatus": "Status",
        "lxDispatchDate": "Versanddatum",
        "lxSubmitted": "eingereicht",
        "lxCost": "Kosten",
        "lxJobDraft": "Entwurf (Testmodus)",
        "lxJobHold": "angehalten",
        "lxJobQueue": "in der Warteschlange",
        "lxJobSent": "gesendet",
        "lxJobCanceled": "abgebrochen",
        "amounts": "Beträge",
        "total": "Gesamt",
        "paidField": "bezahlt (€)",
        "paidTotal": "bereits bezahlt",
        "dunningFine": "Mahngebühr",
        "removeFine": "Mahngebühr entfernen",
        "fineAlreadyPaidHint": "Diese Gebühr wurde bereits bezahlt und kann nicht mehr entfernt werden.",
        "dunningFineTooltip": "Dieser Rechnung wurde eine Verzugsgebühr von {{amount}} € hinzugefügt, da sie nicht bis zum Fälligkeitsdatum ({{date}}) beglichen wurde.",
        "totalWithFine": "Gesamt inkl. Mahngebühr",
        "newPayment": "neue Zahlung (€)",
        "paymentRequiresSent": "Zahlungen können erst erfasst werden, nachdem die Rechnung versendet wurde.",
        "paymentBlockedHint": "Bitte zuerst die Rechnung versenden, um eine Zahlung zu erfassen.",
        "materialCosts": "Materialkosten",
        "eyebrowInvoice": "Rechnung",
        "eyebrowCreated": "Erstellt",
        "eyebrowSource": "Quelle",
        "sourcePad": "PAD-Upload",
        "sourceManual": "Manuell",
        "summaryOutstanding": "offen",
        "summaryInclFine": "— inkl. € {{amount}} Mahngebühr",
        "summaryOverdueDays": "{{count}} Tage überfällig",
        "samePersonShort": "Gleiche Person",
        "selfPayerLabel": "Selbstzahler",
        "datesDunning": "Daten & Mahnung",
        "datesDunningLead": "Fälligkeitsdatum und Mahnstufe manuell anpassen. Änderungen gelten nach dem Speichern.",
        "nextEscalation": "Nächste Eskalation",
        "escalationAuto": "automatisch",
        "daysOverdueShort": "{{count}} T. überfällig",
        "pauseDunningLead": "Nächste Erinnerung aussetzen. Patient bleibt auf der aktuellen Stufe, bis Sie es deaktivieren.",
        "lifecycleViaPad": "via PAD-Upload",
        "lifecycleViaPadTime": "via PAD-Upload · {{time}}",
        "lifecyclePortalSeen": "Portal-Link · gesehen {{date}}",
        "lifecyclePending": "— ausstehend",
        "patientBornAge": "Geboren {{date}} ({{age}} J.)",
        "patientBorn": "Geboren {{date}}",
        "lifecycleManual": "manuell",
        "lifecyclePortalLink": "Portal-Link",
        "lifecycleNotSent": "nicht gesendet",
        "lifecycleOverdueSub": "{{days}} Tage überfällig · M{{level}} erreicht",
        "lifecycleDunningSub": "M{{level}} Mahnung initiiert",
        "lifecycleDuePending": "ausstehend",
        "lifecycleNotReceived": "nicht eingegangen",
        "lifecycleReceived": "eingegangen",
        "lifecyclePaidBankAuto": "automatischer Bankabgleich",
        "lifecyclePaidBankManual": "manueller Bankabgleich",
        "lifecyclePaidCard": "per Karte (SumUp)",
        "cardPayment": "Kartenzahlung (SumUp)",
        "lifecyclePaidManually": "manuell",
        "lifecyclePaidManuallyBy": "manuell · {{name}}",
        "sidebarHistory": "Verlauf",
        "sidebarTotalInvoiced": "Gesamt fakturiert",
        "sidebarAcrossInvoices": "über {{count}} Rechnungen",
        "sidebarPaidOnTime": "Pünktlich bezahlt",
        "sidebarOpenBalance": "Offener Betrag",
        "sidebarThisInvoice": "nur diese Rechnung",
        "sidebarActivity": "Aktivität",
        "sidebarViewLog": "Vollständiges Protokoll",
        "sidebarOtherInvoices": "Weitere Rechnungen · {{name}}",
        "sidebarAllInvoices": "Alle {{count}} Rechnungen",
        "unsavedChanges": "{{count}} ungespeicherte Änderungen",
        "discard": "Verwerfen",
        "datesStatus": "Datum & Status",
        "createdSent": "erstellt / gesendet",
        "dueDate": "Fälligkeit",
        "pauseDunning": "Mahnung pausieren",
        "noRecipient": "kein Empfänger",
        "noPatient": "kein Patient",
        "samePersonBadge": "= Patient",
        "selfPays": "selbst",
        "viewPatient": "Patient ansehen",
        "examDate": "Datum",
        "examQty": "Anz.",
        "examPosition": "Position",
        "examDescription": "Bezeichnung",
        "examValue": "Wert",
        "goaPoints": "Punkte",
        "examFactor": "Faktor",
        "examAmount": "Betrag",
        "editServicesHint": "Leistungen dieses Datums bearbeiten",
        "editServicesTitle": "Leistungen vom {{date}}",
        "justification": "Begründung",
        "justificationPlaceholder": "optional",
        "addService": "Leistung hinzufügen",
        "deleteService": "Entfernen",
        "restoreService": "Wiederherstellen",
        "factorAllowedRange": "Erlaubt: {{min}}–{{max}}",
        "unknownCode": "Unbekannte GOÄ-Ziffer",
        "materialLines": "Auslagen & Kosten",
        "addMaterialLine": "Auslage hinzufügen",
        "materialLineCost": "Kosten (€)",
        "kindMaterial": "Auslage / Material",
        "kindMedication": "Medikament",
        "kindPostage": "Porto",
        "kindExpertReport": "Gutachten",
        "kindFee": "Honorar",
        "kindCompensation": "Entschädigung",
        "originalAnnotations": "Ursprünglicher Text (PAD-Import, nicht bearbeitbar)",
        "examsEditHint": "Auf ein Datum klicken, um die Leistungen zu bearbeiten",
        "padDivergenceTitle": "Rechnung wird geändert",
        "originManual": "Manuell erstellt",
        "originManualHint": "Von Hand in Medinvoice erstellt – die Leistungen lassen sich bis zum Versand in jedem Tarif korrigieren.",
        "originImported": "Importiert",
        "originImportedHint": "Aus der Praxissoftware übernommen (hochgeladene Datei oder Desktop-App).",
        "padDivergenceWarning": "Diese Änderungen weichen vom ursprünglich importierten Datensatz ab und wirken sich direkt auf die Rechnung aus. Fortfahren?",
        "replyOpen": "Antworten",
        "replyHide": "Antwort abbrechen",
        "replyPlaceholder": "Antwort schreiben…",
        "replySend": "Antwort senden",
        "replySending": "senden…",
        "attachFiles": "Dateien anhängen",
        "lifecycleCreated": "erstellt",
        "lifecycleSent": "versandt",
        "lifecycleDue": "fällig",
        "lifecycleOverdue": "fällig · überfällig",
        "lifecyclePaid": "bezahlt",
        "lifecycleWrittenOff": "abgeschrieben",
        "overdueWarning": "diese Rechnung ist überfällig — Fälligkeitsdatum war {{date}}.",
        "outstandingBalance": "offener Betrag",
        "overpaidBy": "Überzahlt um € {{amount}}",
        "net": "Netto",
        "vat": "MwSt. ({{rate}} %)",
        "vatBadge": "inkl. {{rate}} % MwSt.",
        "vatIncluded": "Diese Rechnung enthält {{rate}} % MwSt. Der angezeigte Betrag ist der Bruttobetrag.",
        "vatBadgeMixed": "inkl. MwSt.",
        "vatIncludedMixed": "Diese Rechnung enthält unterschiedliche MwSt.-Sätze je Position (siehe Leistungen). Der angezeigte Betrag ist der Bruttobetrag.",
        "lineVatRateAmount": "{{rate}} % MwSt. ({{amount}})",
        "lineVatExempt": "steuerfrei",
        "lineVatOverrideHint": "Abweichender MwSt.-Satz für diese Position",
        "vatNotApplicable": "— nicht anwendbar",
        "totalBeforeFees": "Summe vor Gebühren",
        "collected": " eingezogen",
        "recordManualPayment": "Manuelle Zahlung erfassen",
        "recordManualPaymentLead": "Bar, Überweisung oder andere Zahlung außerhalb des Portals.",
        "dunningFineWhen": "ab M{{level}}",
        "paid": "bezahlt",
        "remaining": "verbleibend",
        "apply": "anwenden",
        "roleRecipient": "Empfänger",
        "rolePatient": "Patient",
        "paywiseBannerTitle": "Bereit für Inkasso",
        "paywiseBannerDesc": "Diese Rechnung hat die letzte Mahnstufe erreicht. Sie können sie jetzt zur automatisierten Beitreibung an Paywise übergeben.",
        "paywiseSubmitBtn": "An Paywise übergeben",
        "paywiseAlreadySubmitted": "An Paywise übergeben",
        "paywiseCaseId": "Fall-ID",
        "paywiseConfirmTitle": "An Paywise übergeben?",
        "paywiseConfirmDesc": "Folgende Informationen werden zur Forderungsbeitreibung an Paywise weitergegeben:",
        "paywiseConfirmDataName": "Vollständiger Name",
        "paywiseConfirmDataAddress": "Adresse",
        "paywiseConfirmDataContact": "Kontakt (E-Mail / Telefon)",
        "paywiseConfirmDataAmount": "Ausstehender Betrag",
        "paywiseConfirmDataRef": "Rechnungsnummer",
        "paywiseConfirmNote": "Medizinische Details, Diagnosen oder Leistungsangaben werden nicht weitergegeben.",
        "paywiseConfirmBtn": "Bestätigen & Übergeben",
        "paywiseSuccess": "Fall erfolgreich an Paywise übergeben. Fall-ID: {{caseId}}",
        "paywiseError": "Übergabe an Paywise fehlgeschlagen. Bitte erneut versuchen.",
        "paywisePlanRequired": "Die Paywise-Integration erfordert mindestens einen Plus-Tarif.",
        "paywiseNoKey": "Kein Paywise API-Schlüssel konfiguriert. Bitte in Einstellungen → Mahnwesen eintragen.",
        "paywiseNotConfirmed": "Bitte bestätigen Sie den Datenschutzhinweis in Einstellungen → Mahnwesen, bevor Sie an Paywise übergeben.",
        "toastChangesSaved": "Änderungen gespeichert.",
        "toastSaveFailed": "Änderungen konnten nicht gespeichert werden.",
        "toastMarkedPaid": "Rechnung als bezahlt markiert.",
        "toastWrittenOff": "Rechnung abgeschrieben.",
        "toastReopened": "Rechnung wieder geöffnet.",
        "toastEmailSent": "E-Mail erfolgreich gesendet.",
        "toastEmailSendFailed": "E-Mail konnte nicht gesendet werden.",
        "toastPortalLinkSent": "Rechnungs-Link an die E-Mail des Empfängers gesendet.",
        "toastPortalLinkSentId": "Rechnungs-Link für Rechnung {{id}} an die E-Mail des Empfängers gesendet.",
        "toastPortalLinkFailedId": "Rechnungs-Link für Rechnung {{id}} konnte nicht gesendet werden.",
        "toastLxSent": "Rechnung {{id}} per Post versandt.",
        "toastLxFailed": "Rechnung {{id}} konnte nicht per Post versandt werden.",
        "toastLxSentSingle": "Rechnung per Post versandt.",
        "toastLxSendFailed": "Briefversand fehlgeschlagen.",
        "toastLxJobNotFound": "Briefauftrag nicht gefunden.",
        "toastLxStatusFailed": "Brief-Status konnte nicht abgerufen werden.",
        "toastPdfFailed": "PDF konnte nicht erstellt werden.",
        "toastDeleteFailed": "Rechnung konnte nicht gelöscht werden. Bitte erneut versuchen.",
        "toastPortalLinkSendFailed": "Rechnungs-Link konnte nicht gesendet werden.",
        "markPaidTitle": "Als bezahlt markieren",
        "markPaidMsg": "Rechnung {{id}} als vollständig bezahlt markieren?",
        "markPaidConfirm": "Als bezahlt markieren",
        "writeOffTitle": "Rechnung abschreiben",
        "writeOffMsg": "Rechnung {{id}} abschreiben?",
        "writeOffConfirm": "Abschreiben",
        "reopenTitle": "Rechnung wieder öffnen",
        "reopenMsg": "Rechnung {{id}} wieder öffnen? Sie wird auf \"offen\" zurückgesetzt.",
        "reopenConfirm": "Rechnung freigeben",
        "sendEmailTitle": "E-Mail senden",
        "sendEmailAlreadySent": "Eine E-Mail wurde bereits am {{date}} gesendet. ",
        "sendEmailMsg": "Weitere E-Mail für Rechnung {{id}} an {{name}} senden?",
        "sendEmailConfirm": "Senden",
        "deleteInvoice": "Rechnung löschen",
        "deleteInvoiceBtn": "löschen",
        "deleteMsg": "Möchten Sie Rechnung {{id}} wirklich löschen?",
        "paymentReceivedDate": "Zahlungseingang",
        "paymentConfirmation": "Zahlungsbestätigung",
        "sendConfirmation": "Bestätigung senden",
        "sending": "Wird gesendet…",
        "toastConfirmationSent": "Zahlungsbestätigung an Empfänger gesendet.",
        "toastConfirmationFailed": "Zahlungsbestätigung konnte nicht gesendet werden."
    },
    "uploads": {
        "title": "Dateien",
        "fetching": "laden...",
        "search": "nach Name oder ID suchen",
        "noUploads": "noch keine Dateien vorhanden",
        "fileId": "Datei-ID",
        "uploadDate": "Hochladedatum",
        "parseDate": "Verarbeitungsdatum",
        "totalAmount": "Gesamtbetrag",
        "actions": "Aktionen",
        "reread": "erneut lesen",
        "delete": "löschen",
        "rereading": "wird erneut gelesen…",
        "rereadSuccess": "Datei erfolgreich erneut gelesen",
        "rereadFailed": "Fehler beim erneuten Lesen",
        "deleteFailed": "Fehler beim Löschen",
        "confirmDelete": "diesen Upload-Eintrag löschen?",
        "noFileData": "keine Dateidaten gespeichert — erneutes Lesen nicht möglich",
        "count_one": "{{count}} Datei",
        "count_other": "{{count}} Dateien",
        "status": {
            "uploaded": "hochgeladen",
            "read": "gelesen",
            "partial": "teilweise",
            "failed": "fehlgeschlagen",
            "unknown": "unbekannt"
        }
    },
    "fileUpload": {
        "uploadError": "Fehler beim Hochladen",
        "attachFiles": "Dateien anhängen",
        "dropFiles": "Dateien hier ablegen oder",
        "browse": "durchsuchen",
        "anyType": "alle Dateitypen akzeptiert",
        "noFiles": "noch keine Dateien ausgewählt",
        "uploaded": "hochgeladen",
        "upload": "hochladen",
        "uploading": "wird hochgeladen…",
        "uploadFailed": "Hochladen fehlgeschlagen:",
        "invalidFileType": "Ungültiger Dateityp. Nur .xml, .pad und .dat Dateien werden akzeptiert.",
        "duplicateFile": "Diese Datei wurde bereits hochgeladen.",
        "fileUploadedSuccess": "\"{{name}}\" wurde hochgeladen.",
        "unknownError": "Unbekannter Fehler",
        "uploadTitle": "Datei hochladen",
        "uploadForDoctorLabel": "Für welchen Arzt sind diese Rechnungen?",
        "uploadForDoctorPlaceholder": "Bitte auswählen",
        "uploadAcceptedTypes": "PAD, PADNext Format · .pad, .dat und .xml Dateien",
        "uploadedFiles": "hochgeladene Dateien",
        "filesWillAppear": "die hochgeladenen Dateien\nerscheinen hier.",
        "uploadSuccess": "Datei hochgeladen – Rechnungen aktualisiert.",
        "summaryInvoices": "Rechnungen",
        "summaryAccountPatients": "Empfänger",
        "summaryLinkedPatients": "Verknüpfte Patienten",
        "summarySamePerson_one": "{{count}} Rechnung: behandelter Patient ist Rechnungsempfänger",
        "summarySamePerson_other": "{{count}} Rechnungen: behandelter Patient ist Rechnungsempfänger",
        "summaryTotal": "Gesamtbetrag",
        "possibleDuplicatesTitle_one": "{{count}} mögliches Duplikat übersprungen — gleicher Patient, gleiche abgerechnete Leistungen bereits vorhanden",
        "possibleDuplicatesTitle_other": "{{count}} mögliche Duplikate übersprungen — gleicher Patient, gleiche abgerechnete Leistungen bereits vorhanden",
        "duplicateUploadSame": "Diese Datei haben Sie bereits am {{date}} hochgeladen.",
        "duplicateUploadOther": "Diese Datei wurde bereits von {{name}} am {{date}} hochgeladen.",
        "duplicateUploadUnknownDoctor": "einem anderen Mitglied der Praxis",
        "duplicateUploadConfirmTitle": "Bereits hochgeladene Datei erkannt",
        "duplicateUploadConfirmSubtitle": "Möchten Sie diese Datei trotzdem hochladen?",
        "duplicateUploadConfirmUploadAnyway": "Trotzdem hochladen",
        "whatsNextTitle": "Wie geht es weiter?",
        "whatsNextMissingEmailBody": "Ergänzen Sie die Patienten — mindestens ein aus diesem Import angelegtes Konto hat noch keine E-Mail-Adresse. Ohne E-Mail können keine Rechnungen, Portal-Links oder Fragebögen versendet werden.",
        "whatsNextPatientsCta": "Zu den Patienten",
        "uploadFile": "Datei hochladen",
        "phaseReading": "Datei wird gelesen…",
        "phaseParsing": "Daten werden verarbeitet…",
        "phaseStoring": "Werte werden gespeichert…",
        "phaseComplete": "erfolgreich hochgeladen",
        "checking": "wird geprüft…",
        "conflictsTitle": "Folgende Rechnungen existieren bereits:",
        "conflictsSubtitle": "Wählen Sie aus, welche Rechnungen ersetzt werden sollen. Nicht ausgewählte Rechnungen bleiben unverändert.",
        "conflictRecipientLabel": "Rechnungsempfänger",
        "conflictPatientLabel": "Patient",
        "conflictDateLabel": "Erstellt am",
        "conflictAmountLabel": "Betrag",
        "conflictsReplace": "Ausgewählte ersetzen",
        "conflictsReplaceNone": "Keine ersetzen, fortfahren",
        "semanticDuplicatesTitle": "Mögliche Duplikate gefunden — bitte prüfen",
        "semanticDuplicatesSubtitle": "Gleicher Patient, gleiche abgerechnete Leistungen und Betrag wie eine bereits vorhandene Rechnung. Wählen Sie aus, welche trotzdem importiert werden sollen — der Rest wird übersprungen.",
        "semanticDuplicateExistingLabel": "Bereits vorhanden als",
        "semanticDuplicatesImportSelected_one": "Ausgewählte trotzdem importieren ({{count}})",
        "semanticDuplicatesImportSelected_other": "Ausgewählte trotzdem importieren ({{count}})",
        "semanticDuplicatesSkipAll": "Alle überspringen, fortfahren",
        "demoDisabled": "Upload ist im Demo-Modus deaktiviert.",
        "recipientConflictsTitle": "Mögliche Duplikate gefunden – bitte prüfen",
        "recipientConflictFilePad": "In dieser Datei",
        "recipientConflictExisting": "Vorhandener Datensatz",
        "recipientConflictMerge": "Gleiche Person – zusammenführen",
        "recipientConflictCreateNew": "Andere Person – neu anlegen",
        "recipientConflictsContinue": "Weiter & importieren",
        "emailsSent": "{{count}} E-Mail versendet",
        "emailsSent_other": "{{count}} E-Mails versendet",
        "emailsFailed": "{{count}} Versand fehlgeschlagen – bitte manuell senden",
        "emailsFailed_other": "{{count}} Versände fehlgeschlagen – bitte manuell senden",
        "uploadSuccessWithFailures": "Upload erfolgreich — {{count}} Rechnung konnte nicht automatisch gesendet werden",
        "uploadSuccessWithFailures_other": "Upload erfolgreich — {{count}} Rechnungen konnten nicht automatisch gesendet werden",
        "sendFailuresTitle": "Diese Rechnungen wurden nicht versendet",
        "sendFailureReasonNO_RECIPIENT_EMAIL": "Keine E-Mail-Adresse hinterlegt",
        "sendFailureReasonLEGAL_NOT_ACCEPTED": "Einwilligung noch nicht unterzeichnet – zuerst senden",
        "sendFailureReasonPOST_ONLY": "Patient ist als \"Nur Post\" markiert",
        "sendFailureReasonEMAIL_FAILED": "E-Mail-Zustellung fehlgeschlagen",
        "sendFailureReasonUnknown": "Konnte nicht gesendet werden",
        "flowHowItWorks": "So funktioniert's",
        "flowStoryboardTitle": "Von der Rechnungs-Datei bis zur bezahlten Rechnung",
        "flowStep1Title": "Upload Rechnungs-Datei",
        "flowStep1Desc": "Laden Sie Ihren PAD/Padnext-Export hoch – der Rest läuft automatisch.",
        "flowStep2Title": "Auslesen der Rechnungs-Datei",
        "flowStep2Desc": "Rechnungen, Rechnungsempfänger, Patienten und verknüpfte Patienten werden automatisch erkannt.",
        "flowStep3Title": "E-Mail des Patienten",
        "flowStep3Desc": "Tragen Sie die E-Mail-Adresse des Empfängers (einmalig) in der App ein, damit Fragebogen und Links empfangen werden können.",
        "flowStep4Title": "Einwilligung senden",
        "flowStep4Desc": "Versenden Sie die Einwilligung (per Fragebogen) per E-Mail oder lassen Sie vor Ort den QR-Code scannen — ohne unterschriebene Einwilligung kann die Rechnung nicht versendet werden.",
        "flowStep5Title": "Einwilligung unterschrieben",
        "flowStep5Desc": "Patient füllt die Pflichtfelder aus und unterschreibt die Einwilligung digital — erst danach kann die Rechnung versendet werden.",
        "flowStep6Title": "Rechnungslink senden",
        "flowStep6Desc": "Versenden Sie den Rechnungs-Link, damit die Rechnung jederzeit geöffnet werden kann.",
        "flowStep7Title": "Portal oder OTP-SMS",
        "flowStep7Desc": "Empfänger gelangt über Link zum Portal: SMS-Code zum Download der Rechnung oder Registrierung / Login fürs Patientenportal.",
        "flowStep8Title": "Als bezahlt markieren",
        "flowStep8Desc": "Nach Zahlungseingang werden Rechnungen automatisch in Medinvoice als bezahlt markiert – Abschluss des Workflows."
    },
    "patientPage": {
        "notFound": "Patient nicht gefunden",
        "linkRecipient": "Empfänger verknüpfen",
        "changeRecipient": "Empfänger ändern",
        "saving": "speichern…",
        "saveChanges": "Änderungen speichern",
        "recipientUnlinked": "Empfänger getrennt",
        "failedUnlink": "Trennung des Empfängers fehlgeschlagen.",
        "failedLoadRecipients": "Empfänger konnten nicht geladen werden.",
        "recipientLinked": "Empfänger verknüpft",
        "failedLink": "Verknüpfung des Empfängers fehlgeschlagen.",
        "noInvoices": "keine Rechnungen vorhanden",
        "noRecipient": "kein Empfänger verknüpft",
        "unlink": "trennen",
        "invoicesCard": "Rechnungen",
        "recipientCard": "Empfänger",
        "validationError": "Nachname ist erforderlich.",
        "tab_details": "Patient",
        "tab_invoices": "Rechnungen",
        "tab_recipient": "Empfänger",
        "tab_questionnaire": "Einwilligung",
        "nextPatient": "Nächster Patient",
        "statusRecipient": "Empfänger",
        "statusRecipientLinked": "Verknüpft",
        "statusRecipientNone": "Nicht verknüpft",
        "statusRecipientSubLinked": "Empfänger aktiv",
        "statusRecipientSubNone": "Kein Empfänger vorhanden",
        "statusQuestionnaireNeedsRecipient": "Zuerst Empfänger verknüpfen",
        "statusUnsent": "Nicht gesendet",
        "statusUnsentNone": "Alle gesendet",
        "statusUnsentSub": "{{count}} Rechnungen noch nicht gesendet",
        "noEmailBanner": "Dieser Patient hat keine E-Mail-Adresse hinterlegt. Mahnschreiben werden per Post versendet – das ist kostenpflichtig!",
        "changeRecipientTitle": "Empfänger ändern",
        "changeRecipientOwnOption": "Patient ist eigener Rechnungsempfänger",
        "changeRecipientOwnDesc": "Erstellt einen neuen Empfänger mit den Daten dieses Patienten.",
        "changeRecipientMinorNote": "Minderjährige brauchen einen Elternteil oder Erziehungsberechtigten als Rechnungsempfänger. Wählen Sie einen vorhandenen oder legen Sie einen neuen an.",
        "changeRecipientSelfExists":"Diese Person ist schon Rechnungsempfänger in Ihrer Praxis. Wählen Sie diesen Empfänger, statt einen zweiten anzulegen:",
        "changeRecipientSelfExistsPick": "Gleicher Name und Geburtsdatum — wird als Empfänger selbst markiert",
        "changeRecipientSearch": "Empfänger suchen…",
        "changeRecipientConfirm": "Empfänger übernehmen",
        "changeRecipientSuccess": "Empfänger wurde geändert.",
        "changeRecipientFailed": "Empfänger konnte nicht geändert werden.",
        "changeRecipientNew": "Neuen Empfänger erstellen",
        "changeRecipientCreate": "Erstellen & übernehmen",
        "identityReviewPending": "Patient hat beim Fragebogen abweichende Angaben gemacht — Prüfung erforderlich",
        "identityReviewTitle": "Abweichende Angaben aus dem Fragebogen",
        "identityReviewDesc": "Beim Ausfüllen des Fragebogens wurden andere Angaben gemacht als im System hinterlegt. Bitte prüfen, ob es sich um denselben Patienten handelt.",
        "identityReviewName": "Name",
        "identityReviewAddress": "Adresse",
        "identityReviewAccept": "Übernehmen",
        "identityReviewReject": "Verwerfen",
        "identityReviewAcceptSuccess": "Angaben wurden übernommen.",
        "identityReviewRejectSuccess": "Änderung wurde verworfen, bisherige Angaben bleiben bestehen.",
        "identityReviewFailed": "Aktion fehlgeschlagen."
    },
    "recipientPage": {
        "notFound": "Patient nicht gefunden",
        "sendQuestionnaire": "Fragebogen per E-Mail-Link senden",
        "resendQuestionnaire": "Fragebogen erneut per E-Mail-Link senden",
        "sendQuestionnaireSms": "Fragebogen per SMS senden",
        "resendQuestionnaireSms": "Fragebogen erneut per SMS senden",
        "smsCostNote": "Diese SMS kostet 0,09 €.",
        "smsLanguageLabel": "Sprache",
        "smsToLabel": "Telefon des Empfängers",
        "smsTitleLabel": "Titel",
        "smsTextLabel": "Nachricht",
        "questionnaireSmsLinkSent": "Fragebogen-Link erfolgreich per SMS gesendet.",
        "questionnaireSmsFailed": "Fehler beim Senden des Fragebogen-Links per SMS.",
        "addPatient": "Patient hinzufügen",
        "requestConsentRevoke": "Einwilligung widerrufen",
        "requestConsentRevokeQrTitle": "Widerruf – QR-Code",
        "requestConsentRevokeQrHint": "QR-Code scannen, damit der Patient den Widerruf seiner Einwilligung bestätigen kann.",
        "requestConsentRevokeOr": "oder Link senden an",
        "sendConsentRevokeEmail": "Per E-Mail senden",
        "sendConsentRevokeSms": "Per SMS senden",
        "consentRevokeEmailSent": "Widerruf-Link erfolgreich per E-Mail gesendet.",
        "consentRevokeEmailFailed": "Fehler beim Senden des Widerruf-Links per E-Mail.",
        "consentRevokeSmsSent": "Widerruf-Link erfolgreich per SMS gesendet.",
        "consentRevokeSmsFailed": "Fehler beim Senden des Widerruf-Links per SMS.",
        "markAsPatient": "Auch als Patient anlegen",
        "markAsPatientHint": "Anlegen, falls der Empfänger (z. B. ein Elternteil) selbst auch behandelt wird, dies aber bisher nicht als Patient erfasst wurde.",
        "markAsPatientDone": "Empfänger wurde auch als Patient angelegt und verknüpft.",
        "linkExistingPatient": "Bestehenden verknüpfen",
        "unlinkPatient": "Verknüpfung aufheben",
        "saving": "speichern…",
        "saveChanges": "Änderungen speichern",
        "questionnaireSent": "Fragebogen-Link erfolgreich gesendet.",
        "questionnaireFailed": "Fehler beim Senden des Fragebogen-Links.",
        "questionnairePdfFailed": "Fragebogen-PDF konnte nicht geladen werden.",
        "digitalSendingLabel": "Digitaler Versand",
        "postConsentLabel": "Briefversand",
        "questionnaireSectionTitle": "Einwilligung (digital)",
        "consentSectionTitle": "Einwilligung (Post)",
        "sendQuestionnaireEmail": "Per E-Mail senden",
        "resendQuestionnaireEmail": "Per E-Mail erneut senden",
        "sendQuestionnaireSmsShort": "Per SMS senden",
        "resendQuestionnaireSmsShort": "Per SMS erneut senden",
        "questionnaireQrScan": "QR-Code zum Vor-Ort-Scannen",
        "postOnlyConsentHint": "Alle Patienten dieses Empfängers sind als „Nur Brief“ markiert — die Einwilligung kann nur auf Papier (postalisch) eingeholt werden.",
        "setConsentManually": "Einwilligung manuell setzen",
        "questionnaireQr": "QR-Code",
        "questionnaireQrHint": "Lassen Sie den Empfänger diesen Code mit dem Smartphone scannen, um die Einwilligung vor Ort auszufüllen.",
        "qrFailed": "QR-Code konnte nicht generiert werden.",
        "patientUnlinked": "Patient getrennt",
        "failedUnlink": "Trennung des Patienten fehlgeschlagen.",
        "failedLoadPatients": "Patienten konnten nicht geladen werden.",
        "patientLinked": "Patient verknüpft",
        "failedLink": "Verknüpfung des Patienten fehlgeschlagen.",
        "unsentInvoices": "nicht versendete Rechnungen",
        "validationError": "Nachname und Geburtsdatum sind erforderlich.",
        "patientsCard": "Patienten",
        "noPatients": "keine Patienten verknüpft",
        "noExtraPatientsConnected": "Keine weiteren Patienten mit {{name}} verknüpft.",
        "unlink": "Verknüpfung aufheben",
        "colName": "Name",
        "colBirthDate": "Geburtsdatum",
        "colEmail": "E-Mail",
        "tab_patients": "Patienten",
        "tab_details": "Details",
        "tab_recipient": "Empfänger",
        "tab_invoices": "Rechnungen",
        "tab_questionnaire": "Einwilligung",
        "eyebrowPatient": "Patient",
        "summaryPatients": "{{count}} Patienten",
        "summaryOpenInvoices": "{{count}} offene Rechnungen",
        "statusPortal": "Portal",
        "statusPortalActive": "Aktiv",
        "statusPortalInactive": "Nicht registriert",
        "statusPortalSubActive": "Kann sich anmelden",
        "statusPortalSubInactive": "Kein Portal-Konto",
        "statusQuestionnaire": "Fragebogen",
        "statusQuestionnaireNone": "Nicht gesendet",
        "statusQuestionnaireSub": "Über Toolbar senden",
        "statusPatients": "Patienten",
        "statusPatientsSub": "{{count}} verknüpft",
        "statusInvoices": "Rechnungen",
        "statusInvoicesSub": "{{open}} offen · {{done}} bezahlt",
        "nextRecipient": "Nächster Patient",
        "nextRecipientTitle": "Nächster Patient – {{name}}",
        "questionnaire_submission": "Einreichung",
        "questionnaire_submittedAt": "eingereicht am",
        "questionnaire_submitted": "Einwilligung unterschrieben",
        "questionnaire_viewPdf": "PDF anzeigen",
        "questionnaire_additionalPatients_one": "{{count}} weiterer Patient im Fragebogen",
        "questionnaire_additionalPatients_other": "{{count}} weitere Patienten im Fragebogen",
        "questionnaire_patients": "Patienten",
        "questionnaire_noSubmission": "noch keine Einwilligung unterschrieben.",
        "questionnaire_previousSubmissions": "Frühere Einreichungen",
        "questionnaire_questions": "Fragen",
        "questionnaire_noQuestions": "keine Fragen eingereicht.",
        "questionnaire_openCount_one": "{{count}} offen",
        "questionnaire_openCount_other": "{{count}} offen",
        "questionnaire_allResolved": "alle beantwortet",
        "questionnaire_resolve": "als beantwortet markieren",
        "questionnaire_resolved": "beantwortet",
        "questionnaire_history": "Verlauf",
        "questionnaire_event_sent": "Einwilligung gesendet",
        "questionnaire_event_resent": "Einwilligung erneut gesendet",
        "questionnaire_event_opened": "Einwilligung geöffnet",
        "questionnaire_event_submitted": "Einwilligung unterschrieben",
        "questionnaire_event_revoked": "Einwilligung widerrufen",
        "category_general": "Allgemein",
        "category_billing": "Abrechnung",
        "category_appointment": "Termin",
        "category_treatment": "Behandlung",
        "category_insurance": "Versicherung",
        "colActions": "Aktionen",
        "sameAsMeButton": "Das bin ich",
        "sameAsMeBadge": "Identisch mit Empfänger",
        "sameAsMeTitle": "Patient mit Empfänger abgleichen?",
        "sameAsMeIntro": "Kontakt- und Stammdaten werden zusammengeführt: leere Felder werden vom jeweils anderen Datensatz ergänzt; wenn beide Seiten einen Wert haben, bleibt der Wert des Empfängers. Der Patient wird als dieselbe Person wie dieser Empfänger markiert.",
        "sameAsMeReplaceWarning": "{{name}} ist bereits als dieser Empfänger markiert. Wenn Sie fortfahren, wird diese Verknüpfung aufgehoben und stattdessen {{newName}} verknüpft.",
        "sameAsMeConfirm": "Abgleichen & verknüpfen",
        "sameAsMeClearTitle": "Gleiche Person entknüpfen?",
        "sameAsMeClearIntro": "Die Zuordnung \"dieser Patient ist der Empfänger\" wird entfernt. Bereits zusammengeführte Daten werden nicht automatisch zurückgesetzt.",
        "sameAsMeClearLink": "Verknüpfung entfernen",
        "sameAsMeClearConfirm": "Entfernen",
        "sameAsMeSuccess": "Stammdaten abgeglichen und Verknüpfung gespeichert.",
        "sameAsMeClearSuccess": "Verknüpfung entfernt.",
        "sameAsMeFailed": "Speichern fehlgeschlagen."
    },
    "onboarding": {
        "avvTitle": "Auftragsverarbeitungsvertrag",
        "avvDesc": "Bevor Sie loslegen, lesen und akzeptieren Sie bitte den Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO. Dies ist für die datenschutzkonforme Nutzung von Medinvoice erforderlich.",
        "avvAccept": "Ich akzeptiere den",
        "avvLink": "Auftragsverarbeitungsvertrag (AVV)",
        "avvSignatureLabel": "Digitale Unterschrift",
        "avvSignaturePlaceholder": "Vollständigen Namen eingeben",
        "avvSignatureHint": "Mit der Eingabe Ihres Namens unterzeichnen Sie diesen Vertrag digital.",
        "avvSign": "Akzeptieren & weiter",
        "next": "Weiter",
        "back": "Zurück",
        "finish": "Loslegen",
        "gettingStartedTitle": "Erste Schritte",
        "gettingStartedDesc": "Arbeiten Sie diese Kapitel durch, um Medinvoice optimal zu nutzen.",
        "percentCompleted": "{{percent}}% erledigt",
        "loadingProgress": "Fortschritt wird geladen …",
        "openSettings": "In Einstellungen öffnen",
        "goTo": "Ansehen",
        "viewDocs": "Doku: {{chapter}}",
        "flowOtherWays": "Keine Praxissoftware? Mit „Rechnung erstellen“ schreiben Sie Rechnungen direkt in Medinvoice. Mit Praxissoftware geht es auch ganz ohne Upload, über die Praxissoftware-Synchronisation. Beides finden Sie im nächsten Schritt.",
        "firstInvoiceTitle": "Rechnungen in Medinvoice bringen",
        "stepSyncConnect": "Praxissoftware-Synchronisation prüfen",
        "stepSyncConnectHint": "Mit Praxissoftware kommen Patienten und Rechnungen automatisch herein — über die Windows-Desktop-App oder im Browser (Chrome/Edge). Ohne Praxissoftware genügt es, die Seite einmal anzusehen.",
        "stepInvoiceFirst": "Erste Rechnung erstellen oder hochladen",
        "stepInvoiceFirstHint": "„Ansehen“ öffnet „Rechnung erstellen“: Patient wählen, Diagnose und GOÄ-Ziffern eintragen, prüfen, erstellen. Eine Rechnung per PAD-Datei oder Synchronisation zählt genauso.",
        "goaCheckTitle": "GOÄ-Prüfung",
        "stepGoaCheckRun": "Erste GOÄ-Prüfung durchgeführt",
        "stepGoaCheckRunHint": "Die Prüfung läuft automatisch: bei „Rechnung erstellen“ in Schritt 4, bei vorhandenen Rechnungen im Reiter „Leistungen“. Sie meldet Ziffern, die sich gegenseitig ausschließen, und überschrittene Höchstgrenzen.",
        "layoutTitle": "Rechnungs-Layout einrichten",
        "stepLayoutLogo": "Logo hochladen und Position wählen",
        "stepLayoutHeaderFooter": "Kopf- und Fußzeile einrichten",
        "stepLayoutQr": "QR-Code für Zahlung aktivieren",
        "stepLayoutInvoiceText": "Rechnungstext anpassen",
        "bankTitle": "Bank & Zahlungen",
        "stepBankIban": "IBAN und Steuernummer eintragen",
        "stepBankScanPay": "SCAN & PAY Name hinterlegen",
        "stepBankFinapi": "Konto für Zahlungsabgleich über BANKSapi verbinden",
        "stepBankSepa": "SEPA-Kontodaten für den Lastschrifteinzug prüfen",
        "invoiceTitle": "Rechnungseinstellungen",
        "stepInvoiceLegalAcceptance": "\"Rechtliche Zustimmung vor dem Senden erforderlich\" prüfen",
        "stepInvoiceSendOnUpload": "\"Senden bei Upload\" prüfen",
        "stepInvoiceEmailLinkModes": "E-Mail-Link Optionen festlegen",
        "dunningTitle": "Mahnwesen",
        "stepDunningIntervals": "Mahnintervalle festlegen",
        "stepDunningFines": "Mahngebühr einstellen",
        "stepDunningSendModes": "Versandweg der letzten Mahnung festlegen",
        "goaTitle": "GOÄ-Ziffern",
        "stepGoaFirstCode": "Erste GOÄ-Ziffer abgerechnet",
        "tagsGroupsTitle": "Tags & Gruppen",
        "stepTagsEnable": "Tags aktivieren",
        "stepTagsCreate": "Ersten Tag anlegen",
        "stepGroupsEnable": "Patientengruppen aktivieren",
        "stepGroupsAssign": "Erste Patientengruppe zugewiesen",
        "consentTitle": "Einwilligung",
        "stepConsentSent": "Erste Einwilligungsanfrage gesendet",
        "stepConsentSigned": "Erste Einwilligung erhalten",
        "teamTitle": "Team & Berechtigungen",
        "stepTeamInvite": "Weiteres Teammitglied eingeladen",
        "stepTeamPermissions": "Berechtigungen geprüft",
        "patientsTitle": "Patienten übernehmen",
        "stepPatientsImport": "Bestehende Patienten importieren",
        "stepPatientsImportHint": "Exportieren Sie Ihre Patientenliste aus der bisherigen Software als CSV-Datei. Auf der Seite Patienten oben rechts auf „…“ und dann auf „CSV importieren“ klicken — „Ansehen“ öffnet den Import direkt. Patienten entstehen außerdem automatisch beim Hochladen einer PAD-Datei und über die Praxissoftware-Synchronisation."
    },
    "settings": {
        "title": "Einstellungen",
        "bankManageViewOnly": "Sie können die Banktransaktionen einsehen, aber die Bankverbindung selbst nur als Arzt oder Admin verwalten (verbinden, trennen, synchronisieren). Bitten Sie einen Arzt oder Admin, dies hier einzurichten.",
        "pageLead": "Verwalten Sie Praxisprofil, Team, Abrechnungseinstellungen und Benachrichtigungen.",
        "navGeneral": "Allgemein",
        "navPractice": "Praxis",
        "navInvoicing": "Rechnungen",
        "navSending": "Versand",
        "navInfo": "Info",
        "dunningSchedule": "Mahnplan",
        "dunningScheduleDesc": "Wann jede Mahnstufe nach Versand der Rechnung ausgelöst wird und wie sie zugestellt wird.",
        "daysAfterSent": "Tage nach Versand",
        "legalFlagged": "Zur rechtlichen Prüfung markiert — kein automatischer Brief",
        "lateFees": "Mahngebühren",
        "lateFeesDesc": "Optionale Gebühren pro Mahnstufe zusätzlich zum Rechnungsbetrag.",
        "back": "zurück",
        "praxis": "Praxis",
        "bankDetails": "Bankverbindung/Steuernummer",
        "bankAndPayments": "Bank & Zahlungen",
        "cardPaymentSumup": "Kartenzahlung (SumUp)",
        "bankDetailsDesc": "Ihre Bankdaten, die auf der PDF-Rechnung gedruckt werden. Falls nichts angegeben ist, werden die Daten verwendet, die bei der Registrierung angegeben wurden.",
        "bankConnectionDesc": "Verbinden Sie Ihr Bankkonto, damit Zahlungseingänge automatisch erkannt werden.",
        "sepaPayment": "SEPA-Zahlung",
        "sepaPaymentDesc": "Das Bankkonto, das Medinvoice für die automatische monatliche Abrechnung verwendet.",
        "sepaAccountHolder": "Name des Kontoinhabers",
        "sepaAccountHolderPlaceholder": "z. B. Dr. Max Mustermann",
        "sepaMandate": "SEPA-Lastschrift",
        "sepaMandateDesc": "Aktualisieren Sie das Bankkonto für die automatische monatliche Abrechnung. Bei einer IBAN-Änderung wird die Mandatssequenz zurückgesetzt, sodass die nächste Einziehung als Erstlastschrift gilt.",
        "ibanFallbackNotice": "keine IBAN eingetragen – die Praxis-IBAN wird für Ihre Zahlungen verwendet.",
        "bicLookingUp": "BIC wird ermittelt …",
        "myProfile": "Mein Profil",
        "invoices": "Rechnungseinstellungen",
        "pdfFormat": "Rechnungs-PDF-Format",
        "dunning": "Mahnwesen",
        "praxisSoftwareSync": "Praxissoftware-Synchronisation",
        "datev": "DATEV",
        "datevTitle": "DATEV-Buchhaltungsexport",
        "datevDesc": "Von Ihrem Steuerberater vergeben — erforderlich, damit der DATEV/EXTF-Export eine echte Buchungsdatei statt einer einfachen CSV erzeugt. Für alle Patienten wird ein gemeinsames Sammelkonto verwendet, nicht ein Konto pro Person.",
        "datevBeraterNr": "Beraternummer",
        "datevBeraterNrDesc": "Die DATEV-Beraternummer Ihres Steuerberaters",
        "datevMandantNr": "Mandantennummer",
        "datevMandantNrDesc": "Die DATEV-Mandantennummer Ihrer Praxis bei diesem Steuerberater",
        "datevRevenueAccount": "Erlöskonto",
        "datevRevenueAccountDesc": "Das Sachkonto, auf das Ihr Steuerberater GOÄ-Erlöse bucht, z. B. 8400",
        "datevDebtorAccount": "Debitorenkonto (Gegenkonto)",
        "datevDebtorAccountDesc": "Das Sammel-Debitorenkonto für Patienten, z. B. 10000",
        "datevAccountLength": "Kontenlänge",
        "datevAccountLengthDesc": "Sachkontenlänge — wie viele Stellen der Kontenrahmen Ihres Steuerberaters verwendet (meist 4)",
        "fileLocations": "Dateipfade",
        "teamMembers": "Teammitglieder",
        "email": "E-Mail",
        "emailSmtp": "E-Mail (SMTP)",
        "tabSmtp": "SMTP",
        "tabTemplates": "Vorlagen",
        "docs": "Dokumentation",
        "zaala": "Medinvoice",
        "generic": "Allgemein",
        "subscription": "Abonnement",
        "subscriptionManage": "Abonnement kündigen oder ändern",
        "subscriptionManageDesc": "Wechseln Sie Ihren Abonnementplan oder kündigen Sie Ihr Konto.",
        "subscriptionManageBtn": "Abonnement kündigen / ändern",
        "dashboard": "Dashboard",
        "activityDays": "Aktivitätsfenster",
        "activityDaysDesc": "Aktivitäten der letzten N Tage auf dem Dashboard anzeigen.",
        "praxisDetails": "Praxisdetails",
        "praxisQrTitle": "QR-Code zur Patienten-Selbstregistrierung",
        "praxisQrDesc": "Ein dauerhafter QR-Code, den Patienten scannen können, um sich selbst zu registrieren – einmal herunterladen und ausdrucken oder auf Ihrer Website einbetten. Im Gegensatz zum einmaligen QR-Code unter \"Patient hinzufügen\" läuft dieser nie ab und funktioniert für beliebig viele Patienten.",
        "praxisQrRowTitle": "QR-Code",
        "praxisQrRowDesc": "Beim Scannen öffnet sich derselbe Selbstregistrierungs-Fragebogen, den Patienten auf ihrem eigenen Smartphone ausfüllen.",
        "praxisQrGenerate": "QR-Code erstellen",
        "praxisQrGenerating": "Wird erstellt…",
        "praxisQrLabelField": "Name auf dem QR-Code (SVG/PDF)",
        "praxisQrFormatField": "Dateiformat",
        "praxisQrSizeField": "Größe",
        "praxisQrSizeA7Desc": "74 × 105 mm — Kleines Etikett",
        "praxisQrSizeA6Desc": "105 × 148 mm — Postkarte",
        "praxisQrSizeDinLangDesc": "99 × 210 mm — Tischaufsteller",
        "praxisQrSizeA5Desc": "148 × 210 mm — Flyer",
        "praxisQrSizeA4Desc": "210 × 297 mm — Poster",
        "praxisQrSizeA3Desc": "297 × 420 mm — Großes Poster",
        "praxisQrDownloadBtn": "Herunterladen",
        "praxisQrDownloading": "Wird heruntergeladen…",
        "praxisQrDownloadError": "QR-Code konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut.",
        "praxisQrWidgetTextField": "Text des Website-Widgets",
        "praxisQrWidgetTextDesc": "Passen Sie den Text des eingebetteten Widgets unten an. Lassen Sie ein Feld leer, um den Standardtext zu verwenden.",
        "praxisQrWidgetHeadingField": "Überschrift",
        "praxisQrWidgetMessageField": "Nachricht",
        "praxisQrWidgetTextSave": "Text speichern",
        "praxisQrWidgetTextSaving": "Wird gespeichert…",
        "praxisQrWidgetTextSaved": "Gespeichert",
        "praxisQrWidgetTextError": "Text konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
        "praxisQrEmbedField": "Auf Ihrer Website einbetten",
        "praxisQrEmbedDesc": "Fügen Sie diesen Code in das HTML Ihrer Website ein, um eine \"Als Patient registrieren\"-Karte mit diesem QR-Code anzuzeigen. Breite/Höhe können Sie gerne an Ihre Seite anpassen.",
        "praxisQrEmbedPreviewTitle": "Widget-Vorschau",
        "praxisQrEmbedCopy": "Code kopieren",
        "praxisQrEmbedCopied": "Kopiert!",
        "praxisQrEmbedCopyError": "Kopieren fehlgeschlagen – bitte den Code manuell markieren und kopieren.",
        "praxisQrRegenerate": "Neu erstellen",
        "praxisQrRegenerateConfirm": "Neuen QR-Code erstellen? Jede bisher gedruckte, heruntergeladene oder eingebettete Kopie – einschließlich des Widgets auf Ihrer Website – funktioniert danach sofort nicht mehr.",
        "praxisQrLoadError": "QR-Code konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
        "praxisQrGenerateError": "QR-Code konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
        "myProfileTitle": "Mein Profil",
        "deleteAccount": "Konto löschen",
        "deleteAccountDesc": "Ihr Konto wird deaktiviert und Sie werden sofort abgemeldet. Ihre Rechnungsdaten bleiben gesetzlich erhalten.",
        "deleteAccountConfirmTitle": "Konto wirklich löschen?",
        "deleteAccountConfirmMsg": "Sie werden sofort abgemeldet. Ihr Login wird deaktiviert. Alle Rechnungsdaten bleiben erhalten.",
        "deleteAccountLastAdmin": "Sie sind der einzige Administrator. Bitte ernennen Sie zuerst einen anderen Administrator.",
        "roleChangeLastAdmin": "Dies ist der einzige Administrator der Praxis. Ernennen Sie zuerst ein anderes Mitglied zum Administrator, bevor Sie diese Rolle ändern.",
        "iban": "IBAN",
        "bic": "BIC",
        "taxNumber": "Steuernummer",
        "vatId": "Umsatzsteuer-ID",
        "scanPayName": "SCAN & PAY Name",
        "scanPayNameDesc": "Name des Rechnungsempfängers, der im QR-Code erscheint. Standard: Praxisname.",
        "scanPayNamePlaceholder": "z.B. Dr. Max Mustermann",
        "dunningIntervals": "Mahnintervalle",
        "dayAfterSent": "Tag nach dem Senden der Rechnung.",
        "days": "Tage",
        "legalSelf": "Ich handle rechtlich selbst",
        "legalSelfDesc": "Sie verwalten den Rechtsprozess mit Ihrem eigenen Anwalt.",
        "legalApi": "Paywise API verwenden",
        "legalApiDesc": "Rechtliche Einziehung automatisch an Paywise übergeben.",
        "finalNoticeDelivery": "Zustellung der letzten Mahnung",
        "finalNoticeDeliveryDesc": "Wie die letzte Mahnung versendet wird. Alle anderen Stufen verwenden standardmäßig E-Mail.",
        "emailOnly": "Nur E-Mail",
        "letterOnly": "Nur Brief",
        "emailAndLetter": "E-Mail & Brief",
        "dunningFinesEnabled": "Mahngebühren",
        "dunningFinesEnabledDesc": "Fügt für jede Mahnstufe eine konfigurierbare Gebühr hinzu.",
        "dunningFineLabel": "Gebühr",
        "dunningFallbackToLetter": "Brief-Fallback",
        "dunningFallbackToLetterDesc": "Wenn ein Empfänger keine E-Mail-Adresse hat, wird stattdessen ein Brief versendet.",
        "fallback.extraCost": "-> Zusatzkosten ca. EUR{{cost}} pro Brief",
        "sendVia": "Versand",
        "letterDelivery": "Briefzustellung",
        "legalHandling": "Inkasso-Verfahren",
        "paywiseApiKey": "Paywise API-Schlüssel",
        "paywiseApiKeyDesc": "Ihr Paywise API-Schlüssel. Jetzt registrieren auf paywise.de.",
        "paywiseApiKeyPlaceholder": "pw_live_...",
        "paywiseApiKeyConnected": "Schlüssel gespeichert",
        "paywiseApiKeyStoredPlaceholder": "•••••••• gespeichert – neuen Schlüssel eingeben zum Ersetzen",
        "paywiseDsgvoConfirm": "Ich bestätige, dass die Datenschutzerklärung meiner Praxis einen Hinweis enthält, dass überfällige Rechnungen an einen Inkasso-Dienstleister weitergegeben werden können.",
        "paywiseSubmitBtn": "An Paywise übergeben",
        "paywiseAlreadySubmitted": "An Paywise übergeben",
        "dispatchStandard": "Standard",
        "dispatchR1": "Einwurf",
        "dispatchR2": "Einschreiben RS",
        "dispatchR1Cost": "Einwurf-Einschreiben – ca. +€2–3 pro Brief",
        "dispatchR2Cost": "Einschreiben Standard – ca. +€2–4 pro Brief",
        "dunningM3EmailWarning": "Wir empfehlen, den Patienten bei der letzten Mahnstufe auch per Post zu benachrichtigen. Reine E-Mail-Mahnungen werden leichter übersehen und können Ihre rechtliche Position schwächen.",
        "dunningFallbackEnabledNote": "Hinweis: Sollte keine E-Mail-Adresse vorhanden sein, werden die Mahnschreiben per Post versendet. Das ist kostenpflichtig!",
        "dunningFallbackDisabledWarnM1": "Aktuelle Konfiguration: Patienten ohne E-Mail-Adresse werden bei M1 nicht benachrichtigt.",
        "dunningFallbackDisabledWarnM2": "Aktuelle Konfiguration: Patienten ohne E-Mail-Adresse werden bei M2 nicht benachrichtigt.",
        "dunningFallbackDisabledWarnM1M2": "Aktuelle Konfiguration: Patienten ohne E-Mail-Adresse werden bei M1 und M2 nicht benachrichtigt.",
        "invoiceDueAfter": "Rechnung fällig nach",
        "invoiceDueAfterDesc": "Wie lange nach dem Senden bis eine Rechnung fällig ist.",
        "paymentTolerance": "offener Toleranzbetrag",
        "paymentToleranceDesc": "Wenn der Restbetrag kleiner oder gleich diesem Wert ist, gilt die Rechnung als bezahlt.",
        "sendMethods": "Versandmethode(n)",
        "sendMethodsDesc": "Wie Rechnungen an Empfänger versendet werden.",
        "sendOnUpload": "Senden bei Upload",
        "sendOnUploadDesc": "E-Mail-Link automatisch an den Empfänger senden, unmittelbar nachdem eine Rechnungsdatei hochgeladen wurde.",
        "sendOnUploadHint": "Die E-Mail wird nur gesendet, wenn die E-Mail-Adresse und Telefonnummer des Empfängers vorhanden ist.",
        "sendOnQuestionnaireSubmit": "Senden nach Einwilligung",
        "sendOnQuestionnaireSubmitDesc": "E-Mail-Link automatisch an den Empfänger senden, sobald der Empfänger die Einwilligung ausgefüllt und unterschrieben hat.",
        "sendOnQuestionnaireSubmitHint": "Betrifft nur Rechnungen, die noch nicht versendet wurden, z. B. weil die E-Mail-Adresse oder die Einwilligung vorher gefehlt hat.",
        "requireLegalAcceptance": "Rechtliche Zustimmung vor dem Senden erforderlich",
        "requireLegalAcceptanceDesc": "Wenn aktiviert, können Rechnungen nur gesendet werden, nachdem der Empfänger den Fragebogen ausgefüllt und den AGBs und dem Datenschutz zugestimmt hat.",
        "requireLegalAcceptanceWarning": "Warnung: Rechnungen werden gesendet, ohne die rechtliche Zustimmung des Empfängers zu den AGBs und dem Datenschutz zu bestätigen.",
        "questionnairePostOption": "Postversand in der Einwilligung anbieten",
        "questionnairePostOptionDesc": "Patienten können in der Einwilligung (per E-Mail oder QR-Code) wählen, Rechnungen ausschließlich per Post zu erhalten. Dann wird nur die postalische Einwilligung erteilt und der Patient als „Nur Brief“ markiert.",
        "requireLegalAcceptanceConfirm": "Sind Sie sicher, dass Sie Rechnungen ohne die rechtliche Zustimmung des Empfängers zu AGBs und Datenschutz senden möchten?",
        "questionsEnabled": "Patientenfragen aktiviert",
        "questionsEnabledDesc": "Wenn deaktiviert, können Empfänger keine Fragen über das Portal stellen und der Bereich Fragen bei Rechnungen wird ausgeblendet.",
        "tagsEnabled": "Tags aktiviert",
        "tagsEnabledDesc": "Wenn deaktiviert, sind Tags in der Rechnungsübersicht, im PAD-Import und in der Rechnung nicht mehr verfügbar.",
        "hideCategoryLabels": "Kennzeichen ausblenden",
        "hideCategoryLabelsDesc": "Wenn aktiviert, werden Kennzeichnungen wie \"Auslage / Material:\" oder \"Porto:\" auf Rechnungen und im PDF nicht mehr angezeigt.",
        "groupsEnabled": "Patientengruppen aktiviert",
        "groupsEnabledDesc": "Wenn deaktiviert, sind Patientengruppen in der Patientenübersicht und bei Patientenakten nicht mehr verfügbar.",
        "csvAutoExport": "Automatischer CSV-Export",
        "csvAutoExportDesc": "Sendet regelmäßig einen CSV-Rechnungsexport per E-Mail.",
        "csvExtraEmails": "Weitere E-Mail-Empfänger",
        "csvExtraEmailsDesc": "Zusätzliche E-Mail-Adressen, die den Export erhalten.",
        "csvExtraEmailsPlaceholder": "E-Mail-Adresse eingeben und Enter drücken",
        "csvInterval": "Versandintervall",
        "csvIntervalDesc": "Wie oft der Export automatisch verschickt wird.",
        "csvIntervalDays": "Tage",
        "csvIntervalWeeks": "Wochen",
        "csvIntervalMonths": "Monate",
        "csvWhichInvoices": "Welche Rechnungen?",
        "csvWhichInvoicesDesc": "Welche Rechnungen im CSV-Export enthalten sind.",
        "csvFilterAll": "Alle",
        "csvFilterPaid": "Nur bezahlt",
        "csvFilterPaidPartial": "Bezahlt & Teilzahlung",
        "csvAmountMin": "Betrag ab (€)",
        "csvAmountMinDesc": "Nur Rechnungen ab diesem Betrag exportieren.",
        "emailLink": "E-Mail-Link",
        "postOffice": "Post",
        "bdtFileLocation": "BDT-Dateispeicherort",
        "bdtFileLocationDesc": "Pfad zur BDT-Datei für den Import von Patientendaten.",
        "padFolderLocation": "PAD-Ordnerspeicherort",
        "padFolderLocationDesc": "Ordner, in dem PAD-Abrechnungsdateien gespeichert sind.",
        "smtpConfigured": "Ihr benutzerdefinierter SMTP-Server wird zum Senden von E-Mails verwendet.",
        "smtpNotConfigured": "kein benutzerdefiniertes SMTP konfiguriert — Medinvoice E-Mail-Server wird verwendet.",
        "smtpDisabled": "SMTP deaktiviert — E-Mails werden nicht über diesen Server gesendet.",
        "smtpActive": "SMTP aktiviert",
        "smtpActiveDesc": "SMTP ein- oder ausschalten.",
        "smtpClear": "Felder löschen",
        "smtpHost": "Host",
        "smtpHostDesc": "z.B. smtp.beispiel.de",
        "smtpPort": "Port",
        "smtpPortDesc": "Übliche Werte: 587 (STARTTLS) oder 465 (SSL/TLS)",
        "smtpSecure": "SSL/TLS",
        "smtpSecureDesc": "Für Port 465 aktivieren. Für STARTTLS (Port 587) deaktiviert lassen.",
        "smtpSecureLabel": "SSL/TLS verwenden",
        "smtpUsername": "Benutzername",
        "smtpUsernameDesc": "SMTP-Anmeldename oder E-Mail",
        "smtpPassword": "Passwort / API-Schlüssel",
        "smtpPasswordDesc": "SMTP-Passwort oder app-spezifischer Schlüssel",
        "smtpFromAddress": "Absenderadresse",
        "smtpFromAddressDesc": "E-Mail-Adresse des Absenders.",
        "smtpFromName": "Absendername",
        "smtpFromNameDesc": "Anzeigename, der Empfängern als Absender angezeigt wird.",
        "smtpFromNamePlaceholder": "z. B. Praxis Müller",
        "smtpTest": "Server testen",
        "smtpTestTitle": "Test-E-Mail senden",
        "smtpTestDesc": "Geben Sie eine E-Mail-Adresse ein, an die eine Testnachricht gesendet wird.",
        "smtpTestSend": "senden",
        "smtpTestSending": "wird gesendet…",
        "smtpTestOk": "Test-E-Mail erfolgreich gesendet.",
        "smtpTestFailed": "Test-E-Mail konnte nicht gesendet werden.",
        "emailTemplates": "E-Mail-Vorlagen",
        "emailSubjectPlaceholder": "E-Mail-Betreff (optional)",
        "emailSubject": "Betreff",
        "emailBody": "Nachricht",
        "emailPreview": "Vorschau",
        "emailSendToMe": "an mich senden",
        "emailSendConfirmDesc": "Diese Test-E-Mail wird mit Beispieldaten gesendet.",
        "emailSendTo": "An",
        "emailPreviewTitle": "E-Mail Vorschau",
        "emailTemplateInvoice": "Neue Rechnung",
        "emailTemplateInvoiceDesc": "Text beim Senden einer neuen Rechnung.",
        "emailTemplateResent": "Erneut gesendete Rechnung",
        "emailTemplateResentDesc": "Text beim erneuten Senden einer Rechnung.",
        "emailTemplateFriendly": "freundliche Erinnerung",
        "emailTemplateFriendlyDesc": "Text für die erste Mahnung.",
        "emailTemplateDemanding": "nachdrückliche Erinnerung",
        "emailTemplateDemandingDesc": "Text für die zweite Mahnung.",
        "emailTemplateFinal": "letzte Mahnung",
        "emailTemplateFinalDesc": "Text für die letzte Mahnung.",
        "emailTemplateQuestionnaire": "Einwilligung",
        "emailTemplateQuestionnaireDesc": "Text beim Versenden der Einwilligung zum digitalen Rechnungsversand.",
        "tabPost": "Post",
        "tabLetterTemplates": "Brief-Vorlagen",
        "letterTemplatesDesc": "Diese Texte werden als Deckblatt vor der Rechnung eingefügt, wenn Sie per Post versenden.",
        "letterTemplateInvoice": "Rechnung",
        "letterTemplateLegal": "Inkasso / Rechtlich",
        "letterTemplateInvoiceInfo": "Die Rechnung wird als ärztliche Liquidation versendet, wie unter 'PDF ansehen' dargestellt. Kein separates Deckblatt erforderlich.",
        "letterTemplateLegalInfo": "Informationen zur Rechtsverfolgung sind bereits im Mahnschreiben M3 enthalten. Kein separate Vorlage nötig.",
        "letterTemplateDesc": "Wird als Deckblatt vor der Rechnung gedruckt. Leer lassen für kein Deckblatt.",
        "letterQrCode": "Scan & Pay QR-Code einfügen",
        "letterPreview": "Vorschau",
        "letterPreviewTitle": "Brief-Vorschau",
        "noTeamMembers": "keine Teammitglieder gefunden.",
        "teamPlanHint": "Ihr Plan enthält {{doctors}} Arzt/Ärzte (Ärzte & Admins) und {{staff}} Mitarbeiter. Zusätzliche Ärzte/Admins kosten €39/Monat, zusätzliche Mitarbeiter €9,90/Monat (jeweils zzgl. 19% MwSt.).",
        "addMemberCostWarn": "Das Hinzufügen dieses Mitglieds kostet {{fee}}/Monat (zzgl. 19% MwSt.) und wird sofort in voller Höhe für den laufenden Monat berechnet. Sie können das Mitglied jederzeit wieder entfernen; es gelten unsere AGB.",
        "deleteMemberBillingNote": "Die Abrechnung von {{fee}}/Monat für diesen Platz bleibt unabhängig von der gewählten Option für den laufenden Monat bestehen — die Reduzierung wirkt sich erst ab dem 1. des Folgemonats auf Ihre Rechnung aus.",
        "deleteAckLabel": "Ich verstehe, dass {{fee}}/Monat für {{name}} diesen Monat weiterhin berechnet werden.",
        "deleteModeImmediate": "Sofort löschen",
        "deleteModeImmediateDesc": "Der Zugriff wird sofort entzogen. Um dies rückgängig zu machen, müssen Sie das Mitglied erneut hinzufügen.",
        "deleteModeEndOfMonth": "Zum Monatsende löschen",
        "deleteModeEndOfMonthDesc": "Der Zugriff bleibt bis dahin vollständig bestehen. Die Entfernung erfolgt automatisch zum 1. des Folgemonats — Sie können sie jederzeit vorher abbrechen.",
        "scheduledForRemoval": "Entfernung geplant: {{date}}",
        "cancelScheduledRemoval": "Entfernung abbrechen",
        "deleteMemberTitle": "{{name}} entfernen?",
        "roleDesc": {
            "1": "Standardmäßig kein Rechnungszugriff — Ansicht und Bearbeitung können pro Person in der Tabelle unten freigegeben werden. Sieht die Patienten der gesamten Praxis.",
            "2": "Sieht eigene Rechnungen; kann Rechnungen erstellen, bearbeiten und löschen. Sieht die Patienten der gesamten Praxis.",
            "3": "Vollzugriff auf Einstellungen und Teammitglieder; sieht eigene Rechnungen, sofern nicht zusätzlich freigegeben. Sieht die Patienten der gesamten Praxis.",
            "5": "Sieht standardmäßig alle Rechnungen der Praxis; Ansicht und Bearbeitung können pro Person in der Tabelle unten angepasst werden. Sieht die Patienten der gesamten Praxis."
        },
        "rolesInfoBtn": "Rollen-Info",
        "rolesInfoTitle": "Rollenübersicht",
        "sharedSettingsNoticeP1": "Einstellungen wie Mahnwesen-Fristen, Rechnungsformat oder E-Mail-Vorlagen gelten für die gesamte Praxis — sie lassen sich nicht pro Arzt oder Mitglied getrennt festlegen.",
        "sharedSettingsNoticeP2": "Bank & Zahlungen und die Rechnungs-PDF-Gestaltung sind die Ausnahme: IBAN/BIC, Bankverbindung und das PDF-Layout (Kopf-/Fußzeile, Logo, Schrift) sind pro Arzt/Admin eigenständig und greifen nur dann auf die Praxis-Vorgabe zurück, wenn nichts Eigenes hinterlegt ist. Jeder bearbeitet dabei nur seine eigenen Einstellungen.",
        "sharedSettingsNoticeP3": "Die Berechtigungen unten bestimmen nur, wer diese Einstellungen sehen oder ändern darf.",
        "permissionsHeading": "Berechtigungen",
        "rolesTable": {
            "hint": "Rechnungen sind standardmäßig privat für jede Person — nicht für andere Ärzte sichtbar. Patienten sieht dagegen die gesamte Praxis gemeinsam. Diese Tabelle regelt die Rechnungssichtbarkeit sowie weitere Berechtigungen.",
            "feature": "Funktion",
            "groupInvoices": "Rechnungen & Patienten",
            "groupAdmin": "Praxisverwaltung",
            "groupBank": "Bank",
            "groupTags": "Tags & Gruppen",
            "groupDashboard": "Dashboard",
            "viewAllInvoices": "Alle Rechnungen (praxisweit)",
            "viewAllInvoicesHint": "Ohne diese Berechtigung sieht diese Person nur ihre eigenen Rechnungen. Mit dieser Berechtigung sieht sie die aller Ärzte der Praxis.",
            "viewAllInvoicesSub": "sonst: nur eigene",
            "viewAllFixedHint": "Diese Rolle sieht und bearbeitet immer nur ihre eigenen Rechnungen — das ist fest vorgegeben, keine vergebbare Berechtigung.",
            "bankFixedOwnHint": "Diese Rolle sieht und gleicht immer nur das eigene Bankkonto ab — das ist fest vorgegeben, keine vergebbare Berechtigung.",
            "accessNone": "Aus",
            "accessView": "Ansehen",
            "accessEdit": "Bearbeiten",
            "accessEditDelete": "Bearbeiten + Löschen",
            "editInvoices": "Rechnungen erstellen / bearbeiten",
            "deleteInvoices": "Rechnungen löschen",
            "viewPatients": "Patienten anzeigen",
            "editPatients": "Patienten bearbeiten",
            "manageRecipients": "Empfänger & Patienten verwalten",
            "manageRecipientsHint": "Patienten sind für alle in der Praxis sichtbar — nicht Teil dieser Berechtigung. \"Bearbeiten\" erlaubt Anlegen/Ändern, \"Bearbeiten + Löschen\" zusätzlich das Löschen (betrifft ggf. auch Rechnungen anderer Ärzte für denselben Patienten) — standardmäßig für Ärzte und Administratoren, medizinisches Fachpersonal und Buchhaltung benötigen eine explizite Freigabe.",
            "bankPayments": "Bank & Zahlungen",
            "bankReconcile": "Bank-Transaktionen abgleichen",
            "bankReconcileHint": "Transaktionen manuell Rechnungen zuordnen, Zuordnung aufheben, ignorieren/wiederherstellen und Patienten bei einer möglichen Doppelzahlung benachrichtigen. Unabhängig von \"Bank & Zahlungen\" (Ansehen) — jemand kann die Kontoauszüge sehen, ohne daran etwas ändern zu dürfen. Verbinden/Trennen/Synchronisieren der Bankverbindung selbst bleibt immer Ärzten/Administratoren vorbehalten.",
            "reports": "Berichte & CSV-Export",
            "dunning": "Mahnwesen & Inkasso",
            "datev": "DATEV-Export",
            "datevHint": "Steuerberater-Kontendaten für den DATEV-Export (EXTF). Standardmäßig nur für Administratoren, da ein falscher Wert die Buchhaltung der Praxis durcheinanderbringt.",
            "datevSub": "sonst: nur Administrator",
            "createForOthers": "Rechnungen für andere Ärzte erstellen",
            "createForOthersSub": "Hochladen und manuell erstellen – sonst nur für sich selbst",
            "createForOthersHint": "Ärztinnen, Ärzte und Administratoren erstellen und laden Rechnungen standardmäßig nur für sich selbst hoch. Mit diesem Recht wählen sie die behandelnde Ärztin bzw. den Arzt aus. Mitarbeitende ohne eigene Rechnungen wählen immer.",
            "createForOthersStaff": "wählt immer",
            "createForOthersStaffHint": "Mitarbeitende haben keine eigenen Rechnungen und wählen beim Erstellen immer die Ärztin bzw. den Arzt.",
            "manageSettings": "Einstellungen & Team",
            "viewTagsGroups": "Tags & Gruppen ansehen",
            "editTagsGroups": "Tags & Gruppen verwalten",
            "dashboardTasks": "Aufgaben im Dashboard",
            "dashboardTasksHint": "Zeigt die Aufgabenliste (unversendete Rechnungen, fehlende Einwilligung, offene Fragen u.a.) auf dem Dashboard an. Medizinische Fachangestellte und Buchhaltung sehen sonst ein vereinfachtes Dashboard ohne diese Liste.",
            "dashboardTasksSub": "sonst: ausgeblendet",
            "pvsSavings": "PVS-Ersparnisanzeige",
            "pvsSavingsHint": "Zeigt die Kostenersparnis gegenüber einer PVS-Abrechnungsstelle auf dem Dashboard an. Die Gebühren-Seite selbst (wo dies konfiguriert wird) bleibt unabhängig davon nur für Administratoren zugänglich — eine Person ohne Administratorrechte mit dieser Berechtigung sieht den Betrag, kann die Seite aber nicht öffnen.",
            "pvsSavingsSub": "sonst: ausgeblendet",
            "bankDashboard": "Bankabgleich im Dashboard",
            "cardQr": "Kartenzahlung am Empfang",
            "cardQrSub": "SumUp-QR-Code und Kartenterminal",
            "cardQrHint": "Darf bei offenen Rechnungen einen QR-Code für die Kartenzahlung über SumUp zeigen und den Betrag an ein gekoppeltes SumUp-Kartenterminal senden; die Rechnung wird nach der Zahlung automatisch als bezahlt markiert. Ärzt:innen und Admins standardmäßig, Mitarbeitende nur, wenn freigegeben.",
            "bankDashboardHint": "Zeigt die Kontostand-Übersicht und eine Vorschau der letzten Transaktionen auf dem Dashboard an. Unabhängig von \"Bank & Zahlungen\" — jemand kann die Bank-Seite öffnen dürfen, ohne dass dieser Betrag auch ungefragt auf dem gemeinsamen Dashboard erscheint.",
            "bankDashboardSub": "sonst: ausgeblendet",
            "bankDoctorScope": "Konto",
            "bankDoctorScopeAll": "Alle Ärzte",
            "own": "eigene",
            "all": "alle",
            "allRO": "alle (nur lesen)"
        },
        "addMember": "+ Mitglied hinzufügen",
        "newMember": "neues Mitglied",
        "editMember": "Mitglied bearbeiten",
        "addMemberBtn": "Mitglied hinzufügen",
        "saveChangesBtn": "Änderungen speichern",
        "daysUnit": "Tage",
        "weeksUnit": "Wochen",
        "saved": "gespeichert",
        "saveChanges": "Änderungen speichern",
        "emailAccountDesc": "Die mit Ihrem Konto verknüpfte E-Mail-Adresse.",
        "deviatingAddressTitle": "Alternativer Rechnungsabsender",
        "deviatingAddressDesc": "Optional. Wird als Absender auf Ihren Rechnungen verwendet, statt der Praxis. Einzelne Felder leer lassen, um dort die Praxis-Angabe zu verwenden.",
        "senderOrgName": "Name Organisation",
        "company": "Unternehmen",
        "version": "Version",
        "roleRequired": "Rolle *",
        "emailRequired": "E-Mail *",
        "passwordLabel": "Passwort",
        "passwordKeep": "(leer lassen zum Behalten)",
        "changePassword": "Passwort ändern",
        "currentPassword": "aktuelles Passwort",
        "newPassword": "neues Passwort",
        "confirmPassword": "Passwort bestätigen",
        "pwAllFieldsRequired": "Alle Felder sind erforderlich.",
        "pwTooShort": "Passwort muss mindestens 6 Zeichen lang sein.",
        "pwMismatch": "Passwörter stimmen nicht überein.",
        "pwError": "Passwort konnte nicht geändert werden.",
        "resetMemberPasswords": "Teampasswörter zurücksetzen",
        "resetMemberPasswordsDesc": "Als Admin können Sie Passwörter für andere Teammitglieder zurücksetzen.",
        "resetPassword": "zurücksetzen",
        "resetPasswordFor": "Passwort zurücksetzen für {{name}}",
        "resetPasswordBtn": "Passwort setzen",
        "specialtyRequired": "Fachgebiet *",
        "specialty": "Fachgebiet",
        "selectSpecialty": "Fachgebiet wählen",
        "saving": "speichern…",
        "emailInvalid": "Ungültige E-Mail-Adresse.",
        "passwordTooShort": "Mindestens 8 Zeichen erforderlich.",
        "passwordNeedsSpecial": "Mindestens ein Sonderzeichen erforderlich (!@#$%^&* …).",
        "errorAddMember": "Nachname, E-Mail und Passwort sind erforderlich.",
        "errorFailedAddDoctor": "Mitglied konnte nicht hinzugefügt werden.",
        "errorEditMember": "Nachname und E-Mail sind erforderlich.",
        "errorFailedSave": "Änderungen konnten nicht gespeichert werden.",
        "errorBugTitleDesc": "Titel und Beschreibung sind erforderlich.",
        "errorFailedSend": "Senden fehlgeschlagen. Bitte erneut versuchen.",
        "emailLinkEnable": "E-Mail-Link aktivieren",
        "emailLinkEnableDesc": "Ein E-Mail-Link wird an den Empfänger gesendet.",
        "emailLinkOptions": "E-Mail-Link Optionen",
        "emailLinkOptionsDesc": "Wie der Empfänger seine Rechnung erhält und aufruft. Mindestens eine Option muss aktiv sein.",
        "emailLinkLoginDesc": "Der Empfänger meldet sich mit seiner E-Mail-Adresse und seinem Passwort an, um seine Rechnung zu öffnen.",
        "emailLinkSmsOtpDesc": "Der Empfänger erhält die Rechnung direkt per Einmal-SMS-Code — kein Account-Login erforderlich.",
        "postSendOnUploadDesc": "Rechnung automatisch per Post versenden, sobald eine PAD-Datei hochgeladen wurde.",
        "post": "Postversand",
        "postBillingNotice": "Hinweis: Jeder versendete Brief wird Ihnen in Rechnung gestellt. Die Kosten werden am Ende des Monats abgebucht.",
        "postTrialDisabled": "Postversand ist während der Testphase nicht verfügbar. Bitte upgraden Sie Ihren Plan, um Briefe zu versenden.",
        "postEnable": "Postversand aktivieren",
        "postEnableDesc": "Ermöglicht das Versenden von Rechnungen per Post.",
        "postColor": "Farbe",
        "postColorDesc": "Druckfarbe für Briefe.",
        "postColorOption": "Farbe",
        "postPrint": "Druck",
        "postPrintDesc": "einseitig oder beidseitig drucken.",
        "postEnvelope": "Umschlag",
        "postEnvelopeDesc": "Art des Briefumschlags.",
        "postDispatch": "Versand",
        "postDispatchDesc": "wie schnell der Brief versendet wird.",
        "postDispatchStandard": "Standard",
        "postRegisteredMail": "Einschreiben",
        "postRegisteredMailDesc": "Brief als Einschreiben versenden.",
        "postRegisteredMailNone": "kein Einschreiben",
        "postRegisteredMailR1": "Einwurf-Einschreiben",
        "postRegisteredMailR2": "Einschreiben (Standard)",
        "postRegisteredMailNationalOnly": "Einschreiben können nur national versendet werden.",
        "postShipping": "Versandbereich",
        "postShippingDesc": "Zustellbereich des Briefes.",
        "postShippingNational": "National",
        "postShippingInternational": "International",
        "postEstimatedCost": "Kosten pro Brief:",
        "postEstimatedCostSuffix": "(Schätzung)",
        "postColorBW": "S/W",
        "postPrintSimplex": "simplex",
        "postPrintDuplex": "duplex",
        "postEnvelopeWindowRight": "Fenster (rechts)",
        "postEnvelopeWindowLeft": "Fenster (links)",
        "postEnvelopeC4": "C4",
        "postWillBeSentTo": "wird geschickt an",
        "postWillBeSentFrom": "wird geschickt von",
        "postPages": "Seiten",
        "postPagesDesc": "Anzahl der Seiten für die Kostenschätzung",
        "postVatIncluded": "inkl. 19% MwSt.",
        "reports": "Berichte",
        "reportInterval": "Berichtsintervall",
        "reportIntervalDesc": "Wie oft automatisch ein Bericht erstellt werden soll.",
        "monthsUnit": "Monate",
        "everyDay": "Jeden Tag",
        "everyWeek": "Jede Woche",
        "everyNWeeks": "Alle X Wochen",
        "everyMonth": "Jeden Monat",
        "everyNMonths": "Alle X Monate",
        "monday": "Mo",
        "tuesday": "Di",
        "wednesday": "Mi",
        "thursday": "Do",
        "friday": "Fr",
        "saturday": "Sa",
        "sunday": "So",
        "firstDayOfMonth": "Erster Tag",
        "lastDayOfMonth": "Letzter Tag",
        "generateReport": "Bericht jetzt erstellen",
        "generateReportDesc": "Einen PDF-Bericht aller Rechnungsaktivitäten für den angemeldeten Arzt herunterladen.",
        "generateNow": "jetzt generieren",
        "generating": "wird generiert…"
    },
    "docs": {
        "eyebrow": "DOKUMENTATION",
        "title": "Dokumentation",
        "pageLead": "Wie Rechnungen, Mahnwesen und Bankabgleich in Ihrer Praxis funktionieren.",
        "schnellstart": {
            "title": "Schnellstart",
            "q0": "Der vollständige Ablauf von der Abrechnungsdatei bis zur bezahlten Rechnung — in 8 Schritten.",
            "a0": "<ol class=\"docs-steps\"><li><strong>PAD- oder PADnext-Datei hochladen</strong><br>Exportieren Sie Ihre PAD- oder PADnext-Datei aus der Praxissoftware und laden Sie diese im Dashboard hoch. Eine Datei startet den gesamten Abrechnungsprozess.<br><span class=\"docs-path\">Dashboard › Hochladen</span></li><li><strong>Rechnungen &amp; Empfänger werden eingelesen</strong><br>Medinvoice analysiert die Datei automatisch — Rechnungen, Empfänger und verknüpfte Patienten werden erkannt und angelegt. Kein manuelles Eintippen nötig.</li><li><strong>E-Mail-Adresse des Empfängers hinterlegen</strong><br>Tragen Sie beim ersten Mal die E-Mail-Adresse des Empfängers ein, damit Fragebogen und Rechnungslink zugestellt werden können. Sollten Sie das Onboarding vor Ort durchführen (s. Schritt 4), übernimmt der Rechnungsempfänger dies für Sie.<br><span class=\"docs-path\">Patienten › Empfänger öffnen › E-Mail bearbeiten</span></li><li><strong>Fragebogen versenden</strong><br>Senden Sie zunächst den Fragebogen an den Patienten — dieser Schritt ist nötig, bevor die Rechnung digital versendet werden kann. Der Patient kann alternativ vor Ort einen QR-Code scannen und wird direkt zum Fragebogen geleitet.<br><em>Tipp: Der Fragebogen ist der beste erste Kontakt — er sammelt Patientendaten, Einwilligung und Rechnungsadresse in einem Schritt. Etwaige Korrekturen werden automatisch in Medinvoice übernommen.</em></li><li><strong>Patient füllt aus &amp; unterzeichnet Einwilligung</strong><br>Der Patient füllt die Pflichtfelder aus, akzeptiert mit seiner digitalen Unterschrift den digitalen Rechnungsversand und Datenschutz. Die Angaben werden automatisch in Medinvoice übernommen und der Fragebogen als PDF hinterlegt.</li><li><strong>Rechnungslink versenden</strong><br>Senden Sie den persönlichen Patientenportal-Link per E-Mail — einzeln, für mehrere oder automatisch für alle. Der Patient kann die Rechnung jederzeit öffnen — ohne App-Installation.<br><em>Hinweis: Noch nicht versendete Rechnungen können teilweise bearbeitet werden (Betrag, Stammdaten). Nach dem Versand ist eine direkte Bearbeitung nicht mehr möglich.</em></li><li><strong>Patient erhält Link zur Rechnung</strong><br>Der Patient öffnet den Link und entscheidet selbst:<br>1) Rechnung direkt als PDF herunterladen — per SMS-Einmalcode (OTP)<br>2) Im Portal registrieren, um alle Rechnungen der Praxen mit Medinvoice® zentral einzusehen und zu bezahlen.</li><li><strong>Als bezahlt markieren</strong><br>Sobald ein Zahlungseingang vorliegt, wird die Rechnung automatisch per Kontoabgleich als bezahlt markiert. Bei unklarem Zahlungseingang kann der Abgleich manuell erfolgen.<br><span class=\"docs-path\">Rechnungen › Rechnung öffnen › Als bezahlt markieren</span></li></ol>"
        },
        "onboarding": {
            "title": "Onboarding",
            "note": "Patientendaten und Daten des Rechnungsempfängers werden nur teilweise mit den hochgeladenen Rechnungsdateien übermittelt. Es fehlen die E-Mail-Adresse und Handynummer.",
            "q0": "Woher erhält das System die E-Mail-Adresse und Handynummer des Rechnungsempfängers?",
            "a0": "Die E-Mail-Adresse und Handynummer können manuell vom Praxisteam eingetragen werden. Eleganter ist der Weg über den Patientenfragebogen.",
            "q1": "Kann der Rechnungsempfänger den Fragebogen gleich in der Praxis ausfüllen?",
            "a1": "Den Fragebogen kann man auf 2 Weisen dem Rechnungsempfänger übermitteln:\na) Per E-Mail, nachdem manuell die E-Mail-Adresse in den Stammdaten des Rechnungsempfängers erfasst wurde.\nb) Eleganter: man wählt den Rechnungsempfänger aus, scannt den QR-Code (Handy/Tablet) – der Fragebogen kann vor Ort ausgefüllt werden.",
            "q2": "Können auf den Fragebogen weitere Personen einem Rechnungsempfänger zugeordnet werden, auch wenn diese noch keine Rechnung erhalten haben?",
            "a2": "Ja! Sobald der Rechnungsempfänger den Fragebogen erhält, kann er diesen komplett für sich und die betreuenden Personen einmalig ausfüllen. Hinweis: Funktion für Kinderarztpraxen vor allem, aber auch für Patienten, bei denen ein anderer Rechnungsempfänger erfasst werden muss (Betreuer, Institution ...).",
            "q3": "Was passiert mit dem Fragebogen, nachdem dieser vom Rechnungsempfänger ausgefüllt wurde?",
            "a3": "Der ausgefüllte und unterschriebene Fragebogen landet in der Akte des Patienten und kann im Reiter Fragebogen als PDF geöffnet werden. Gleichzeitig werden die Daten abgeglichen und übernommen. Noch nicht angelegte Patienten werden angelegt und dem Rechnungsempfänger automatisch zugeordnet.",
            "q4": "Muss ich die Einwilligung des Patienten für den digitalen Rechnungsversand einholen?",
            "a4": "Ja. Zum digitalen Rechnungsversand empfiehlt es sich, die Einwilligung des Rechnungsempfängers einzuholen. Dies hat Medinvoice ebenfalls mittels des Fragebogens implementiert.",
            "q5": "Kann ich meine bestehenden Patienten aus der bisherigen Software übernehmen?",
            "a5": "Ja, per CSV-Datei. Exportieren Sie die Patientenliste aus Ihrer bisherigen Software, öffnen Sie die Seite Patienten und wählen Sie oben rechts „…“ → „CSV importieren“. Medinvoice erkennt die Spalten, zeigt alle Patienten zur Prüfung an (einzelne Zeilen lassen sich abwählen) und überspringt Patienten, die schon vorhanden sind. Minderjährige werden einem Rechnungsempfänger zugeordnet. Ohne CSV entstehen Patienten auch automatisch beim Hochladen einer PAD-Datei oder über die Praxissoftware-Synchronisation.<br><span class=\"docs-path\">Patienten › … › CSV importieren</span>"
        },
        "invoices": {
            "title": "Rechnungen",
            "q0": "Kann ich mehrere Rechnungen gleichzeitig hochladen?",
            "a0": "Ja. Ein Batch-Upload mehrerer Rechnungen ist vorgesehen, damit auch größere Rechnungsläufe effizient verarbeitet werden können.",
            "q1": "Welche Versandwege gibt es?",
            "a1": "E-Mail mit persönlichem Rechnungs-Link (Patient öffnet die Rechnung im Browser) oder physischer Briefversand über unsere Schnittstelle. Beide Wege lassen sich gleichzeitig aktivieren.<br><span class=\"docs-path\">Einstellungen › Rechnungen</span>",
            "q2": "Können gleichzeitig mehrere Rechnungen versandt werden?",
            "a2": "Ja, es können sowohl digital als auch per Brief mehrere Rechnungen versandt werden. Dazu wählt man die entsprechenden Rechnungen aus und folgt den angebotenen Versandmöglichkeiten.",
            "q3": "Wie werden Rechnungen digital versendet?",
            "a3": "Die Rechnung kann über einen sicheren Downloadlink oder über das Patientenportal bereitgestellt werden. Patienten erhalten eine Benachrichtigung per E-Mail und können die Rechnung digital abrufen.",
            "q4": "Kann der Zugriff zusätzlich abgesichert werden?",
            "a4": "Ja. Der Zugriff wird über OTP (SMS) oder Portalanmeldung abgesichert. Welche Variante genutzt wird, hängt vom gewünschten Sicherheitsniveau und der Praxisentscheidung ab.",
            "q5": "Gibt es ein Ablaufdatum für Downloadlinks?",
            "a5": "Ja. Downloadlinks können zeitlich begrenzt werden. So bleibt der Zugriff kontrollierbar und nachvollziehbar.",
            "q6": "Was bedeuten die Rechnungsstatus?",
            "a6": "<table class=\"docs-table\"><thead><tr><th>Status</th><th>Bedeutung</th></tr></thead><tbody><tr><td><strong>Hochgeladen – nicht versandt</strong></td><td>Importiert, noch nicht versandt</td></tr><tr><td><strong>Versendet – offen</strong></td><td>Rechnung wurde dem Empfänger zugestellt</td></tr><tr><td><strong>Überfällig</strong></td><td>Mindestens eine Mahnstufe wurde ausgelöst (M1 / M2 / M3)</td></tr><tr><td><strong>Bezahlt</strong></td><td>Zahlung erfasst oder per Bankabgleich zugeordnet</td></tr><tr><td><strong>Abgeschrieben</strong></td><td>Forderung manuell abgeschrieben</td></tr></tbody></table>",
            "q7": "Kann ich Rechnungen nachträglich korrigieren?",
            "a7": "Noch nicht versendete Rechnungen können teilweise bearbeitet werden — Stammdaten und Rechnungsbetrag können vor Versand geändert werden. Bereits versendete Rechnungen können nur storniert und neu erstellt werden.<br><em>Wichtig: Nach dem Versand ist direkte Bearbeitung nicht mehr möglich — stornieren Sie die Rechnung und erstellen Sie eine neue.</em>",
            "q8": "Kann ich Rechnungen einzeln versenden?",
            "a8": "Ja. Sie können jede Rechnung nach erneuter Prüfung per Mausklick versenden. Sie haben auch die Möglichkeit, mehrere Rechnungen auszuwählen und gleichzeitig zu versenden.",
            "q9": "Können Rechnungen automatisch nach dem Hochladen versendet werden?",
            "a9": "1) Digital: Ja, wenn E-Mail-Adresse, Handynummer (für die 2FA per SMS) und Einverständniserklärung vorliegen — sonst nicht.\n2) Per Brief: geht immer.\n3) Beide Varianten müssen zuvor in den Einstellungen definiert werden.<br><span class=\"docs-path\">Einstellungen › Rechnungseinstellungen › Senden bei Upload aktivieren</span>",
            "q10": "Können Rechnungen weiterhin per Brief versandt werden?",
            "a10": "Ja. Es wird Patienten geben, die den klassischen Weg weiterhin wünschen.<br><em>Hinweis: Der Briefversand wird separat abgerechnet und ist nicht im Preis enthalten.</em>",
            "q11": "Kann eine Rechnung erneut versendet werden?",
            "a11": "Ja. Ein erneuter Versand des Links oder eine erneute Benachrichtigung kann erfolgen, wenn der Patient die Rechnung nicht abrufen oder die E-Mail nicht mehr finden kann.<br><span class=\"docs-path\">Rechnungsansicht › Rechnung erneut versenden</span>",
            "q12": "Sieht die Praxis, ob eine Rechnung angekommen ist?",
            "a12": "Die Praxis kann sehen, ob eine Rechnung versandt und abgerufen wurde. Damit wird der Rechnungsstatus transparenter als beim klassischen Briefversand.",
            "q13": "Kann ich sehen, ob Patienten die Rechnung heruntergeladen haben?",
            "a13": "Ja. Der Abruf- bzw. Downloadstatus ist eine zentrale Funktion. Dadurch erkennt die Praxis, ob eine Rechnung bereits eingesehen wurde.",
            "q14": "Gibt es ein Protokoll je Rechnung?",
            "a14": "Ja. Ein Rechnungsprotokoll zeigt, wann eine Rechnung erstellt, versendet, abgerufen, erinnert, gemahnt oder bezahlt wurde.<br><span class=\"docs-path\">Rechnungen › Rechnung wählen › Reiter Protokoll</span>",
            "q15": "Kann ich offene Rechnungen filtern?",
            "a15": "Ja. Filterbar nach: offen, überfällig, abgerufen, nicht abgerufen, bezahlt, abgemahnt."
        },
        "createInvoice": {
            "title": "Rechnungen erstellen",
            "note": "Ohne Praxissoftware – oder für einzelne Rechnungen zwischendurch: Rechnungen direkt in Medinvoice schreiben, Schritt für Schritt, mit GOÄ-Hilfe.",
            "q0": "Wie erstelle ich eine Rechnung ohne Praxissoftware?",
            "a0": "Klicken Sie auf <strong>Rechnung erstellen</strong> – im Dashboard oder auf der Seite Rechnungen. Fünf Schritte auf einer Seite: <strong>Patient</strong> (suchen oder neu anlegen), <strong>Behandlung</strong> (Ärztin/Arzt, Behandlungstage, mindestens eine Diagnose – aus dem ICD-10-GM mit Diagnosesicherheit G/V/A/Z und ggf. Seite R/L/B, oder als freier Text), <strong>Leistungen</strong> (GOÄ-Ziffer suchen – nur Ziffern suchen die Nummer, mit Buchstaben die Bezeichnung; Einfachsatz und Faktorrahmen werden ausgefüllt; Reihenfolge per Ziehen am Griff), <strong>Prüfung</strong> und <strong>Vorschau</strong> mit PDF. Dann <em>Erstellen</em> oder <em>Erstellen &amp; senden</em>. Ein Rechnungsdatum geben Sie nicht ein – wie bei jeder Rechnung gilt der Versandtag.<br><span class=\"docs-path\">Rechnungen › Rechnung erstellen</span>",
            "q1": "Was wird vor dem Erstellen geprüft?",
            "a1": "<strong>Rot – verhindert das Erstellen:</strong> kein Patient oder Rechnungsempfänger, keine Ärztin / kein Arzt, ein Behandlungstag in der Zukunft, keine Diagnose, ein Tag ohne Leistungen, eine Zeile ohne Ziffer, Text oder Einfachsatz, Faktor außerhalb des Rahmens, fehlende Begründung über dem Schwellenwert, weder E-Mail noch Postanschrift.<br><strong>Gelb – nur ein Hinweis:</strong> eine Ziffer außerhalb des GOÄ-Katalogs (z. B. Analogziffern), fehlende Einwilligung, dieselbe Ziffer mehrfach am selben Tag (einmal als <em>Bewusst so abrechnen</em> bestätigen).<br><em>Das PDF lässt sich ansehen, sobald Patient, Behandlung und Leistungen vollständig sind.</em>",
            "q2": "Geht meine Arbeit verloren, wenn ich die Seite schließe?",
            "a2": "Nein. Alles wird automatisch als <strong>Entwurf</strong> gespeichert. Mit <strong>Beenden</strong> verlassen Sie die Seite in jedem Schritt; weiter geht es über den violetten Knopf <strong>Entwürfe</strong> auf der Seite Rechnungen. Entwürfe sind persönlich und zählen nicht als Rechnung.<br><span class=\"docs-path\">Rechnungen › Entwürfe</span>",
            "q3": "Wie nutze ich Rechnungsvorlagen?",
            "a3": "Wiederkehrende Leistungen speichern Sie als <strong>Vorlage</strong> – für sich oder die ganze Praxis. In Schritt 3 hat jeder Behandlungstag <em>Vorlage einfügen</em> und <em>Als Vorlage speichern</em>; Vorlagen über mehrere Tage füllen die folgenden Behandlungstage. Auch jede bestehende Rechnung lässt sich im Reiter Leistungen als Vorlage speichern.<br><span class=\"docs-path\">Einstellungen › Rechnungsvorlagen</span>",
            "q4": "Was bringen GOÄ-Prüfung und Vorschläge?",
            "a4": "<strong>GOÄ-Prüfung (Pro):</strong> Ziffern, die nicht nebeneinander abgerechnet werden dürfen, Höchstzahlen je Sitzung, fehlende Grundleistungen – jeder Hinweis wird korrigiert oder als <em>Bewusst so abrechnen</em> bestätigt.<br><strong>Vorschläge (ab Plus):</strong> Ziffern, die Sie meist zusammen oder bei dieser Diagnose abrechnen, Ihr üblicher Faktor – jeweils mit GOÄ-Bezeichnung und Begründung, nur aus den Rechnungen Ihrer Praxis. Schon in Schritt 2 Diagnosen, die Sie oft zusammen eintragen, in Schritt 3 die Ziffern zu den Diagnosen. Diagnosen mit A oder V lösen keine Vorschläge aus.",
            "q5": "Einwilligung, Versand und danach?",
            "a5": "Fehlt die Einwilligung, holen Sie sie in Schritt 1 – vor Ort per QR-Code oder auf Papier, sonst per Link per E-Mail oder SMS. Erstellen geht auch ohne, nur das Senden wartet. <strong>Erstellen &amp; senden</strong> schickt den Portal-Link sofort per E-Mail. Danach ist es eine normale Rechnung (<em>Manuell erstellt</em>); bis zum Versand lassen sich ihre Leistungen in jedem Tarif korrigieren."
        },
        "dunning": {
            "title": "Mahnwesen",
            "q0": "Wie konfiguriere ich die Mahnstufen?",
            "a0": "Legen Sie die Abstände in Tagen nach Fälligkeit für jede Mahnstufe sowie den Versandweg je Stufe fest. Medinvoice löst Mahnungen automatisch aus. Die Berechnung der Tage erfolgt ab dem Datum des Rechnungsversands.<br><br><table class=\"docs-table\"><thead><tr><th>Stufe</th><th>Bezeichnung</th><th>Versandart</th></tr></thead><tbody><tr><td>Keine Mahnung</td><td>Rechnung offen innerhalb der Zahlungsfrist</td><td>keine</td></tr><tr><td>M1</td><td>Zahlungserinnerung</td><td>E-Mail, Brief oder beides</td></tr><tr><td>M2</td><td>Mahnung</td><td>E-Mail, Brief oder beides</td></tr><tr><td>M3</td><td>Letzte Mahnung</td><td>E-Mail, Brief oder beides</td></tr><tr><td>Inkasso</td><td>Inkassoübergabe möglich</td><td>E-Mail vom System nur an Praxis</td></tr><tr><td>Inkasso übergeben</td><td>Rechnung ans Inkasso abgetreten bzw. an Anwalt weitergeleitet</td><td>E-Mail vom System nur an Praxis</td></tr></tbody></table><br><em>Hinweis: Versandart bei letzter Mahnung ist systemseitig Brief und E-Mail als Standard eingestellt.</em><br><span class=\"docs-path\">Einstellungen › Mahnwesen</span>",
            "q1": "Kann ich Mahngebühren berechnen?",
            "a1": "Ja. Aktivieren Sie Mahngebühren und legen Sie den Betrag je Stufe fest. Die Gebühren werden rechtssicher in der Mahnung ausgewiesen.<br><span class=\"docs-path\">Einstellungen › Mahnwesen</span>",
            "q2": "Kann ich eigene Mahntexte verwenden?",
            "a2": "Ja. Die Praxis kann eigene Textvorlagen hinterlegen bzw. die vorhandenen je nach Mahnstufe anpassen. Dies gilt für E-Mail sowie auch Briefversand der Mahnungen.<br><em>Hinweis: Man kann sehr elegant eine Test-E-Mail an sich schicken, um die Änderungen zu überprüfen.</em>",
            "q3": "Gibt es einen Ampelstatus?",
            "a3": "Ja. Ein Ampelstatus hilft, kritische Rechnungen schnell zu erkennen: zum Beispiel grün für unkritisch, orange für Mahnstufe und rot für letzte Mahnung.",
            "q4": "Was passiert nach der letzten Mahnstufe?",
            "a4": "Es ist Ihnen überlassen, welchen Weg Sie gehen wollen. Sie können die Forderung an ein Inkassounternehmen Ihrer Wahl übergeben oder die implementierte Schnittstelle zu Paywise nutzen und die Rechnung digital direkt aus der Rechnungsansicht abtreten. Dazu müssten Sie einmalig ein Konto bei Paywise eröffnen.<br><em>Hinweis: Die Inkassoübergabe ist ein manueller Schritt — Medinvoice löst ihn nicht automatisch aus. Das System markiert die fällige Rechnung und informiert die Praxis.</em>",
            "q5": "Kann ich Mahnungen auch pausieren?",
            "a5": "Ja. Das geht ganz einfach, indem diese Funktion in der entsprechenden Rechnung aktiviert wird.<br><span class=\"docs-path\">Rechnungen › Rechnung auswählen › Mahnung pausieren</span>"
        },
        "bank": {
            "title": "Zahlungsabgleich und Bankanbindung",
            "q0": "Wie verbinde ich mein Konto?",
            "a0": "Folgen Sie dem geführten Open-Banking-Prozess. Sie werden gebeten, sich wie beim Onlinebanking anzumelden und das Konto für Zahlungseingänge auszuwählen. Es wird kein direkter Zugriff auf Transaktionen erteilt – nur Lesezugriff auf Eingänge. Für den Abgleich benötigen wir keine Zugangsdaten.\n\nEinstellungen › Bank & Zahlungen › Bank verbinden",
            "q1": "Ist der Kontenzugang sicher?",
            "a1": "Ja. Wir verwenden den Zugang von BANKSapi. BANKSapi wird von der BaFin reguliert und darüber erhält Medinvoice Zugang zum Kontoinformationsdienst (KID), der für den Abgleich benötigt wird.",
            "q2": "Kann Medinvoice Zahlungseingänge automatisch erkennen?",
            "a2": "Ja. Über eine Bankanbindung können Zahlungseingänge mit offenen Rechnungen abgeglichen werden.",
            "q3": "Wie funktioniert der Zahlungsabgleich?",
            "a3": "Der Abgleich kann über Rechnungsnummer, Betrag, Name des Rechnungsempfängers und weitere Referenzen erfolgen. Eindeutige Treffer können automatisch zugeordnet werden.",
            "q4": "Was passiert bei unklaren Zahlungen?",
            "a4": "Unklare Zahlungen werden nicht blind verbucht, sondern in eine Liste zur manuellen Prüfung übernommen.",
            "q5": "Wird direkt in der Buchhaltung verbucht?",
            "a5": "Medinvoice kann Zahlungseingänge zuordnen und den Rechnungsstatus setzen. Eine echte Buchung in einer Finanzbuchhaltung existiert aktuell nicht.",
            "q6": "Können Patienten per Karte bezahlen?",
            "a6": "Demnächst, in allen Tarifen über Ihr eigenes SumUp-Konto. Patienten zahlen dann im Patientenportal per Karte, Apple Pay oder Google Pay auf einer sicheren Zahlungsseite von SumUp; das Geld geht direkt an Ihre Praxis, Medinvoice sieht keine Kartendaten. Die Rechnung wird automatisch als bezahlt markiert. Am Empfang zahlen Patienten per QR-Code mit dem eigenen Handy oder – mit einem gekoppelten SumUp Solo – am Kartenterminal, an das Medinvoice den Betrag sendet. Das gilt nur für Zahlungen, die in Medinvoice gestartet werden: Beträge, die Sie selbst am SumUp-Terminal oder in der SumUp-App eingeben, und eigene SumUp-Links erkennt Medinvoice nicht – diese Rechnungen bitte manuell als bezahlt markieren. Wo Kartenzahlung angeboten wird (Portal, QR-Code, Kartenterminal), legt ein Admin auf derselben Einstellungsseite fest. Die Gebühren berechnet SumUp Ihnen pro Zahlung – ein Aufschlag für Patienten ist nicht erlaubt.\n\nEinstellungen › Kartenzahlung (SumUp)"
        },
        "portal": {
            "title": "Patientenportal",
            "q0": "Was bietet das Patientenportal?",
            "a0": "Patienten können Rechnungen einsehen, herunterladen, bezahlen (über den QR-Code), den aktuellen Mahnstatus einsehen und bei Fragen Kontakt mit der Praxis aufnehmen.",
            "q1": "Ist das Patientenportal für Patienten kostenlos?",
            "a1": "Ja. Das Patientenportal ist für Patienten kostenlos.",
            "q2": "Ist das Patientenportal für Patienten verpflichtend?",
            "a2": "Nein! Um eine Rechnung zu erhalten, kann der Rechnungsempfänger auch direkt nach Anforderung eines Codes via SMS (OTP) diese herunterladen.",
            "q3": "Können Patienten mehrere Rechnungen an einem Ort sehen?",
            "a3": "Ja. Das Ziel ist ein zentrales Portal, in dem Patienten ihre Rechnungen teilnehmender Praxen übersichtlich aufgelistet sehen.",
            "q4": "Können Eltern Rechnungen ihrer Kinder sehen?",
            "a4": "Ja. Für Familien ist eine Rechnungsempfängerfunktion sinnvoll, bei der mehrere Patienten einem Rechnungsempfänger zugeordnet werden können.",
            "q5": "Gibt es einen QR-Code für Überweisungen?",
            "a5": "Ja. Ein QR-Zahlungscode für die Überweisung erleichtert den Zahlungsprozess und vermeidet Tippfehler.",
            "q6": "Können Rechnungen an PKV oder Beihilfe weitergeleitet werden?",
            "a6": "Medinvoice kann Patienten dabei unterstützen, Rechnungen für PKV oder Beihilfe vorzubereiten. Eine direkte Übergabe hängt von den Schnittstellen der jeweiligen Versicherung oder App ab.",
            "q7": "Können Patienten Fragen zur Rechnung stellen?",
            "a7": "Ja. Eine Kommunikationsfunktion zur Praxis ist möglich, damit Rückfragen zur jeweiligen Rechnung gestellt werden können. Es können z.B. Nachweise von Sachkosten auf Verlangen übermittelt werden. Diese Funktion kann bei Bedarf von der Praxis deaktiviert werden."
        },
        "team": {
            "title": "Teammitglieder",
            "note": "Je nach Größe der Praxis kann es sinnvoll sein, mehrere Rollen einzustellen.",
            "q0": "Gibt es unterschiedliche Rollen- und Rechtevergaben?",
            "a0": "Ja. Je nach gebuchtem Modell können mehrere Ärzte und Teammitglieder definiert werden.",
            "q1": "Können einzelne Mitglieder unterschiedliche Rechte erhalten?",
            "a1": "Ja, der Administrator richtet die Rollen der Teammitglieder ein (Administrator, Arzt, MFA, Buchhaltung) und kann ihnen individuelle Rechte vergeben.",
            "q2": "Können mehrere Ärzte eingerichtet werden und können sie separat abrechnen?",
            "a2": "Ja. Das ist so für BAG und MVZ gedacht. Die Ärzte haben jeweils ein eigenes Unterkonto, das mit der Praxis/MVZ verknüpft ist. Somit kann auch jede/r Ärztin/Arzt eigene Kontodaten für den Zahlungseingang einstellen und auch ihr Bankkonto verknüpfen."
        },
        "videos": {
            "title": "Anwendervideos",
            "q0": "Gibt es Einführungsvideos zu Medinvoice?",
            "a0": "Wir arbeiten derzeit an einer Videobibliothek mit Schritt-für-Schritt-Anleitungen zu allen wichtigen Funktionen. Die Videos werden in Kürze hier verfügbar sein."
        }
    },
    "bugReport": {
        "title": "Medinvoice",
        "reportBug": "Fehler melden",
        "thankYou": "Vielen Dank! Ihr Bericht wurde gesendet.",
        "close": "schließen",
        "bugArea": "Bereich *",
        "bugAreaPlaceholder": "Bereich auswählen…",
        "areaInvoices": "Rechnungen",
        "areaPatients": "Patienten / Empfänger",
        "areaEmail": "E-Mail / Benachrichtigungen",
        "areaPortal": "Patientenportal",
        "areaSettings": "Einstellungen",
        "areaBilling": "Abrechnung / Abonnement",
        "areaOther": "Sonstiges",
        "bugTitle": "Titel *",
        "bugTitlePlaceholder": "kurze Zusammenfassung des Problems",
        "bugDescription": "Beschreibung *",
        "bugDescriptionPlaceholder": "Schritte zur Reproduktion, was Sie erwartet haben, was passiert ist...",
        "cancel": "abbrechen",
        "sending": "senden…",
        "sendReport": "Bericht senden"
    },
    "suggestion": {
        "helpUsImprove": "Helfen Sie uns, uns zu verbessern",
        "modalTitle": "Vorschlag einreichen",
        "modalLead": "Haben Sie eine Idee für eine neue Funktion oder eine Verbesserung? Schreiben Sie uns – wir lesen alles.",
        "titleLabel": "Was würden Sie gerne sehen? *",
        "titlePlaceholder": "Kurze Zusammenfassung Ihrer Idee",
        "descLabel": "Mehr Details",
        "descPlaceholder": "Details, Kontext oder Beispiele, die uns helfen, Ihre Idee besser zu verstehen…",
        "send": "Senden",
        "sending": "Senden…",
        "thankYou": "Vielen Dank! Wir schätzen Ihr Feedback.",
        "cancel": "Abbrechen"
    },
    "referral": {
        "button": "Kollegen empfehlen",
        "modalTitle": "Medinvoice empfehlen",
        "modalLead": "Öffnen Sie Ihren E-Mail-Client mit einer vorgefertigten Nachricht – oder kopieren Sie den Text und teilen Sie ihn nach Belieben.",
        "messageLabel": "Nachricht (bearbeitbar)",
        "copy": "Text kopieren",
        "copied": "Kopiert ✓",
        "openEmail": "In E-Mail-Client öffnen",
        "subject": "Empfehlung: Medinvoice – digitale GOÄ-Privatabrechnung",
        "close": "Schließen"
    },
    "form": {
        "salutation": "Anrede",
        "salutationRequired": "Anrede *",
        "title": "Titel",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "gender": "Geschlecht",
        "birthDate": "Geburtsdatum",
        "email": "E-Mail",
        "phone": "Telefon",
        "phonePlaceholder": "+491511234567",
        "street": "Straße",
        "streetAndNumber": "Straße & Nr.",
        "streetError": "muss eine Hausnummer enthalten (z.B. Hauptstraße 22a)",
        "houseNumber": "Nr.",
        "plz": "PLZ",
        "city": "Stadt",
        "address": "Adresse",
        "photo": "Foto",
        "logo": "Logo",
        "change": "ändern",
        "remove": "entfernen",
        "addPhone": "Telefonnummer hinzufügen",
        "personal": "Persönlich",
        "contactAddress": "Kontakt & Adresse",
        "contact": "Kontakt",
        "personalContact": "Persönlich – Kontakt",
        "externalId": "ID",
        "externalIdHint": "Die Patientennummer aus Ihrer Praxissoftware. Sie wird bei der Praxissoftware-Synchronisation automatisch übernommen und dient dazu, diesen Patienten bei späteren Importen wiederzuerkennen. Sie kann hier nicht bearbeitet werden.",
        "externalIdHintManual": "Die Patientennummer aus Ihrer Praxissoftware. Tragen Sie sie ein, damit spätere Importe diesen Patienten wiedererkennen und Dokumente in die Praxissoftware zurückgeschrieben werden können.",
        "externalIdTaken": "Diese Patientennummer ist bereits einem anderen Patienten zugeordnet.",
        "herr": "Herr",
        "frau": "Frau",
        "male": "Männlich",
        "female": "Weiblich",
        "diverse": "Divers / keine Angabe",
        "selectGender": "— auswählen —",
        "drPlaceholder": "Dr.",
        "cancel": "abbrechen",
        "save": "speichern",
        "ok": "OK",
        "delete": "löschen",
        "clear": "leeren",
        "name": "Name",
        "tel": "Tel",
        "patient": "Patient",
        "insuranceProvider": "Krankenversicherung",
        "insuranceNumber": "Versicherungsnummer",
        "postOnly": "Nur Brief",
        "postOnlyHint": "Rechnungen dieses Patienten werden ausschließlich per Post versendet — E-Mail/Portallink-Versand ist deaktiviert",
        "postOnlyConfirm": "Wenn Sie dies aktivieren, werden Rechnungen dieses Patienten nur noch per Post versendet. Der automatische E-Mail-Versand (bei Upload, bei Fragebogen-Abschluss) wird übersprungen, und der manuelle E-Mail-/Portallink-Button wird deaktiviert — Post bleibt der einzige Versandweg für diesen Patienten. Auch Mahnungen gehen nicht per E-Mail raus. Sind alle Patienten des Empfängers „Nur Brief“, wird die Einwilligung nicht mehr per E-Mail, SMS oder QR-Code angefragt — nur noch auf Papier.",
        "bankAccountName": "Rechnungsempfänger",
        "bankAccountNamePlaceholder": "leer lassen, wenn identisch mit Empfängername",
        "imageTooLarge": "das Bild darf nicht größer als 5 MB sein",
        "emailInvalid": "Ungültige E-Mail-Adresse."
    },
    "createPatient": {
        "title": "Neuer Patient",
        "editTitle": "Patient bearbeiten",
        "lastNameRequired": "Bitte geben Sie den Nachnamen ein.",
        "birthDateRequired": "Bitte geben Sie das Geburtsdatum ein.",
        "createError": "Patient konnte nicht erstellt werden.",
        "linkSelfError": "Patient wurde angelegt, konnte aber nicht als Empfänger selbst verknüpft werden. Bitte erneut versuchen.",
        "dupIntro": "{{name}}, geb. {{birthDate}}, gibt es in Ihrer Praxis schon. Nutzen Sie den vorhandenen Eintrag, statt die Person doppelt anzulegen.",
        "dupPatient": "Patient: {{name}}",
        "dupRecipient": "Rechnungsempfänger: {{name}}",
        "dupRecipientHint": "Zahlt bereits Rechnungen in Ihrer Praxis, ist aber noch nicht selbst Patient.",
        "dupNoRecipient": "Ohne Rechnungsempfänger",
        "dupAlreadyHere": "Schon Patient bei diesem Rechnungsempfänger",
        "dupPaysSelf": "Zahlt selbst ({{name}})",
        "dupPaidBy": "Rechnungsempfänger: {{name}}",
        "dupUse": "Diesen verwenden",
        "dupMoveHere": "Hierher übernehmen",
        "dupLinkSelf": "Als Empfänger selbst markieren",
        "dupCreateAsSelf": "Als Empfänger selbst anlegen",
        "dupAddToRecipient": "Bei diesem Empfänger anlegen",
        "dupMoveHint": "Beim Übernehmen ziehen die Rechnungen des Patienten mit um. Ein Rechnungsempfänger, der danach keine Patienten mehr hat, wird entfernt.",
        "dupCreateAnyway": "Trotzdem neu anlegen",
        "dupUseError": "Der vorhandene Patient konnte nicht übernommen werden. Bitte erneut versuchen.",
        "updateError": "Patient konnte nicht gespeichert werden.",
        "deleteError": "Patient konnte nicht gelöscht werden.",
        "deleteConfirm": "Diesen Patienten wirklich löschen?",
        "creating": "wird erstellt…",
        "create": "Patient erstellen",
        "recipientSection": "Rechnungsempfänger",
        "recipientNone": "Keiner",
        "recipientLinkExisting": "Bestehenden verknüpfen",
        "recipientCreateNew": "Neuen erstellen",
        "recipientSearch": "Name suchen…",
        "recipientNoResults": "Keine Treffer",
        "recipientNewValidation": "Nachname für den Rechnungsempfänger ist erforderlich.",
        "recipientCreateFailed": "Rechnungsempfänger konnte nicht erstellt werden.",
        "recipientSelf": "Selbstzahler",
        "recipientSelfHint": "Ein Rechnungsempfänger wird mit denselben Daten des Patienten angelegt und automatisch verknüpft.",
        "recipientHasRecipient": "Hat Rechnungsempfänger",
        "billingQuestion": "Wer soll Rechnungen erhalten?",
        "recipientOptionSelf": "Der Patient selbst",
        "recipientOptionSelfDesc": "Rechnung an eigene Kontaktdaten",
        "recipientOptionOther": "Eine andere Person",
        "recipientOptionOtherDesc": "Elternteil, Versicherung, Betreuer…",
        "stepPatient": "Patient",
        "stepBilling": "Rechnungsempfänger",
        "billingContactTitle": "Rechnungsempfänger",
        "next": "Weiter",
        "back": "Zurück",
        "patientContext": "Patient: {{name}}"
    },
    "createRecipient": {
        "title": "Neuer Patient",
        "birthDateOptional": "Geburtsdatum (optional)",
        "validationError": "Nachname ist erforderlich.",
        "createError": "Patient konnte nicht erstellt werden.",
        "creating": "wird erstellt…",
        "create": "Patient erstellen",
        "patientSection": "Patient",
        "patientNone": "Keinen Patient",
        "patientSelf": "Selbstzahler",
        "patientSelfHint": "Ein Patient wird mit denselben Daten angelegt und diesem Empfänger zugeordnet.",
        "patientLinkExisting": "Bestehenden verknüpfen",
        "patientSearch": "Patient suchen…",
        "patientNew": "Zahlt für anderen Patienten",
        "patientNewValidation": "Nachname des Patienten ist erforderlich.",
        "tabRecipient": "Rechnungsempfänger",
        "tabPatient": "Patient",
        "patientQuestion": "Ist der Patient dieselbe Person?",
        "patientOptionSelf": "Dieselbe Person",
        "patientOptionSelfDesc": "Rechnungsempfänger und Patient sind identisch",
        "patientOptionOther": "Anderer Patient",
        "patientOptionOtherDesc": "Kind, Familienmitglied usw.",
        "stepRecipient": "Rechnungsempfänger",
        "stepPatient": "Patient",
        "patientTitle": "Patientendaten",
        "recipientContext": "Rechnungsempfänger: {{name}}",
        "next": "Weiter",
        "back": "Zurück",
        "modeQr": "QR-Code scannen",
        "modeQrDesc": "Patient füllt den Fragebogen selbst auf seinem Smartphone aus – keine E-Mail-Adresse nötig.",
        "modeManual": "Manuell eingeben",
        "modeManualDesc": "Daten des Patienten direkt in die Maske eingeben.",
        "qrTitle": "Patient per QR-Code aufnehmen",
        "qrHint": "Zeigen Sie dem Patienten diesen QR-Code. Er kann den Fragebogen direkt auf seinem Smartphone ausfüllen.",
        "qrError": "QR-Code konnte nicht generiert werden. Bitte erneut versuchen.",
        "qrPrint": "Drucken"
    },
    "table": {
        "id": "ID",
        "status": "Status",
        "recipient": "Empfänger",
        "patient": "Patient",
        "amount": "Betrag",
        "paid": "bezahlt",
        "remaining": "Restbetrag",
        "dunning": "Mahnung",
        "dates": "Daten",
        "created": "erstellt",
        "sent": "gesendet",
        "due": "fällig",
        "gender": "Geschlecht",
        "birthDate": "Geburtsdatum",
        "birthDateInvalid": "Das Geburtsdatum muss in der Vergangenheit liegen und darf nicht mehr als 100 Jahre zurückliegen.",
        "invDone": "bezahlt",
        "invOpen": "offen",
        "invNotSent": "nicht versendet",
        "name": "Name",
        "billingRecipient": "Rechnungsempfänger",
        "email": "E-Mail",
        "info": "Info"
    },
    "filters": {
        "filters": "Filter",
        "clearAll": "alle löschen",
        "createdFrom": "Erstellt von",
        "createdTo": "bis",
        "overdue": "überfällig",
        "dunningGte3": "Mahnung ≥ 3",
        "sent": "gesendet",
        "notSent": "nicht gesendet",
        "all": "alle",
        "amountGte": "Betrag ≥",
        "amountPlaceholder": "z.B. 100",
        "hasOpen": "hat offene",
        "hasPaid": "hat bezahlte",
        "invoices": "Rechnungen",
        "portal": "Portal",
        "questionnaire": "Einwilligung",
        "hasReceivedLink": "Link erhalten",
        "questionnaireSubmitted": "Einwilligung unterschrieben",
        "questionnaireNotSubmitted": "Gesendet, nicht unterschrieben",
        "questionnaireNotSent": "Einwilligung nicht gesendet",
        "vat": "MwSt.",
        "vatIncluded": "MwSt. enthalten",
        "reviewFlags": "Prüfhinweise",
        "origin": "Herkunft",
        "originUpload": "Hochgeladen",
        "originManual": "Manuell erstellt",
        "goaConflict": "GOÄ-Konflikte",
        "amountMismatch": "Betragsabweichung",
        "sendingStatus": "Sendungsstatus",
        "readyForPost": "Bereit für Postversand",
        "readyForPostHint": "Noch nicht versendete offene Rechnungen, die nur per Post rausgehen können (Nur Brief, keine E-Mail oder nur postalische Einwilligung) und bereit dafür sind: vollständige Adresse und Einwilligung vorhanden.",
        "doctor": "Arzt",
        "noQuestionnaireSent": "keine Einwilligung versendet",
        "addressPlaceholder": "Straße, Stadt oder PLZ…",
        "search": "suchen…",
        "status": {
            "open": "offen",
            "unsent": "nicht versandt",
            "sendFailed": "Versand fehlgeschlagen",
            "paid": "bezahlt",
            "overdue": "überfällig",
            "writtenOff": "abgeschrieben",
            "deleted": "gelöscht",
            "unknown": "unbekannt"
        },
        "dunningLevels": {
            "paused": "pausiert",
            "none": "keine Mahnung",
            "friendly": "freundlich",
            "demanding": "fordernd",
            "final": "Letzte",
            "legal": "Inkasso"
        },
        "missingInfo": "fehlende Angaben",
        "noEmail": "keine E-Mail",
        "noTel": "kein Telefon",
        "noAddress": "keine Adresse"
    },
    "a11y": {
        "skipToContent": "Zum Hauptinhalt springen"
    },
    "planDetails": {
        "1": {
            "line1": "1 Arzt inklusive",
            "line2": "100 Rechnungen pro Arzt"
        },
        "2": {
            "line1": "1 Arzt + 1 Mitarbeitende/r",
            "line2": "200 Rechnungen pro Arzt"
        },
        "3": {
            "line1": "2 Ärzt/innen + 2 Mitarbeitende",
            "line2": "Unbegrenzte Rechnungen"
        },
        "4": {
            "line1": "Individueller Plan",
            "line2": "Vertrieb kontaktieren"
        }
    },
    "quickTips": {
        "title": "Schnelltipps",
        "bank": {
            "title": "Bank verbinden",
            "steps": [
                "Gehe zu Einstellungen → Bankverbindung",
                "Klicke auf 'Bank verbinden'",
                "Schließe den OAuth-Flow in deiner Bank ab",
                "Die meisten Transaktionen werden automatisch abgeglichen",
                "Verbleibende Transaktionen auf der Bank-Seite manuell zuordnen"
            ],
            "action": "Zu den Einstellungen"
        },
        "cardPayment": {
            "title": "Kartenzahlung für Patienten (SumUp)",
            "steps": [
                "Ein SumUp-Geschäftskonto eröffnen (sumup.de) – falls Sie schon ein SumUp-Kartenterminal nutzen, haben Sie eines",
                "Einstellungen → Kartenzahlung (SumUp) → „Mit SumUp verbinden“",
                "Bei SumUp anmelden und den Zugriff erlauben",
                "Unter „Wo Kartenzahlung angeboten wird“ wählen: im Patientenportal, per QR-Code am Empfang, am Kartenterminal (Admin) – dann „Änderungen speichern“",
                "Optional: ein SumUp Solo unter „Kartenterminals“ koppeln – „An Kartenterminal senden“ bei einer Rechnung schickt den Betrag dann direkt ans Gerät",
                "Patienten zahlen per Karte, Apple Pay oder Google Pay – im Portal, per QR-Code mit dem eigenen Handy oder am Terminal",
                "Bezahlte Rechnungen werden automatisch als bezahlt markiert – Übersicht unter Bank → Kartenzahlungen",
                "Automatisch verbucht wird nur, was in Medinvoice gestartet wird (Portal, QR-Code, An Kartenterminal senden) – selbst am Terminal oder in der SumUp-App eingegebene Beträge bitte manuell als bezahlt markieren",
                "SumUp zahlt gesammelt auf Ihr Bankkonto aus; diese Auszahlungen im Bankabgleich nur als geprüft markieren"
            ],
            "action": "Kartenzahlung einrichten"
        },
        "pad": {
            "title": "PAD-/PADnext-Datei hochladen",
            "steps": [
                "Klicke in der Navigation auf 'Datei hochladen'",
                "Wähle deine PAD- oder PADnext-Datei aus (.pad, .dat oder .xml)",
                "Prüfe die importierten Rechnungen",
                "Sende sie direkt an die Rechnungsempfänger"
            ]
        },
        "createInvoice": {
            "title": "Rechnung ohne Praxissoftware erstellen",
            "steps": [
                "Klicke auf 'Rechnung erstellen' (Dashboard oder Rechnungen)",
                "Patient wählen oder neu anlegen – Einwilligung direkt per QR-Code, Papier, E-Mail oder SMS einholen",
                "Behandlungstage und mindestens eine Diagnose eintragen – ICD-10-GM nach Code oder Begriff suchen, dann G/V/A/Z und ggf. Seite R/L/B setzen",
                "GOÄ-Ziffern suchen (Zahl = Ziffer, mit Buchstaben = Bezeichnung) – Einfachsatz und Faktorrahmen kommen automatisch, Vorlagen sparen Zeit, Zeilen am Griff in die richtige Reihenfolge ziehen",
                "In der Prüfung Hinweise und Vorschläge ansehen (GOÄ-Prüfung ab Pro, Vorschläge ab Plus)",
                "PDF ansehen, dann 'Erstellen' oder 'Erstellen & senden'",
                "Alles wird automatisch als Entwurf gespeichert – weitermachen unter Rechnungen → Entwürfe"
            ],
            "action": "Rechnung erstellen"
        },
        "csvImport": {
            "title": "Patienten per CSV importieren",
            "steps": [
                "Patientenliste aus der bisherigen Software als CSV exportieren",
                "Auf der Seite Patienten oben rechts auf „…“ → „CSV importieren“ klicken",
                "Datei ablegen, erkannte Patienten prüfen, einzelne Zeilen abwählen",
                "Importieren — bereits vorhandene Patienten werden übersprungen"
            ],
            "action": "CSV-Import öffnen"
        },
        "praxisSoftwareSync": {
            "title": "Praxissoftware automatisch synchronisieren",
            "steps": [
                "Getestet mit MEDICAL OFFICE — T2med, tomedo und medatixx folgen in Kürze",
                "Die GDT-Schnittstelle richtet dein Praxissoftware-Betreuer ein",
                "Dann auf der Synchronisationsseite den Ordner verbinden (Chrome/Edge) oder die Windows-Desktop-App installieren",
                "Neue Dateien werden automatisch erkannt — kein manueller Upload"
            ],
            "action": "Zu den Einstellungen"
        },
        "send": {
            "title": "Rechnung senden",
            "sections": [
                {
                    "heading": "Digital versenden",
                    "steps": [
                        "E-Mail-Adresse des Empfängers hinterlegen",
                        "Einwilligung senden und vom Empfänger unterschreiben lassen",
                        "Einwilligung muss unterzeichnet sein",
                        "Rechnung öffnen und 'Senden' → E-Mail klicken"
                    ]
                },
                {
                    "heading": "Per Post versenden",
                    "steps": [
                        "Postadresse des Empfängers hinterlegen",
                        "Einwilligung muss unterzeichnet sein",
                        "Rechnung öffnen und 'Senden' → Post klicken"
                    ]
                }
            ],
            "action": "Zur Rechnungsübersicht"
        },
        "personalize": {
            "title": "Rechnung personalisieren",
            "steps": [
                "Gehe zu Einstellungen → PDF-Vorlage",
                "Logo, Farbe und Schriftart anpassen",
                "Kopf- und Fußzeile mit eigenen Texten versehen",
                "Vorschau direkt im Browser prüfen"
            ],
            "action": "Zu den Einstellungen"
        },
        "dunning": {
            "title": "Mahnwesen",
            "steps": [
                "M1 – Zahlungserinnerung (nach Fälligkeit)",
                "M2 – Mahnung mit Mahngebühr",
                "M3 – Letzte Mahnung vor Inkasso",
                "Inkasso – automatische Weiterleitung, ab Plus-Tarif",
                "Jeden Morgen um 04:15 Uhr automatisch geprüft",
                "Manuell pausierbar pro Rechnung"
            ]
        },
        "charges": {
            "title": "Gebühren & Umsatz",
            "steps": [
                "Übersicht aller offenen und bezahlten Beträge",
                "Filterbar nach Zeitraum und Status",
                "Umsatzdiagramme im Dashboard",
                "CSV-Export verfügbar"
            ],
            "action": "Zu den Gebühren"
        },
        "tags": {
            "title": "Rechnungen taggen",
            "steps": [
                "Rechnung öffnen und auf 'Tags' klicken",
                "Ein oder mehrere Tags anlegen oder zuweisen",
                "Rechnungen nach Tag filtern und in Gruppen bearbeiten"
            ],
            "action": "Zur Rechnungsübersicht"
        },
        "groups": {
            "title": "Patientengruppen",
            "steps": [
                "Mehrere Zeilen auf der Patienten-Seite auswählen",
                "Auf 'Zu Gruppe hinzufügen' klicken",
                "Neue Gruppe anlegen oder bestehende auswählen",
                "Patientenliste nach Gruppe filtern"
            ],
            "action": "Zu den Patienten"
        },
        "statistics": {
            "title": "Dashboard-Statistiken",
            "steps": [
                "Auf 'Statistiken' im Dashboard klicken",
                "Umsatz-, Rechnungs- und Mahnverlauf einsehen",
                "Zwischen Tabs für verschiedene Auswertungen wechseln",
                "Aktualisiert sich mit jeder Rechnungsänderung"
            ],
            "action": "Zum Dashboard"
        },
        "goaChecker": {
            "title": "GOÄ-Konfliktprüfung",
            "steps": [
                "Reiter 'Leistungen' einer Rechnung öffnen",
                "Widersprüchliche oder ausgeschlossene GOÄ-Ziffern werden automatisch markiert",
                "Warnung anklicken, um die zutreffende Regel zu sehen"
            ],
            "action": "Zur Rechnungsübersicht"
        },
        "reports": {
            "title": "Automatische Berichte",
            "steps": [
                "Gehe zu Einstellungen → Allgemein",
                "Berichtsintervall festlegen (täglich, wöchentlich, monatlich, ...)",
                "PDF-Bericht auf Wunsch oder automatisch erstellen lassen"
            ],
            "action": "Zu den Einstellungen"
        },
        "planBadge": {
            "2": "Plus",
            "3": "Pro"
        },
        "docs": {
            "title": "Dokumentation",
            "steps": [
                "Vollständige Anleitung zu allen Funktionen",
                "GOÄ-Regeln und Abrechnungshinweise",
                "Prozesse, FAQ und Musterbriefe",
                "Immer aktuell im App-Bereich 'Docs'"
            ],
            "action": "Zur Dokumentation"
        }
    },
    "common": {
        "refresh": "aktualisieren",
        "back": "zurück",
        "notFound": "nicht gefunden",
        "pageNotFound": "Seite nicht gefunden",
        "loading": "laden…",
        "fetching": "laden...",
        "search": "suchen",
        "footer": "medinvoice® – powered by exipnon GmbH",
        "at": "an",
        "notSent": "nicht gesendet",
        "allSent": "Alle gesendet",
        "nothingToSend": "Nichts zu senden",
        "paid": "bezahlt",
        "open": "offen",
        "willAlsoDelete": "Folgendes wird ebenfalls gelöscht:",
        "invoicesWillAlsoBeDeleted": "Folgende Rechnungen werden ebenfalls gelöscht:",
        "deleteAlsoOtherDoctorsInvoices": "Dieser Patient ist praxisweit sichtbar. Beim Löschen werden auch die Rechnungen von {{doctors}} entfernt.",
        "doctorInvoiceCount_one": "{{name}} ({{count}} Rechnung)",
        "doctorInvoiceCount_other": "{{name}} ({{count}} Rechnungen)",
        "deletingData": "{{count}} Einträge werden gelöscht…",
        "cleaningUp": "Aufräumen…",
        "sendingProgress": "Wird gesendet ({{done}}/{{total}})…",
        "cancel": "Abbrechen",
        "cancelling": "Wird abgebrochen…",
        "cancelledProgress": "Abgebrochen nach {{done}} von {{total}}.",
        "bulkSendingProgress": "{{subject}} werden gesendet — {{done}} von {{total}}",
        "bulkSendMoreQueued_one": "+{{count}} weitere in Warteschlange",
        "bulkSendMoreQueued_other": "+{{count}} weitere in Warteschlange",
        "bulkSendSubjectQuestionnaires": "Fragebögen",
        "bulkSendSubjectPortalLinks": "Portal-Links",
        "bulkSendSubjectLetters": "Briefe",
        "demoSimulated": "Im Demo-Modus simuliert — es wurde keine echte Aktion ausgeführt.",
        "changesSaved": "Änderungen gespeichert.",
        "saving": "Speichern…",
        "saved": "Gespeichert",
        "saveFailed": "Änderungen konnten nicht gespeichert werden.",
        "unknownError": "Unbekannter Fehler",
        "updatedAt": "Aktualisiert {{time}}",
        "recency": {
            "today": "Heute",
            "yesterday": "Gestern",
            "daysAgo_one": "vor {{count}} Tag",
            "daysAgo_other": "vor {{count}} Tagen",
            "weeksAgo_one": "vor {{count}} Woche",
            "weeksAgo_other": "vor {{count}} Wochen",
            "monthsAgo_one": "vor {{count}} Monat",
            "monthsAgo_other": "vor {{count}} Monaten",
            "yearsAgo_one": "vor {{count}} Jahr",
            "yearsAgo_other": "vor {{count}} Jahren"
        }
    },
    "invoiceRow": {
        "openInvoice": "Rechnung öffnen",
        "paidByCard": "Per Karte bezahlt (SumUp): € {{amount}}",
        "sendPortalLink": "Rechnungs-Link senden",
        "resendPortalLink": "Rechnungs-Link erneut senden",
        "sendViaPost": "per Post senden",
        "sendViaPostMsg": "Rechnung {{id}} als per Post versendet markieren?",
        "noAddress": "Empfänger hat keine Adresse",
        "postConsentRequired": "Einwilligung fehlt — Postversand erst nach Unterzeichnung möglich",
        "consentNeededHint": "Einwilligung noch nicht unterzeichnet – erforderlich für den digitalen Versand",
        "cannotSendYet": "Kann noch nicht gesendet werden",
        "goToRecipient": "Zum Empfänger",
        "noEmail": "Empfänger hat keine E-Mail-Adresse",
        "noEmailOrTel": "Empfänger hat keine E-Mail-Adresse",
        "sendLinkMsg": "Rechnungs-Link {{id}} an die E-Mail des Empfängers senden?",
        "resendLinkMsg": "Rechnungs-Link {{id}} erneut an die E-Mail des Empfängers senden?",
        "deleteInvoice": "Rechnung löschen",
        "deleteInvoiceBtn": "löschen",
        "deleteMsg": "Möchten Sie Rechnung {{id}} wirklich löschen?",
        "cannotDeleteSent": "Löschen nicht möglich — Rechnung wurde bereits versendet",
        "cannotDeletePaid": "Löschen nicht möglich — Rechnung wurde bereits bezahlt",
        "cannotDeleteOverdue": "Löschen nicht möglich — Rechnung ist überfällig"
    },
    "tags": {
        "tag": "Tag",
        "manageTags": "Tags verwalten",
        "newTagPlaceholder": "Neuer Tag…",
        "addTag": "Hinzufügen",
        "noTags": "Noch keine Tags angelegt.",
        "noTag": "— kein Tag —",
        "rename": "umbenennen",
        "delete": "löschen",
        "deleteConfirm": "Tag \"{{name}}\" wirklich löschen? Er wird von allen zugewiesenen Rechnungen entfernt.",
        "createFailed": "Tag konnte nicht erstellt werden.",
        "renameFailed": "Tag konnte nicht umbenannt werden.",
        "deleteFailed": "Tag konnte nicht gelöscht werden.",
        "assignFailed": "Tag konnte der Rechnung nicht zugewiesen werden.",
        "tagThisBatch": "Diesen Upload taggen"
    },
    "groups": {
        "group": "Gruppe",
        "manageGroups": "Gruppen verwalten",
        "addToGroup": "Zu Gruppe hinzufügen",
        "newGroupPlaceholder": "Neue Gruppe…",
        "addGroup": "Hinzufügen",
        "noGroups": "Noch keine Gruppen angelegt.",
        "noGroup": "— keine Gruppe —",
        "rename": "umbenennen",
        "delete": "löschen",
        "deleteConfirm": "Gruppe \"{{name}}\" wirklich löschen? Sie wird von allen zugewiesenen Patienten entfernt.",
        "createFailed": "Gruppe konnte nicht erstellt werden.",
        "renameFailed": "Gruppe konnte nicht umbenannt werden.",
        "deleteFailed": "Gruppe konnte nicht gelöscht werden.",
        "assignFailed": "Gruppe konnte dem Patienten nicht zugewiesen werden.",
        "bulkGroupsApplied_one": "{{count}} Patient zu Gruppe(n) hinzugefügt",
        "bulkGroupsApplied_other": "{{count}} Patienten zu Gruppe(n) hinzugefügt"
    },
    "popup": {
        "confirm": "bestätigen",
        "cancel": "abbrechen",
        "ok": "OK",
        "done": "fertig",
        "close": "Schließen"
    },
    "pdfSettings": {
        "praxisDefaultNotice": "Sie haben noch kein eigenes PDF-Layout gespeichert — es wird aktuell die Vorgabe der Praxis verwendet. Sobald Sie hier speichern, gilt dieses Layout nur noch für Ihre eigenen Rechnungen.",
        "content": "Inhalt",
        "clearAll": "Alles löschen",
        "previewPdf": "PDF-Vorschau",
        "generating": "Wird generiert…",
        "recreating": "PDF wird erstellt…",
        "clearTitle": "PDF-Einstellungen zurücksetzen",
        "clearMessage": "Alle PDF-Einstellungen auf Standardwerte zurücksetzen? Dies kann nicht rückgängig gemacht werden.",
        "previewTitle": "PDF-Vorschau (Beispieldaten)",
        "tabGeneric": "Allgemein",
        "tabHeader": "Seitenkopf",
        "tabFooter": "Seitenfußzeile",
        "tabBody": "Rechnungstext",
        "showQrCode": "Scan & Pay QR-Code anzeigen",
        "showQrCodeDesc": "QR-Code für Banküberweisung auf der Rechnung",
        "showRecipientEmail": "E-Mail des Empfängers anzeigen",
        "showRecipientEmailDesc": "E-Mail-Adresszeile im Patienteninformationsblock",
        "showExams": "Leistungstabelle anzeigen",
        "showExamsDesc": "wenn deaktiviert, wird nur die Gesamtbetragszeile angezeigt",
        "showUstgNote": "Umsatzsteuerbefreiungshinweis",
        "showUstgNoteDesc": "\"umsatzsteuerbefreit nach § 4 Nr. 14 UStG\" unter dem Gesamtbetrag anzeigen",
        "infoLine": "Praxis-Infozeile",
        "infoLineDesc": "Felder in der kleinen Infozeile oben auf der Rechnung",
        "infoShowPraxisName": "Praxisname",
        "infoShowDoctor": "Arztname",
        "infoShowSpecialization": "Fachrichtung",
        "infoShowAddress": "Adresse",
        "headerHint": "Wenn nichts gesetzt ist, wird die Standard-Praxis-Infozeile verwendet.",
        "footerHint": "Wenn nichts gesetzt ist, werden Bankdaten im Rechnungsbereich angezeigt.",
        "bodyHint": "Passen Sie den festen Rechnungstext an. Leer lassen für den Standardtext.",
        "bodyHeading": "Rechnungsüberschrift",
        "bodyHeadingDesc": "Große Überschrift über dem Patientenbereich",
        "bodyHeadingPlaceholder": "Liquidation für ambulante ärztliche Behandlung nach GOÄ",
        "bodyChargeLine": "Berechnungszeile",
        "bodyChargeLineDesc": "Zeile unterhalb der Patientendaten, vor der Leistungstabelle",
        "bodyChargeLinePlaceholder": "für unsere ärztlichen Bemühungen erlaube ich mir zu berechnen:",
        "bodyPaymentTerms": "Zahlungsbedingungen",
        "bodyPaymentTermsDesc": "Text unterhalb des Gesamtbetrags — {invoice.id} und {invoice.dueDate} als Platzhalter",
        "bodyPaymentTermsPlaceholder": "Zahlungsbedingungen: Zahlbar unter Angabe der Rechnungsnummer {invoice.id} ohne Abzug bis zum {invoice.dueDate}.",
        "boxStyle": "Rahmen-Stil",
        "border": "Trennlinie",
        "borderWidth": "Breite",
        "insetH": "Innenabstand H",
        "insetV": "Innenabstand V",
        "marginBottom": "Abstand unten",
        "marginTop": "Abstand oben",
        "logo": "Logo",
        "logoDesc": "Bild in der unten gewählten Spalte",
        "logoSize": "Größe (Höhe)",
        "logoOffset": "Feinposition",
        "logoOffsetDesc": "Verschiebt das Logo pixelgenau von seiner Spaltenposition aus — negative Werte nach oben/links.",
        "logoOffsetX": "Horizontal",
        "logoOffsetY": "Vertikal",
        "logoPosition": "Logo-Position",
        "logoPositionDesc": "In welcher Spalte des Kopfbereichs das Logo erscheint",
        "logoSlotNone": "Keines",
        "logoSlotLeft": "linke Spalte",
        "logoSlotCenter": "mittlere Spalte",
        "logoSlotRight": "rechte Spalte",
        "colLeft": "linke Spalte",
        "colCenter": "mittlere Spalte",
        "colRight": "rechte Spalte",
        "colLeftDesc": "Wenn alle drei Spalten leer sind, wird der benutzerdefinierte Kopfbereich nicht angezeigt.",
        "logoColNotice": "Logo wird in dieser Spalte angezeigt",
        "colPlaceholder": "z.B. {praxis.name}",
        "bold": "fett",
        "italic": "kursiv",
        "underline": "unterstrichen",
        "fontSize": "Größe",
        "alignHorizontal": "Horizontale Ausrichtung",
        "alignVertical": "Vertikale Ausrichtung",
        "alignLeft": "Links",
        "alignCenter": "Mitte",
        "alignRight": "Rechts",
        "alignTop": "Oben",
        "alignMiddle": "Mitte",
        "alignBottom": "Unten",
        "showBankDetails": "Bankdaten anzeigen",
        "showBankDetailsDesc": "IBAN, BIC und Verwendungszweck in der Fußzeile",
        "showAddress": "Praxisadresse anzeigen",
        "showAddressDesc": "Praxisname und -adresse in der Fußzeile",
        "headerRepeatOnEveryPage": "Kopfzeile auf jeder Seite",
        "headerRepeatOnEveryPageDesc": "Kopfzeile auf allen Seiten der Rechnung wiederholen"
    },
    "charges": {
        "title": "monatliche Kosten",
        "subtitle": "Abrechnungsübersicht für den gewählten Monat",
        "invoices": "Rechnungen",
        "sms": "SMS-Benachrichtigungen",
        "letters": "Briefe",
        "count": "Anzahl",
        "basePrice": "Grundpreis",
        "surcharge": "Aufschlag",
        "total": "Summe",
        "grandTotal": "Gesamtbetrag",
        "perInvoice": "pro Rechnung",
        "perSms": "pro SMS",
        "perLetter": "pro Brief",
        "zaalaFeePerLetter": "medinvoice Gebühr pro Brief",
        "zaalaFee": "medinvoice Gebühr",
        "letterPriceNote": "Briefkosten variieren je nach Spezifikation (S/W, Farbe, duplex…) + €0,10 medinvoice Gebühr",
        "letterCostFormula": "Briefkosten + €0,10",
        "letterCostCol": "Kosten (Briefversand + Gebühr)",
        "tier": "Staffel",
        "noCharges": "Keine Aktivität in diesem Monat",
        "amount": "Betrag",
        "invoiceId": "Rechnungs-ID",
        "recipient": "Empfänger",
        "patient": "Patient",
        "sentDate": "gesendet",
        "paidDate": "bezahlt",
        "notSent": "nicht gesendet",
        "notPaid": "nicht bezahlt",
        "phone": "Telefon",
        "address": "Adresse",
        "letterRef": "Briefref.",
        "letterDetails": "Details",
        "color": "Farbe",
        "bw": "S/W",
        "duplex": "duplex",
        "simplex": "simplex",
        "cost": "Kosten",
        "type": "Typ",
        "kind_sms": "SMS",
        "kind_otp": "OTP",
        "smsDetail": "SMS-Details",
        "letterDetail": "Brief-Details",
        "timeSaved": "Gesparte Zeit diesen Monat",
        "timeSavedDesc": "Jede bezahlte Rechnung über Medinvoice spart ~5 Min. gegenüber manuellem Postversand: Drucken, Versenden, Nachverfolgen vs. Import, automatischer Versand, automatische Prüfung Zahlungseingangs. Lieferzeit: sofort vs. 2–5 Werktage.",
        "timeSavedMinutes": "{{min}} Min. gespart",
        "timeSavedHours": "{{h}}Std. {{min}}Min. gespart",
        "timeSavedBasis": "{{count}} bezahlte Rechnung × ~5 Min.",
        "co2Saved": "Papier & CO₂ gespart",
        "co2Desc": "Jede digitale Rechnung vermeidet das Drucken, Eincouvern und Versenden von ~2 Blatt Papier. 1 Baum ≈ 8.333 Blatt.",
        "co2Sheets": "{{n}} Blatt gespart",
        "co2Co2": "≈ {{g}}g CO₂",
        "co2Trees": "≈ {{pct}}% eines Baumes",
        "co2Basis": "{{count}} digitale Rechnung × ~2 Blatt",
        "doctor": "Arzt",
        "invoiceCount": "Rechnungen",
        "rate": "Satz",
        "billed": "abgerechnet",
        "byDoctor": "Aufschlüsselung nach Arzt",
        "previous": "zurück",
        "next": "weiter",
        "current": "aktuell",
        "clickForDetails": "auf eine Zeile klicken für Details",
        "rowPlan": "Plan",
        "rowDoctors": "Ärzte",
        "rowStaff": "Personal",
        "messages": "{{count}} Nachrichten",
        "rowSent": "{{count}} gesendet",
        "doctorsIncluded": "{{count}} Arzt · {{included}} inkl.",
        "doctorsIncludedPlural": "{{count}} Ärzte · {{included}} inkl.",
        "doctorsOverage": "{{total}} gesamt · {{included}} inkl. + {{extra}} × €39",
        "staffIncluded": "{{count}} Mitarbeiter · {{included}} inkl.",
        "staffIncludedPlural": "{{count}} Mitarbeiter · {{included}} inkl.",
        "staffOverage": "{{total}} gesamt · {{included}} inkl. + {{extra}} × €9,90",
        "invoicesUnlimited": "{{count}} Rechnungen · unbegrenzt",
        "invoicesAllowance": "{{count}} genutzt / {{total}} inkl. ({{perDoctor}}/Arzt)",
        "subtotal": "Zwischensumme",
        "discount": "Rabatt (netto)",
        "discountWithPercentage": "Rabatt ({{pct}} %, netto)",
        "netTotal": "Nettobetrag",
        "vat19": "MwSt. (19%)",
        "totalInclVat": "Gesamt inkl. MwSt.",
        "addOns": "Zusatzleistungen",
        "addOnCancelsOn": "Endet am {{date}}",
        "cancel": "Kündigen",
        "undo": "Rückgängig",
        "paid": "BEZAHLT",
        "paidOn": "BEZAHLT · {{date}}",
        "unpaid": "AUSSTEHEND",
        "free": "INKLUSIVE",
        "popupPlans": "Pläne",
        "popupDoctors": "Ärzte",
        "close": "schließen",
        "updateIban": "SEPA-Lastschriftmandat aktualisieren",
        "updateIbanHint": "Geben Sie die neue IBAN für Ihr SEPA-Lastschriftmandat ein. Die nächste Einziehung wird als Erstlastschrift behandelt.",
        "ibanRequired": "IBAN ist erforderlich",
        "ibanSaveError": "IBAN konnte nicht aktualisiert werden. Bitte erneut versuchen.",
        "ibanSaved": "IBAN erfolgreich aktualisiert",
        "pvsSavingsLabel": "Kostenersparnis diesen Monat gegenüber einer PVS-Abrechnungsstelle:",
        "pvsConfigButton": "Einstellungen Berechnung",
        "pvsResetButton": "Auf 0 zurücksetzen",
        "pvsCommissionLabel": "Abrechnungsprovision in %",
        "pvsPerInvoiceLabel": "zusätzliche Kosten pro Rechnung in Euro (netto)",
        "pvsPerMonthLabel": "sonstige Kosten pro Monat in Euro (netto)",
        "pvsNotConfigured": "Noch nicht konfiguriert — nutzen Sie „Einstellungen Berechnung“, um Ihre Ersparnis zu berechnen.",
        "pvsSavingsNegativeSuffix": "teurer als PVS",
        "pvsSaved": "Einstellungen gespeichert",
        "pvsSaveError": "Einstellungen konnten nicht gespeichert werden. Bitte erneut versuchen.",
        "pvsCommissionRangeError": "Die Provision muss zwischen 0 und 100 % liegen",
        "pvsPerInvoiceRangeError": "Die Kosten pro Rechnung müssen zwischen 0 und 50 liegen",
        "pvsPerMonthRangeError": "Die Kosten pro Monat müssen zwischen 0 und 5000 liegen",
        "noDoctors": "Keine Ärzte gefunden",
        "never": "nie",
        "colStatus": "Status",
        "statusOpen": "offen",
        "statusSent": "gesendet",
        "statusPaid": "bezahlt",
        "statusOverdue": "überfällig",
        "statusWrittenOff": "abgeschrieben",
        "roleMedicalAssistant": "Medizinische Fachangestellte",
        "roleDoctor": "Arzt",
        "roleAdmin": "Admin",
        "roleAccounting": "Buchhaltung",
        "colName": "Name",
        "colRole": "Rolle",
        "colSpecialty": "Fachrichtung",
        "colLastLogin": "Letzter Login",
        "colBillingStatus": "Abrechnung",
        "roleStaff": "Personal",
        "billingStatusIncluded": "Im Plan enthalten",
        "billingStatusExtra": "Zusätzlich · berechnet",
        "billingStatusRemoved": "Entfernt am {{date}} · wird noch berechnet",
        "planCompBaseFee": "Grundgebühr / Monat",
        "planCompIncludedDoctors": "Enthaltene Ärzte",
        "planCompIncludedStaff": "Enthaltenes Personal",
        "planCompDoctorSingular": "Arzt / Ärztin inkl.",
        "planCompDoctorPlural": "Ärzte inkl.",
        "planCompStaffIncluded": "Personal inkl.",
        "planCompExtraDoctor": "Zusätzlicher Arzt",
        "planCompExtraStaff": "Zusätzliches Personal",
        "planCompInvoicesPerDoctor": "Rechnungen / Praxis / Monat",
        "planCompOverageRate": "Je extra Rechnung",
        "planUnlimited": "unbegrenzt",
        "planIncluded": "inklusive",
        "planBilled": "abgerechnet",
        "planCustom": "individuell",
        "extraFeatures": "Zusatzfunktionen (je nach Plan separat berechnet)",
        "addonTagging": "Tags & Patientengruppen",
        "addonGoaChecker": "GOÄ-Checker",
        "addOnAdd": "Hinzufügen · +€{{price}}/Monat",
        "addOnAdded": "Hinzugefügt",
        "changePlan": "Plan ändern",
        "changePlanHint": "Wählen Sie den gewünschten Plan. Unser Team wird sich zur Bestätigung bei Ihnen melden.",
        "changePlanSubmit": "Änderung anfragen",
        "changePlanDone": "Ihre Anfrage haben wir erhalten. Wir melden uns in Kürze zur Bestätigung.",
        "cancelSubscription": "Abonnement kündigen",
        "cancelNotice": "Ihr Abonnement bleibt bis zum Ende des aktuellen Abrechnungsmonats aktiv. Danach wird Ihr Konto deaktiviert. Unser Team bearbeitet Ihre Anfrage und bestätigt diese per E-Mail.",
        "cancelConfirm": "Ja, kündigen",
        "cancelDone": "Ihre Kündigungsanfrage wurde erhalten. Wir bestätigen per E-Mail.",
        "changePlanNote": "Der neue Plan gilt ab dem 1. des nächsten Monats.",
        "pendingPlan": "{{plan}} ab {{date}}",
        "cancelPlanChangeTitle": "Planwechsel stornieren",
        "cancelPlanChangeMsg": "Der Wechsel zu {{plan}} zum {{date}} wird storniert. Sie bleiben auf Ihrem aktuellen Plan.",
        "cancelPlanChangeConfirm": "Wechsel stornieren",
        "confirmPlan": "bestätigen",
        "currentPlan": "(aktuell)",
        "billingEyebrow": "ABRECHNUNG",
        "pageTitle": "Gebühren",
        "pageLead": "Ihre monatliche Rechnung und Abonnementübersicht",
        "invoiceHistory": "Rechnungsverlauf",
        "downloadPdf": "PDF herunterladen",
        "periodLabel": "ZEITRAUM",
        "dueOn": "FÄLLIG {{date}}",
        "netShort": "netto",
        "vatShort": "MwSt. (19%)",
        "billedOn": "abgerechnet {{date}}",
        "sepaOnFile": "SEPA hinterlegt · {{iban}}",
        "subMetaEach": "€{{base}} Grundgebühr + Nutzung · Abrechnung jeweils am 1. · {{doctors}} Ärzte, {{staff}} Mitarbeiter",
        "managePlan": "Plan verwalten",
        "updatePaymentMethod": "Zahlungsmethode aktualisieren",
        "thisMonth": "Dieser Monat",
        "overageHint": "Klicken Sie auf eine Überschreitungszeile für Details",
        "planLineSub": "{{plan}} · {{doctors}} Arzt + {{staff}} Mitarbeiter inklusive",
        "rowExtraDoctors": "Zusätzliche Ärzte",
        "doctorsOverageRate": "{{count}} Ärzte über Plan · je €39",
        "removedButBilled": "davon {{names}} — diesen Monat entfernt, wird noch berechnet",
        "doctorsIncludedShort": "{{count}} Ärzte · {{included}} inklusive",
        "invoiceOverageDetail": "{{used}} von {{total}} inklusive · 0,5 % pro Überschreitung",
        "lettersSub": "{{count}} gesendet · inkl. MwSt.",
        "smsOtp": "SMS & OTP",
        "smsSub": "{{count}} gesendet · je €0,09 · inkl. MwSt.",
        "withinPlan": "Im Plan — {{count}} Positionen",
        "withinPlanSub": "Zusätzliches Personal · Bank-Feed · alles inklusive",
        "whyBillHigher": "Warum Ihre Rechnung ↑ €{{amount}} höher ist als {{month}}",
        "whyBillLower": "Warum Ihre Rechnung ↓ €{{amount}} niedriger ist als {{month}}",
        "topContributors": "Hauptursachen",
        "comparePlansHint": "U drücken zum Planvergleich",
        "whyInvoiceOverageDoctor": "+{{count}} Rechnungsüberschreitungen bei {{name}}",
        "whyInvoiceOverageDetail": "{{used}} vs. {{allowance}} inklusive",
        "whyExtraDoctors": "+{{count}} zusätzliche Ärzte",
        "whyLetters": "{{count}} Briefe",
        "whyLettersLess": "mehr digitale Zustellung",
        "whySms": "{{count}} SMS vs. Vormonat",
        "today": "Heute",
        "downloadInvoice": "Rechnung herunterladen",
        "viewOnStripe": "In Stripe ansehen",
        "receiptEmailed": "Ihre monatliche Rechnung als PDF wird nach der Abbuchung per E-Mail an die Praxis gesendet.",
        "receiptAfterBilling": "Nach der SEPA-Abbuchung erhalten Sie zusätzlich eine PDF per E-Mail.",
        "downloading": "Wird heruntergeladen…",
        "downloadFailed": "Rechnung konnte nicht heruntergeladen werden",
        "totalEyebrow": "{{period}} · RECHNUNG BEREIT",
        "totalPaidEyebrow": "{{period}} · BEZAHLT {{date}}",
        "invoiceReady": "RECHNUNG BEREIT",
        "vsLastMonth": "vs",
        "manageSubscription": "Abonnement verwalten",
        "invoiceOverage": "Rechnungs-Überlimit",
        "invoiceOverageSub": "Arzt-Aufschlag über Kontingent",
        "noPaymentMethod": "Keine Zahlungsmethode hinterlegt",
        "subMeta": "€{{base}} Basis + Nutzung · Abrechnung am 1. · {{doctors}} Ärzte, {{staff}} Mitarbeiter",
        "whyHigherTitle": "Warum höher als {{month}}",
        "whyLowerTitle": "Warum niedriger als {{month}}",
        "ecoInvoices": "{{count}} Rechnungen",
        "ecoTime": "~{{time}} geschätzt gespart",
        "ecoPaper": "{{sheets}} Blätter · {{co2}} kg CO₂ vermieden",
        "methodology": "Methodik",
        "methodologyTitle": "Schätzmethodik",
        "methodologyBody": "Zeitersparnis: ~5 Min. pro digitaler Rechnung vs. Postweg. Papier: ~2 Blätter pro Rechnung. CO₂: ~10 g pro Blatt vermieden. Schätzwerte, nicht geprüft."
    },
    "stripe": {
        "billingTitle": "Abonnement & Zahlung",
        "sepaTitle": "Zahlungsmethode",
        "optional": "Optional",
        "sepaHint": "Fügen Sie Ihr SEPA-Bankkonto hinzu, um Ihr Abonnement nach der Testphase automatisch fortzusetzen.",
        "ibanLabel": "IBAN",
        "confirmSepa": "Zahlungsmethode speichern",
        "confirming": "Speichern…",
        "sepaConfirmed": "Zahlungsmethode erfolgreich gespeichert",
        "confirmError": "Zahlungsmethode konnte nicht bestätigt werden. Bitte erneut versuchen.",
        "mandateText": "Durch die Angabe Ihrer IBAN und die Bestätigung dieses Mandats ermächtigen Sie Zaala GmbH, Ihrem Konto Beträge gemäß den erteilten Anweisungen zu belasten. Sie haben Anspruch auf eine Erstattung durch Ihre Bank gemäß den Bedingungen Ihrer Bankvereinbarung.",
        "addPaymentMethod": "Zahlungsmethode hinzufügen",
        "updatePaymentMethod": "Aktualisieren",
        "sepaOnFile": "SEPA-Lastschrift",
        "notConfigured": "Zahlung nicht konfiguriert",
        "trialEnds": "Testphase endet {{date}}",
        "pastDueWarning": "Zahlung überfällig – bitte Zahlungsmethode aktualisieren",
        "status_trialing": "Testphase",
        "status_active": "Aktiv",
        "status_past_due": "Überfällig",
        "status_canceled": "Gekündigt",
        "status_incomplete": "Unvollständig"
    },
    "verifyEmail": {
        "verifying": "E-Mail-Adresse wird verifiziert…",
        "successTitle": "E-Mail bestätigt!",
        "successText": "Ihre E-Mail-Adresse wurde bestätigt. Sie können sich jetzt anmelden.",
        "errorTitle": "Verifizierung fehlgeschlagen",
        "errorText": "Der Link ist ungültig oder wurde bereits verwendet. Bitte wenden Sie sich an den Support."
    },
    "briefing": {
        "howItWorks": "So funktioniert es",
        "uploadInvoices": "Rechnungen hochladen",
        "moreOptions": "Weitere Optionen",
        "hideActivity": "Aktivitat ausblenden",
        "showActivity": "Aktivitat anzeigen",
        "hideBank": "Bank ausblenden",
        "showBank": "Bank anzeigen",
        "weekShort": "KW {{n}}",
        "todayClear": "Alles erledigt. Gonnen Sie sich einen Kaffee.",
        "outstanding": "Offene Posten",
        "thisMonth": "Diesen Monat",
        "trend12w": "12-Wochen-Trend",
        "rowMonthSent": "Verschickt",
        "rowMonthPaid": "Bezahlt",
        "rowMonthNewOverdue": "Neu uberfällig",
        "rowPlanQuota": "Plan-Kontingent",
        "deltaPctVsPrev12w": "{{pct}}% bezahlt vs. vorh. 12 W.",
        "stackUnsent": "Nicht verschickt",
        "stackOverdue": "Uberfällig",
        "stackAwaiting": "Ausstehende Zahlung",
        "feedBank": "Bank",
        "feedActivity": "Aktivitat",
        "syncedAgo": "synchronisiert {{time}}",
        "last30days": "Letzte 30 Tage",
        "lastNDays": "Letzte {{n}} Tage",
        "bankMatched": "Abgeglichen mit Rechnung {{id}}",
        "bankSuggested": "Vorschlag: Rechnung {{id}}",
        "bankNoMatch": "Keine Ubereinstimmung - moglicherweise Duplikat oder Ruckbuchung",
        "bankExpense": "Ausgabe - automatisch kategorisiert",
        "bankBtnMatch": "Abgleichen",
        "bankBtnFind": "Rechnung suchen",
        "bankBtnDone": "Erledigt",
        "bankBtnFiled": "Abgelegt",
        "actionCtaSendNext": "M{{next}} senden",
        "actionCtaSendPortal": "Portal-Link senden",
        "actionCtaOpenThread": "Thread offnen",
        "actionTitleM3": "Letzte Mahnung bereit",
        "actionTitleM2": "Zweite Mahnung fallig",
        "actionTitleM1": "Erste Mahnung fallig",
        "actionTitleLegal": "Rechtliche Eskalation ausstehend",
        "actionTitleUnsent": "Rechnungen warten auf Versand",
        "actionTitleQuestion": "Patient hat eine Frage gestellt",
        "actionMetaDaysOverdue": "{{days}} Tage uberfällig",
        "actionMetaCreatedAgo": "vor {{days}} Tagen erstellt",
        "actionMetaDaysAgo": "vor {{days}} Tagen",
        "actionContextM3": "Briefkosten ca. 1,84 EUR - M4 eskaliert zu rechtlichen Schritten.",
        "actionContextM12": "Portal bereits gesendet - erneut per E-Mail oder Post senden.",
        "actionContextUnsentSelf": "Patient ist Rechnungsempfänger - Portal-Link ist am schnellsten.",
        "actionContextUnsentOther": "Portal-Link oder Post senden.",
        "bankBtnIgnore": "Als irrelevant markieren",
        "bankBtnUnmatch": "Zuordnung aufheben",
        "bankBtnRestore": "Wiederherstellen",
        "bankBtnOut": "Ausgehend",
        "bankNoTransactions": "Keine aktuellen Transaktionen.",
        "bankUnknown": "Unbekannter Absender",
        "bankMatched2": "Einer Rechnung zugeordnet",
        "timeJustNow": "gerade eben",
        "timeMinAgo": "vor {{n}} Min.",
        "timeHourAgo": "vor {{n}} Std.",
        "timeDayAgo": "vor {{n}} T.",
        "timeM": "Min",
        "timeH": "Std",
        "timeD": "T",
        "timeW": "W",
        "timeMo": "Mo",
        "actPaid": "hat bezahlt",
        "actInvoice": "Rechnung",
        "actEscalatedTo": "eskaliert zu",
        "actBankMatched": "Banktransaktion abgeglichen mit Rechnung",
        "actAskedQuestion": "hat eine Frage gestellt",
        "actViewedInvoice": "hat Rechnung aufgerufen",
        "actReminderSend": "Erinnerung senden",
        "actDOld": "T alt",
        "actPortalRegistered": "hat sich im Portal registriert",
        "actSmsVerified": "hat SMS-Verifizierung genutzt",
        "actQuestionnaire": "hat den Fragebogen ausgefullt",
        "actBilling": "Abrechnung belastet:",
        "recipient": "Empfanger",
        "invoice": "Rechnung",
        "invoices": "Rechnungen",
        "todayNeedYou": "brauchen Sie heute.",
        "todayQueue": "€ {{amount}} in der Warteschlange.",
        "todayNothing": "Nichts",
        "todayNothingNeeds": "braucht Sie heute.",
        "activityEmpty": "Keine aktuellen Aktivitaten.",
        "viewAllActivity": "Alle Aktivitaten anzeigen"
    },
    "trial": {
        "badge": "TEST",
        "daysLeft_one": "{{count}} Tag verbleibend",
        "daysLeft_other": "{{count}} Tage verbleibend",
        "daysLeft_zero": "Letzter Tag",
        "invoices": "Rechnungen",
        "sms": "SMS",
        "limitsTitle": "Testlimits",
        "of": "von",
        "endedTitle": "Ihre Testphase ist abgelaufen",
        "endedSubtitle": "Möchten Sie Medinvoice weiter nutzen?",
        "continueButton": "Ja, weiter nutzen",
        "declineButton": "Nein, Abo kündigen",
        "chargingInfo": "Bei Fortsetzung beginnt die Abrechnung am Ende des laufenden Monats. Der aktuelle Monat wird nur für die Tage nach dem Ablauf der Testphase berechnet – Sie zahlen also nur, was Sie wirklich genutzt haben.",
        "planLabel": "Ihr Tarif",
        "acceptSuccess": "Willkommen! Ihr Abonnement ist jetzt aktiv.",
        "declineSuccess": "Ihr Abonnement wurde gekündigt. Ihre Daten bleiben erhalten.",
        "declineConfirmTitle": "Abonnement kündigen?",
        "declineConfirmMsg": "Sind Sie sicher? Sie verlieren den Zugang zu Medinvoice. Ihre Daten bleiben gespeichert.",
        "invoiceLimitReached": "Rechnungslimit erreicht. Während der Testphase können Sie bis zu 20 Rechnungen erstellen.",
        "smsLimitReached": "SMS-Limit erreicht. Ihre Praxis hat alle 50 SMS-Verifizierungen der Testphase aufgebraucht.",
        "greetingMale": "Sehr geehrter",
        "greetingFemale": "Sehr geehrte",
        "greeting": "Sehr geehrte(r)",
        "expiredBody": "die Testphase Ihres gewählten Abonnement-Plans <strong>{{plan}}</strong> ist nun abgelaufen.",
        "expiredContinue": "Damit Sie medinvoice® ohne Unterbrechung weiter nutzen können, schließen Sie bitte die Bestellung über den untenstehenden Schaltknopf ab.",
        "expiredProration": "Für den laufenden Monat berechnen wir Ihnen selbstverständlich nur den anteiligen Monatspreis ab dem Beginn der kostenpflichtigen Nutzung.",
        "expiredFeedbackPrompt": "Sollten wir Sie nicht überzeugt haben, wären wir Ihnen über ein Feedback sehr dankbar.",
        "selectedPlan": "Gewählter Plan",
        "price": "Preis",
        "vatNote": "* zzgl. MwSt.",
        "perMonth": "/ Monat",
        "completeOrder": "Bestellung abschließen",
        "sendFeedback": "Feedback senden",
        "reject": "Ablehnen",
        "feedbackTitle": "Ihr Feedback",
        "feedbackDescription": "Was hätten wir besser machen können? Wir lesen jede Antwort.",
        "feedbackPlaceholder": "Ihr Feedback…",
        "feedbackSubmit": "Feedback absenden",
        "feedbackBack": "Zurück",
        "feedbackSentTitle": "Vielen Dank für Ihr Feedback.",
        "feedbackSentBody": "Sie können Ihre Bestellung noch abschließen oder sich unten abmelden.",
        "logOut": "Abmelden",
        "activatedLogin": "Jetzt anmelden →",
        "activatedTitle": "Herzlichen Glückwunsch!",
        "activatedBody": "Ihr Account wurde aktiviert. Ab jetzt können Sie den gebuchten Plan in vollem Umfang nutzen. Wir freuen uns auf die Zusammenarbeit mit Ihnen!",
        "activatedSignature": "Das Team von medinvoice®"
    },
    "inactivity": {
        "message": "Sie werden in {{count}} Sekunden aufgrund von Inaktivität abgemeldet.",
        "stayLoggedIn": "Angemeldet bleiben"
    },
    "csvImport": {
        "title": "Patienten aus CSV importieren",
        "dropLabel": "CSV-Datei hier ablegen",
        "dropSub": "oder Datei auswählen (.csv)",
        "browse": "Datei auswählen",
        "hint": "Unterstützte Spalten: Vorname, Nachname, Geburtsdatum, Geschlecht, Anrede, Titel, Straße, PLZ, Ort, Telefon, E-Mail",
        "parse": "Vorschau laden",
        "back": "Zurück",
        "cancel": "Abbrechen",
        "import_one": "{{count}} Patient importieren",
        "import_other": "{{count}} Patienten importieren",
        "importing": "Wird importiert…",
        "close": "Schließen",
        "rowsFound": "Zeilen gefunden",
        "rowsSelected": "ausgewählt",
        "toggleAll": "Alle aus-/abwählen",
        "colName": "Name",
        "colBornGender": "Geb. / Geschl.",
        "colAddress": "Adresse",
        "colContact": "Kontakt",
        "colLastName": "Nachname",
        "colFirstName": "Vorname",
        "colBirthDate": "Geburtsdatum",
        "colGender": "Geschlecht",
        "colTitle": "Titel",
        "colStreet": "Straße",
        "colPlz": "PLZ",
        "colCity": "Ort",
        "colTel": "Telefon",
        "colEmail": "E-Mail",
        "colIsRecipient": "Funktion",
        "minor": "Minderjährig",
        "stepLabelFile": "Datei",
        "stepLabelReview": "Überprüfen",
        "stepLabelDone": "Fertig",
        "previewIntro": "Überprüfen Sie die erkannten Patienten. Entfernen Sie den Haken, um einzelne Zeilen vom Import auszuschließen.",
        "isRecipientYes": "Empfänger + Patient",
        "isRecipientNo": "Nur Patient",
        "stepParsing": "CSV wird eingelesen…",
        "stepValidating": "Daten werden geprüft…",
        "stepCreating": "Patienten werden angelegt…",
        "stepFinalizing": "Wird abgeschlossen…",
        "doneTitle": "Import abgeschlossen",
        "doneCreated_one": "{{count}} Patient angelegt",
        "doneCreated_other": "{{count}} Patienten angelegt",
        "doneSkipped_one": "{{count}} übersprungen (Duplikat)",
        "doneSkipped_other": "{{count}} übersprungen (Duplikate)",
        "errorNotCsv": "Bitte nur .csv-Dateien hochladen.",
        "errorEmpty": "Die Datei enthält keine erkennbaren Zeilen.",
        "errorParse": "Fehler beim Lesen der Datei. Bitte Format prüfen.",
        "errorImport": "Fehler beim Importieren. Bitte erneut versuchen.",
        "errorNoColumns": "Keine der Spalten konnte erkannt werden. Bitte unten die erkannten Spalten prüfen.",
        "showColumns": "Erkannte Spalten anzeigen",
        "hideColumns": "Spalten ausblenden",
        "detectedCols": "Erkannte Spaltenköpfe",
        "colMappedAs": "Wird als «{{field}}» importiert",
        "colIgnored": "Nicht erkannt — wird ignoriert",
        "noColsMatched": "Keine Spalte konnte einem bekannten Feld zugeordnet werden. Bitte prüfen Sie die Spaltenköpfe Ihrer Datei (z. B. Vorname, Nachname, Geburtsdatum, E-Mail).",
        "skippedLabel": "Übersprungene Zeilen:",
        "skippedNoName": "(kein Name)",
        "skipReason_empty_name": "Kein Nachname",
        "skipReason_duplicate_db": "Bereits vorhanden",
        "skipReason_duplicate_csv": "Doppelt in CSV",
        "downloadTemplate": "Vorlage herunterladen",
        "doneRecipients_one": "{{count}} Empfänger angelegt",
        "doneRecipients_other": "{{count}} Empfänger angelegt",
        "warnNoRecipients": "Keine Empfänger wurden angelegt – E-Mail oder Telefon fehlt oder Spalten wurden nicht erkannt."
    },
    "registerWidgetDefaults": {
        "heading": "Jetzt als Patient registrieren",
        "message": "Scannen Sie den QR-Code mit Ihrem Smartphone oder tippen Sie unten – in wenigen Minuten erledigt."
    },
    "updateBanner": {
        "label": "Update",
        "text": "Eine neue Version von Medinvoice ist verfügbar.",
        "reload": "Neu laden"
    },
    "whatsNew": {
        "title": "Was ist neu",
        "button": "Was ist neu",
        "empty": "Noch nichts veröffentlicht."
    }
}
